import api from './../service/apiService'
import {
    CheckLQ,
    Pages,
    FutureNotification,
    Service,
    CartActions,
    DOFlow,
    MTNValidation,
    Save,
    BannerTypes,
    PAGEACTIVITY,
    HOAFlow,
} from './../constants/actionType';
import { apiUrl } from './../constants/apiUrl'
import { redirectTo } from './redirection'
import { errorAction } from './error'
import { logKafka, detailsInfo, updatePageLogs, logOtherInfo, updateisLogRequired, errCheck, getPgLoggerObj, catchJSException } from './../service/logService'
import { loaderActive } from './loder'
import { updateSCTags, updateSCcustomEvent, tempSCData } from './../service/dtmTag';
import {
    updateVzdlSCCustomEvent,
    tempVzdlSCData,
    vzdlErrorUpdate,
    updateVzdlObjectValues,
    addToCartVzdlSCEvent,
    getVZDLInit,
    updateLQZip,
    vzdlSystemfailure,
    loopQualVzTaglqs,
    passiveVzTagLqs,
} from './../service/vzdl';
import * as saveAction from './save';
//import * as resp from './../containers/addressQualification/sampleMTNValidation'
import { doCreditAssessment, setCartDirtyFlag } from './checkout';
import { doPrefetch, updateCheckoutBtnStatus } from './buildProduct';
import { getCartHeader, getCartData, getCartProducts, getCartDataDefault } from './../util/cartUtility';
import { InHomeUtils } from './../util/inhomeUtils';
import { logNRTime } from './../util/commonUtil';
import * as moveExpAction from './moveExp';
import { getCookieVisitIdAndVisitorIdNoParam } from '../service/apiService';
import OrderingBanners from "./../containers/banner/OrderingBanners.json";
import FlashOffersJson from './../containers/offers/FlashOffers.json';
import { clearCart } from './xpsEntry';
import * as modalAction from './modalWindow';
import { isBannerChecked } from './buildProduct';
import axios from 'axios';
import * as buildProductAction from './../action/buildProduct';
import { store } from "../../src/index"/**importing store for reducer values */


let checkAdrAPICount = 0;
let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
let isIONTAddr = false;

const defaultUnit = [{
    addressId: "N",
    baseAddressId: "N",
    unit: "I don't live in a unit"
},
{
    addressId: "",
    baseAddressId: "",
    unit: "I can't find my unit"
}];

const TOTAL_UNITS_CUTOFF = 10;

const defaultStreet = {
    value: {
        addressID: "",
        baseAddID: "",
        elkStreet: "",
        street: "I can't find my address"
    },
    displayValue: "I can't find my address"
};

export const setCookie = (cookies, data, props) => {
    try {
        let domain = "localhost";
        if (document.location.href.indexOf("localhost") > -1) {
            //domain="verizon.com";
            cookies.set('visit_id', data.visit_id, { path: '/', 'domain': domain });
            cookies.set('visitor_id', data.visitor_id, { path: '/', 'domain': domain });
        }
        props.dispatch({ type: "UPDATE_VISITID", value: { visitId: data.visit_id, visitorId: data.visitor_id } });
        props.location && props.dispatch({ type: "PAGE_VISITID", value: { prevPage: props.location, currentPage: props.location } });
    }
    catch (ex) {
        catchJSException('loopQual', props.appState.visitId, 'setCookie', ex);
    }
}

export const updateVisitId = (dispatch, value) => {
    dispatch({ type: "UPDATE_VISITID", value });
}

export const setReferralUrl = (dispatch, value) => {
    dispatch({ type: "SET_REFERRAL_URL", value });
}

export const setLoggerObj = (props, loggerObj) => {
    if (InHomeUtils.isNotNull(loggerObj)) {
        props.dispatch({ type: "UPDATE_LOGGEROBJ", value: { enableUserAction: loggerObj.enableUserAction, enableApiTiming: loggerObj.enableApiTiming, enablePageLoad: loggerObj.enablePageLoad } });
    }
}

export const updateIsVendorVisit = (dispatch, isVendorVisit) => {
    dispatch({ type: CheckLQ.updateIsVendorVisit, isVendorVisit });
}

export const updateAccessCode = (dispatch, isAccessCode) => {
    dispatch({ type: CheckLQ.updateAccessCode, isAccessCode });
}

export const updateStartdatetimestamp = (dispatch, startdatetimestamp) => {
    dispatch({ type: CheckLQ.updateStartdatetimestamp, startdatetimestamp });
}

export const setVendorCookie = async (cookies, data, props, GlobalSessionName) => {
    try {

        let domain = "localhost";
        if (document.location.href.indexOf("localhost") === -1) {
            domain = "verizon.com";
        }
        // cookies.set('visit_id', data.visit_id, { path: '/', 'domain': domain });
        // cookies.set('visitor_id', data.visitor_id, { path: '/', 'domain': domain });
        // props.dispatch({ type: "UPDATE_VISITID", value: { visitId: data.visit_id, visitorId: data.visitor_id } });
        // props.dispatch({ type: "PAGE_VISITID", value: { prevPage: props.location, currentPage: props.location } });
        // if (GlobalSessionName !== undefined) {
        //     cookies.set(GlobalSessionName, data.visitor_id, { path: '/', 'domain': domain });
        // }
        let url = '/inhome/generatevisitidforvendor';
        // url = 'https://localhost.verizon.com:8080/generatevisitidforvendor'; //localDev generatevisitidForVendor
        const { visit_id, visitor_id } = data;
        let request = {
            other_visit_id: visit_id,
            other_visitor_id: visitor_id && visitor_id || '',
            other_GSM_ID: GlobalSessionName && GlobalSessionName || ''
        }
        const response = await api(url, 'POST', JSON.stringify(request));
        if (response) {
            const { visit_id, visitor_id, expirationTime } = response.data;
            window.localStorage.setItem('visit_id', visit_id);
            window.localStorage.setItem('visitor_id', visitor_id);
            window.localStorage.setItem('expirationTime', expirationTime);
            window.sessionStorage.setItem('visit_id', visit_id);
            props.dispatch({ type: "UPDATE_VISITID", value: { visitId: visit_id, visitorId: visitor_id } });
            props.dispatch({ type: "PAGE_VISITID", value: { prevPage: props.location, currentPage: props.location } });
        }
        return;

    }
    catch (ex) {
        catchJSException('loopQual', props.appState.visitId, 'setVendorCookie', ex);
    }
}

export const callCheckPreLink = async () => {
    try {
        let url = apiUrl().checkPreLink;
        return new Promise((resolve, reject) => {
            api(url, 'GET')
                .then(response => {
                    if (response) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, "visitid", 'checkPreLink', "callCheckPrelinkAPISuccess", PAGEACTIVITY.UA));
                    }
                    resolve(response); // Resolve the promise with the response
                })
                .catch(error => {
                    catchJSException('LOOPQUAL', 'checkPreLink', error);
                    reject(error); // Reject the promise with the error
                });
        });
    } catch (ex) {
        catchJSException('LOOPQUAL', 'checkPreLink', ex);
    }
};

export const getMhToken = (vzt, cookieVisitId) => {
  try {
      let request = {
      visitProfilejson: {
      flow_subtype:'inhome',
      clientid:'MVOAPPMNH',
      flowType:'nc',
      },
      mhToken :vzt ? vzt : ''
      }       
      let url = apiUrl().mnhOneClickQualification;
      return api(url, 'POST', JSON.stringify(request)).then(response => {
          if(response){
              logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, cookieVisitId,  'getMhToken', "callgetMhTokenSuccess", PAGEACTIVITY.UA));
          }
        });
      }catch (ex) {
    catchJSException('LOOPQUAL', 'getMhToken', ex);
  }
};


export const validateVendorToken = async (vtoken, props) => {
    try {
        let url = '/inhome/validatevendortoken';
        let request = {
            vtoken: vtoken
        }
        const response = await api(url, 'POST', JSON.stringify(request));
        if (response && response.data) {
            const { visitId, visitorId } = response.data;
            window.localStorage.setItem('visit_id', visitId);
            window.localStorage.setItem('visitor_id', visitorId);
            window.sessionStorage.setItem('visit_id', visitId);
            props.dispatch({ type: "UPDATE_VISITID", value: { visitId: visitId, visitorId: visitorId } });
            props.dispatch({ type: "PAGE_VISITID", value: { prevPage: props.location, currentPage: props.location } });
        }
        return response;

    }
    catch (ex) {
        catchJSException('loopQual', props.appState.visitId, 'setVendorCookie', ex);
    }
}

export const callIDmeGroupVerification = async (accessCode, visitorid, visitid, dispatch) => {
    try {
        let url = '/inhome/groupverification'
        // url = 'https://localhost.verizon.com:8080/groupverification' //localDev
        const response = await api(url, 'POST', JSON.stringify({ code: accessCode, visitorid: visitorid, visitid: visitid }))
        //console.log(response);
        // api(url,'POST',JSON.stringify({code: accessCode})).then(response => {
        console.log("IDME Response : " + response);
        // console.log("IDME Response : " + response.responseData);
        if (response) {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callIDmeGroupVerification', "response received", PAGEACTIVITY.UA));
            //  var idmeresponse = require('./IDmeResponse.json'); 
            try {
                // let jsonstr = JSON.stringify({ uuid: idmeresponse.attributes[0].value, group: idmeresponse.status[0].group,status:idmeresponse.transaction.results[0].verified });
                let verified = InHomeUtils.isNotNull(response.transaction) ? response.transaction : false;
                let SweetnerMessageMFRT = {
                    currentMsg: '',
                    isDisplay: true,
                    bgColor: '',
                    discountEligible: false
                };
                if (verified) {
                    SweetnerMessageMFRT.currentMsg = "You're eligible for this discount.  Now check if services are available at your address.";
                    SweetnerMessageMFRT.bgColor = 'success-bg';
                    SweetnerMessageMFRT.discountEligible = true;
                } else {
                    SweetnerMessageMFRT.currentMsg = "We are unable to verify your eligibility for this discount.  You can still check if services are available at your address.";
                    SweetnerMessageMFRT.discountEligible = false;
                }
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callIDmeGroupVerification', "response received | verified" + verified, PAGEACTIVITY.UA));
                SweetnerMsgMFRT(SweetnerMessageMFRT, dispatch);
                MFRTEligible(true, dispatch);

                //microservice call
                let jsonstr = JSON.stringify({ uuid: response.uuid, group: response.status, status: response.transaction, transactionId: accessCode });
                let MFRTNRes = {
                    vendorType: 'id.me',
                    flow: response.status[0].group,
                    status: verified,
                    transactionId: accessCode

                }
                let mfrtnurl = apiUrl().mfrtnFlow;
                console.log("mfrtnurl: " + mfrtnurl);
                api(mfrtnurl, 'POST', jsonstr).then(response => {
                    if (InHomeUtils.isNotNull(response)) {
                        dispatch({
                            type: 'MFRTN_SERVICE',
                            value: MFRTNRes
                        });
                        MFRTCompleted(true, dispatch);
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callIDmeGroupVerification', "response received | succ saved to DB", PAGEACTIVITY.UA));
                        updateCRMMRefreshMover(visitid, dispatch);
                    }
                })
                    .catch(error => {
                        MFRTCompleted(true, dispatch);
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callIDmeGroupVerification', "response received | fail saved to DB", PAGEACTIVITY.UA));
                        errorAction("ERROR", "LoopQual", error.message, "applogs", '', dispatch, false, "");
                        vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                    });
            }
            catch (ex) {
                MFRTCompleted(true, dispatch);
                catchJSException('loopQual', '', 'existingService', ex);
            }
            //  return response;
        }
        // MFRTCompleted(true, dispatch);                
        return response;
        //})
        //.catch(error => {
        //    errorAction("ERROR", "LoopQual-groupverification", error.message, "applogs", '', dispatch, false, "");
        //    vzdlErrorUpdate(error.code === undefined ? "" : error.code,error.message);
        //})    
    } catch (ex) {
        MFRTCompleted(true, dispatch);
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callIDmeGroupVerification', "response not received - ex occured", PAGEACTIVITY.UA));
        catchJSException('loopQual', '', 'IdmeGroupverification', ex);
    }
}

export const callMilvetGroupVerification = async (accessCode, visitorid, visitid, dispatch, milvetnotVerified) => {
    {
        try {
            if (milvetnotVerified) {
                try {
                    let jsonstr = JSON.stringify({ uuid: "", group: "MILITARY", status: false, transactionId: accessCode });
                    let mfrtnurl = apiUrl().mfrtnFlow;
                    let MFRTNRes = {
                        vendorType: 'milvet',
                        status: false,
                        transactionId: accessCode
                    }
                    console.log("mfrtnurl: " + mfrtnurl);
                    api(mfrtnurl, 'POST', jsonstr).then(response => {
                        if (InHomeUtils.isNotNull(response)) {
                            dispatch({
                                type: 'MFRTN_SERVICE',
                                value: MFRTNRes
                            });
                            MFRTCompleted(true, dispatch);
                        }
                    })
                        .catch(error => {
                            MFRTCompleted(true, dispatch);
                            errorAction("ERROR", "LoopQual", error.message, "applogs", '', dispatch, false, "");
                            vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                        });
                }
                catch (ex) {
                    MFRTCompleted(true, dispatch);
                    catchJSException('loopQual', '', 'MilvetGroupVerification', ex);
                }
            }
            else {
                let url = '/inhome/milvetgroupverification'
                const response = await api(url, 'POST', JSON.stringify({ transactionId: accessCode, visitorid: visitorid, visitid: visitid }))
                if (InHomeUtils.isNotEmpty(response)) {
                    console.log("inside response");
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callMilvetGroupVerification', "response received", PAGEACTIVITY.UA));
                    //  var idmeresponse = require('./IDmeResponse.json'); 
                    let verified = InHomeUtils.isNotEmpty(response.memberId) && !milvetnotVerified ? true : false;
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callMilvetGroupVerification', "response received | verified" + verified, PAGEACTIVITY.UA));
                    let SweetnerMessageMFRT = {
                        currentMsg: '',
                        isDisplay: true,
                        bgColor: '',
                        discountEligible: false
                    };
                    if (verified) {
                        SweetnerMessageMFRT.currentMsg = "You're eligible for this discount.  Now check if services are available at your address.";
                        SweetnerMessageMFRT.bgColor = 'success-bg';
                        SweetnerMessageMFRT.discountEligible = true;
                    } else {
                        SweetnerMessageMFRT.currentMsg = "We are unable to verify your eligibility for this discount.  You can still check if services are available at your address.";
                        SweetnerMessageMFRT.discountEligible = false;
                    }
                    SweetnerMsgMFRT(SweetnerMessageMFRT, dispatch);
                    MFRTEligible(true, dispatch);
                    try {
                        // let jsonstr = JSON.stringify({uuid:"",group:"",status:""}); 
                        let memberid = InHomeUtils.isNotEmpty(response.memberId) ? response.memberId : "";
                        let jsonstr = JSON.stringify({ uuid: memberid, group: "MILITARY", status: verified, transactionId: accessCode });
                        // let jsonstr = JSON.stringify({ uuid: response.attributes[0].value, group: response.status[0].group,status:response.transaction.results[0].verified });                
                        let mfrtnurl = apiUrl().mfrtnFlow;
                        let MFRTNRes = {
                            vendorType: 'milvet',
                            status: verified,
                            transactionId: accessCode
                        }
                        console.log("mfrtnurl: " + mfrtnurl);
                        api(mfrtnurl, 'POST', jsonstr).then(response => {
                            if (InHomeUtils.isNotNull(response)) {
                                dispatch({
                                    type: 'MFRTN_SERVICE',
                                    value: MFRTNRes
                                });
                                MFRTCompleted(true, dispatch);
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callMilvetGroupVerification', "response received | succ saved to DB", PAGEACTIVITY.UA));
                            }
                        })
                            .catch(error => {
                                MFRTCompleted(true, dispatch);
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callMilvetGroupVerification', "response received | fail saved to DB", PAGEACTIVITY.UA));
                                errorAction("ERROR", "LoopQual", error.message, "applogs", '', dispatch, false, "");
                                vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                            });
                    }
                    catch (ex) {
                        MFRTCompleted(true, dispatch);
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callMilvetGroupVerification', "response not received - ex occured", PAGEACTIVITY.UA));
                        catchJSException('loopQual', '', 'existingService', ex);
                    }
                }
                //  MFRTCompleted(true, dispatch); 
                return response;
            }
            // MFRTCompleted(true, dispatch); 
            return;

        } catch (ex) {
            MFRTCompleted(true, dispatch);
            catchJSException('loopQual', '', 'MilvetGroupVerification', ex);
        }
    }
};

export const clearLoopQualAddress = (dispatch, value) => {
    dispatch({
        type: 'CLEARLOOPQUALINPUT',
        value: value
    });
}

export const bussinessLQRedirect = (lqState, dispatch, GUID, visitId, saveState) => {
    try {
        modalAction.closeModalWindow("BUSSINESSREDIRECT", dispatch);
        loaderActive({ isLoaderActive: true, isLoaderText: "we're looking it up now.", isLoaderImg: "loader" }, dispatch);
        const accessTokenUrl = apiUrl().accessToken;
        const fiosQualificationUrl = apiUrl().getFiosQualification;
        const address = lqState.selectedAdr ? lqState.selectedAdr : lqState.inputAddress;
        const payloadFios = {
            "QueryType": "doloop",
            "zipCode": address?.zip,
            "city": address?.muni,
            "state": address?.state,
            "unit": (lqState.selectedUnit?.addressId && lqState.selectedUnit?.addressId !== 'N') ? lqState.selectedUnit?.unit : '',
            "streetAddress": address?.dispstr,
            "AddressID": (lqState.selectedUnit?.addressId && lqState.selectedUnit?.addressId !== 'N') ? lqState.selectedUnit?.addressId : (address?.ntasAddrID ? address?.ntasAddrID : (address?.addressID ? address?.addressID : "")),
            "BaseAddressID": address?.ntasAddrID ? address?.ntasAddrID : (address?.addressID ? address?.addressID : ""),
            "TelePhoneNumber": saveState.saveLqMtnInput ? saveState.saveLqMtnInput.replace(/\./g, '') : "",
            "EmailId": saveState?.saveLqEmailInput,
            "ClientID": "VCGFIOSINHOME",
            "GUID": GUID
        }

        const fiosHeader = {
            headers: {
                "Content-Type": "application/json",
                'Access-Control-Allow-Origin': '*'
            }
        }
        if(window.location.search?.includes('MN=Y') || window.sessionStorage.getItem('isMidnight') === 'true') {
            payloadFios['isMnFlow']='Y'
        }
        console.log('DEBUG: fiosQualificationUrl', fiosQualificationUrl);
        axios.post(fiosQualificationUrl, payloadFios, fiosHeader)
            .then((fiosData) => {
                loaderActive({ isLoaderActive: false }, dispatch);
                if (fiosData && fiosData.status === 200 && fiosData.data && fiosData.data.RedirectUrl) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'BusinessAddressOverlay', "fiosQualification response received", PAGEACTIVITY.UA));
                    window.location.href = `${fiosData.data.RedirectUrl}&cmp=int:int:ac:wln:consumer:consumerlq&utm_medium=int&utm_source=int&utm_campaign=consumer&utm_content=ac:wln:consumerlq`;
                    return;
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'BusinessAddressOverlay', "fiosQualification response not received - ex occured", PAGEACTIVITY.UA));
                }
            })
            .catch(error => {
                loaderActive({ isLoaderActive: false }, dispatch);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'BusinessAddressOverlay', "fiosQualification response not received - ex occured", PAGEACTIVITY.UA));
                catchJSException('fiosQualificationUrl', visitId, 'business address overlay', error);
                errorAction("ERROR", "fiosQualificationUrl", error.message, "applogs", '', dispatch, false, "");
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
            });
        // const payloadAccess = new URLSearchParams();
        // payloadAccess.append('client_id', apiUrl().getConsumerKey);
        // payloadAccess.append('client_secret', apiUrl().getConsumerSecret);
        // payloadAccess.append('grant_type', 'client_credentials');
        // axios.post(accessTokenUrl, payloadAccess).then((accessData) => {
        //         if (accessData && accessData.status === 200 && accessData.data && accessData.data.access_token) {
        //             logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'BusinessAddressOverlay', "accessToken response received", PAGEACTIVITY.UA));
        //             const fiosHeader = {
        //                 headers: {
        //                     "Authorization": `Bearer ${accessData.data.access_token}`,                            
        //                     "Content-Type": "application/json",                         
        //                 },
        //                 withCredentials: true,
        //                 crossDomain: true
        //             }
        //             axios.post(fiosQualificationUrl, payloadFios, fiosHeader)
        //                 .then((fiosData) => {
        //                     loaderActive({ isLoaderActive: false }, dispatch);
        //                     if (fiosData && fiosData.status === 200 && fiosData.data && fiosData.data.FiosQualified && fiosData.data.RedirectUrl) {
        //                         logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'BusinessAddressOverlay', "fiosQualification response received", PAGEACTIVITY.UA));
        //                         window.location.href = `${fiosData.data.RedirectUrl}&cmp=int:int:ac:wln:consumer:consumerlq&utm_medium=int&utm_source=int&utm_campaign=consumer&utm_content=ac:wln:consumerlq`;
        //                         return;
        //                     }
        //                     else{
        //                         logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'BusinessAddressOverlay', "fiosQualification response not received - ex occured", PAGEACTIVITY.UA));
        //                     }
        //                 })
        //                 .catch(error => {
        //                     loaderActive({ isLoaderActive: false }, dispatch);
        //                     logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'BusinessAddressOverlay', "fiosQualification response not received - ex occured", PAGEACTIVITY.UA));
        //                     catchJSException('fiosQualificationUrl', visitId, 'business address overlay', error);
        //                     errorAction("ERROR", "fiosQualificationUrl", error.message, "applogs", '', dispatch, false, "");
        //                     vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
        //                 });
        //         }
        //         else {
        //             loaderActive({ isLoaderActive: false }, dispatch);
        //             logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'BusinessAddressOverlay', "accessToken response not received - ex occured", PAGEACTIVITY.UA));
        //         }
        //     })
        //     .catch(error => {
        //         loaderActive({ isLoaderActive: false }, dispatch);
        //         logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'BusinessAddressOverlay', "accessToken response not received - ex occured", PAGEACTIVITY.UA));
        //         catchJSException('accessTokenUrl', visitId, 'business address overlay', error);
        //         errorAction("ERROR", "accessTokenUrl", error.message, "applogs", '', dispatch, false, "");
        //         vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
        //     });
    }
    catch (err) {
        loaderActive({ isLoaderActive: false }, dispatch);
        catchJSException('accessTokenUrl', visitId, 'business address overlay', err);
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'BusinessAddressOverlay', "response not received - ex occured", PAGEACTIVITY.UA));
    }
}

export const call15gRecom = (vtoken, dispatch, props) => {
    {
        try {
            const currentDate = new Date();
            const timestamp = currentDate.getTime();
            let logvisitId = "15G" + timestamp;
            let sendToCheckoutPage = '';
            if (vtoken) {
                try {
                    let jsonstr = { "vtoken": vtoken };//JSON.stringify({ "vtoken": vtoken });
                    let Url15g = apiUrl().vz15gFlow;
                    let accessTokenUrl = apiUrl().tokenGeneration;
                    let loggingEnablerUrl = apiUrl().loggingEnabler;
                    accessTokenUrl = accessTokenUrl.concat('?timestamp=' + JSON.stringify(Date.now()));
                    const { cookies } = props;
                    const TOKEN_HEADER = {
                        "Content-Type": "application/json",
                        Pragma: "no-cache",
                        "Cache-Control": "no-store",
                    };

                    console.log("Url15g: " + Url15g);
                    axios({
                        url: accessTokenUrl,
                        method: 'GET',
                        responseType: 'json',
                        withCredentials: true,
                        cache: false,
                        headers: TOKEN_HEADER,
                        timeout: 90000
                    }).then((accessData) => {
                        if (accessData && accessData.status === 200 && accessData.data && accessData.data.access_token) {
                            //   logKafka("INFO", "15G", "15G_token_success - " + accessData.data.access_token, getErrorLogUrl, "applogs", logvisitId);
                            //  updatePageLogs(props.appState, logvisitId, false);
                            // logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.FIFTENG, logvisitId, '15g_token_success', "response: " + accessData.data.access_token));
                            axios({
                                url: Url15g,
                                method: 'POST',
                                headers: {
                                    "Authorization": `Bearer ${accessData.data.access_token}`,
                                    "Content-Type": "application/json",
                                },
                                withCredentials: true,
                                crossDomain: true,
                                data: jsonstr,
                                cache: false,
                                timeout: 90000
                            })
                                .then(response => {
                                    loaderActive({ isLoaderActive: false }, dispatch);
                                    if (response && response.status === 200 && response.data) {
                                        console.log("visitId: " + response.data.data.visitdetails.visitId);
                                        console.log("visitorId: " + response.data.data.visitdetails.visitorId);
                                        if (InHomeUtils.isNotNull(response.data.data.visitdetails.sendToCheckoutPage)) {
                                            console.log("sendToCheckoutPage: " + response.data.data.visitdetails.sendToCheckoutPage);
                                            sendToCheckoutPage = response.data.data.visitdetails.sendToCheckoutPage
                                        }                                        
                                        console.log("before set cookies");
                                        window.localStorage.setItem('visit_id', response.data.data.visitdetails.visitId);
                                        window.localStorage.setItem('visitor_id', response.data.data.visitdetails.visitorId);
                                        window.sessionStorage.setItem('visit_id', response.data.data.visitdetails.visitId);
                                        window.localStorage.setItem('expirationTime', Date.now() + 86400000);
                                        let domain = "localhost";
                                        if (document.location.href.indexOf("localhost") === -1) {
                                            domain = "verizon.com";
                                        }
                                        cookies.set('visit_id', response.data.data.visitdetails.visitId, { path: '/', 'domain': domain });
                                        cookies.set('visitor_id', response.data.data.visitdetails.visitorId, { path: '/', 'domain': domain });
                                        console.log("after set cookies: visitid:" + response.data.data.visitdetails.visitId + " visitorid:" + response.data.data.visitdetails.visitorId);
                                        dispatch({ type: "UPDATE_VISITID", value: { visitId: response.data.data.visitdetails.visitId, visitorId: response.data.data.visitdetails.visitorId } });
                                        dispatch({ type: "PAGE_VISITID", value: { prevPage: props.location, currentPage: props.location } });

                                        api(loggingEnablerUrl, 'GET', '').then(configResponse => {
                                            if (errCheck(configResponse) && errCheck(configResponse.meta) && errCheck(configResponse.meta.code) && configResponse.meta.code === 200) {
                                                if (errCheck(configResponse.data)) {
                                                    setLoggerObj(props, configResponse.data);
                                                    updatePgLoggerObjConfig(props.appState.pgLoggerObj)
                                                    setTimeout(
                                                        function () {
                                                            updatePageLogs(props.appState, response.data.data.visitdetails.visitId, false);
                                                        }.bind(this), 500);
                                                    logKafka("INFO", "15G", "15G_validate15recomm_success - " + JSON.stringify(response.data), getErrorLogUrl, "applogs", response.data.data.visitdetails.visitId);
                                                    // logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.FIFTENG, response.data.data.visitdetails.visitId, '15g_validate15recomm_success', "response: " + response.data));                                                    
                                                }
                                            }
                                        })
                                        // dispatch({ type: 'UPDATE_VISITID', value: response.data.data.visitdetails });
                                        if (InHomeUtils.isNotNull(response.data.data.qualResponse)) {
                                            dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: response.data.data.qualResponse });
                                        }
                                        if (InHomeUtils.isNotNull(response.data.data.address)) {
                                            setParsedaddress(dispatch, response.data.data.address);
                                        }
                                        let visitId = response.data.data.visitdetails.visitId;
                                        fetchBanners(dispatch, visitId);
                                        let cartResult = false;
                                        let getCart = apiUrl().getCartAcc + '/' + response.data.data.visitdetails.visitId;
                                        console.log("before getcart call");
                                        axios({
                                            url: getCart,
                                            method: 'GET',
                                            headers: {
                                                "Authorization": `Bearer ${accessData.data.access_token}`,
                                                "Content-Type": "application/json",
                                            },
                                            withCredentials: true,
                                            crossDomain: true,
                                            cache: false,
                                            timeout: 90000
                                        })
                                            .then(response => {
                                                console.log("after getcart call");
                                                if (InHomeUtils.isNotNull(response) && response.status === 200 && InHomeUtils.isNotNull(response.data)) {
                                                    let resp = response.data;
                                                    console.log("15gupdatecart success", response);
                                                    let state = store.getState();
                                                    let appState = state.app;
                                                    let buildProductState = state.buildProduct;
                                                    let lqState = state.loopQual;
                                                    console.log("buildProductState", buildProductState);
                                                    // logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.FIFTENG, visitId, '15g_cart_success', "response: " + response.data));
                                                    logKafka("INFO", "15G", "15G_cart_success - " + JSON.stringify(response.data), getErrorLogUrl, "applogs", visitId);
                                                    //console.log("this.props.buildProductState",this.props.buildProductState);
                                                    //console.log("this.props.servicesQualified",lqState.servicesQualified);
                                                    if (InHomeUtils.isNotNull(resp.data.cartTierPricing)) {
                                                        let cartDataOnResume = getCartDataDefault();
                                                        cartDataOnResume = getCartData(resp.data.cartTierPricing.tierContent, visitId);
                                                        dispatch({
                                                            type: "UPDATE_CART",
                                                            value: {
                                                                cartResponse: resp.data.cartTierPricing,
                                                                cartHeader: getCartHeader(resp.data.cartTierPricing.tierContent, visitId),
                                                                cartData: getCartData(resp.data.cartTierPricing.tierContent, visitId),
                                                                cartOrderDetail: resp.data.orderDetail,
                                                                cartOrderProperty: InHomeUtils.isNull(resp.data.cartOrderProperty) ? null : resp.data.cartOrderProperty
                                                            }
                                                        });
                                                        cartResult = true;
                                                        if (cartResult) {
                                                            let cartProducts = getCartProducts(resp.data.cartTierPricing, visitId)
                                                            let cartResponse = InHomeUtils.isNull(resp.data.cartTierPricing) ? null : resp.data.cartTierPricing;
                                                            let contract = '';
                                                            if (InHomeUtils.isNotNull(resp.data.orderDetail) && InHomeUtils.isNotNull(resp.data.orderDetail.contract)) {
                                                                contract = resp.data.orderDetail.contract;
                                                            }
                                                            let cart = {
                                                                cartResponse: resp.data.cartTierPricing,
                                                                cartHeader: getCartHeader(resp.data.cartTierPricing.tierContent, visitId),
                                                                cartData: getCartData(resp.data.cartTierPricing.tierContent, visitId),
                                                                cartOrderDetail: resp.data.orderDetail,
                                                                cartOrderProperty: InHomeUtils.isNull(resp.data.cartOrderProperty) ? null : resp.data.cartOrderProperty
                                                            };
                                                            console.log("cart", cart);
                                                            console.log("cartProducts", cartProducts);
                                                            let selectedCoreServices = (InHomeUtils.isNotNull(cart) && InHomeUtils.isNotNull(cart.cartOrderDetail) && InHomeUtils.isNotNull(cart.cartOrderDetail.servicesOrdered)) ? cart.cartOrderDetail.servicesOrdered : '';
                                                            let isLocalTvInCart = (InHomeUtils.isNotNull(cartProducts.TvProduct) && InHomeUtils.isNotNull(cartProducts.TvProduct.tvProd[0]) && InHomeUtils.isNotEmpty(cartProducts.TvProduct.tvProd[0].prodTypeVal) && cartProducts.TvProduct.tvProd[0].prodTypeVal === "LOCLDGTL") ? true : false;
                                                            let addlInfo = {
                                                                zip: lqState.selectedState && lqState.selectedState.zip,
                                                                state: lqState.selectedState && lqState.selectedState.state,
                                                                tarCode: lqState.selectedState && lqState.selectedState.tarCode,
                                                                masterpackageview: buildProductState.masterpackageview,
                                                                selectedProductId: "",
                                                                couponFlowType: lqState.couponFlowType,
                                                                EquipmentState: buildProductState.loadedEquipments,
                                                                isFCPflow: true,
                                                                isAlaCarte: false,
                                                                flowType: appState.flowType,
                                                                servicesQualified: lqState.servicesQualified,
                                                                regionId: buildProductState.tv.fiosFiveSearchVhoParams.regionId,
                                                                ismnhFlow: lqState.mnh && lqState.mnh.mnhFlow,
                                                                lqQualdetails: lqState.lqQualdetails
                                                            };
                                                            let additionalInfo = { flowType: '15G', isUpsell: false, couponFlowType: '', orderType: "New Connect", vcpestbQty: '' };
                                                            buildProductAction.doPrefetch("SMART_CART", dispatch, visitId, addlInfo, contract, '', false, isLocalTvInCart, '', '', false, selectedCoreServices)
                                                            buildProductAction.PreselectCartProducts(cartProducts, dispatch, visitId, additionalInfo, null, buildProductState, lqState, cart, lqState.servicesQualified, false, false, resp)
                                                            buildProductAction.smartCartSelectedCoreService(selectedCoreServices, dispatch);
                                                            buildProductAction.fetchOfferInCart(visitId, cartProducts, dispatch, contract, true, response, "", "", "", "15G");
                                                            buildProductAction.getSpecialOffers(visitId, contract, dispatch, '', true, null, cartProducts, false, cartResponse);
                                                            buildProductAction.ResumeCollapsedView(dispatch);
                                                            // logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.FIFTENG, visitId, 'BindCartProducts15GFlow', 'BindCartSuccess'));
                                                            logKafka("INFO", "15G", "BindCartProducts15GFlow", getErrorLogUrl, "applogs", visitId);
                                                            if (InHomeUtils.isNotNull(sendToCheckoutPage) && (sendToCheckoutPage == 'y' || sendToCheckoutPage == 'Y')) {
                                                                redirectTo(Pages.Checkout, dispatch);
                                                            } else{
                                                                const isRetailFiosReferral = window.sessionStorage.getItem('fiosReferralFlow');
                                                                const page = isRetailFiosReferral ? `${Pages.BuildProduct}?fiosReferral=Y` : Pages.BuildProduct
                                                                redirectTo(page, dispatch);
                                                            }
                                                        }
                                                        else {
                                                            // logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.FIFTENG, visitId, 'BindCartProducts15GFlow', PAGEACTIVITY.MSG.apiResponseFailed));
                                                            logKafka("ERROR", "15G", "BindCartProducts15GFlow", getErrorLogUrl, "applogs", visitId);
                                                        }
                                                        // dispatch({
                                                        //     type: "PROFILE_CART",
                                                        //     value: {
                                                        //         cartResponse: response.data.cartTierPricing,
                                                        //         cartHeader: getCartHeader(response.data.cartTierPricing.tierContent, visitId),
                                                        //         cartData: cartDataOnResume,
                                                        //         cartOrderDetail: response.data.orderDetail,
                                                        //         cartOrderProperty: InHomeUtils.isNull(response.data.cartOrderProperty) ? null : response.data.cartOrderProperty
                                                        //     }
                                                        // })

                                                    }

                                                    //redirectTo(Pages.BuildProduct, dispatch);
                                                }
                                                else {
                                                    // logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.FIFTENG, visitId, '15g_cart_fail', "response: " + response));                                                
                                                    logKafka("ERROR", "15G", "15G_cart_fail - " + JSON.stringify(response), getErrorLogUrl, "applogs", visitId);
                                                }

                                                if (InHomeUtils.isNotNull(sendToCheckoutPage) && (sendToCheckoutPage == 'y' || sendToCheckoutPage == 'Y')){
                                                    redirectTo(Pages.Checkout, dispatch);
                                                } else{
                                                    const isRetailFiosReferral = window.sessionStorage.getItem('fiosReferralFlow');
                                                    const page = isRetailFiosReferral ? `${Pages.BuildProduct}?fiosReferral=Y` : Pages.BuildProduct
                                                    redirectTo(page, dispatch);
                                                }
                                                   
                                            })
                                            .catch(error => {
                                                //  logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.FIFTENG, visitId, '15g_cart_except', "response: " + error));                                                
                                                logKafka("ERROR", "15G", "15G_cart_except - " + JSON.stringify(error), getErrorLogUrl, "applogs", visitId);
                                            });
                                        //await buildProductAction.BindCartProductsDOFlow(this.props.app.visitId, dispatch, response.data.data, null, response.data.data.address.state, this.props.lqstate.servicesQualified);

                                    }
                                    else {
                                        // updatePageLogs(props.appState, logvisitId, false);
                                        //  logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.FIFTENG, logvisitId, '15g_validate15recomm_failure', "response: " + response));
                                        logKafka("ERROR", "15G", "15G_validate15recomm_failure - " + JSON.stringify(response), getErrorLogUrl, "applogs", logvisitId);
                                        if (InHomeUtils.isNotNull(sendToCheckoutPage) && (sendToCheckoutPage == 'y' || sendToCheckoutPage == 'Y')){
                                            redirectTo(Pages.Checkout, dispatch);
                                        } else{
                                            const isRetailFiosReferral = window.sessionStorage.getItem('fiosReferralFlow');
                                            const page = isRetailFiosReferral ? `${Pages.BuildProduct}?fiosReferral=Y` : Pages.BuildProduct
                                            redirectTo(page, dispatch);
                                        }
                                       
                                    }
                                })
                                .catch(error => {
                                    // updatePageLogs(props.appState, logvisitId, false);
                                    // logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.FIFTENG, logvisitId, '15g_validate15recomm_except', "response: " + error));
                                    logKafka("ERROR", "15G", "15G_validate15recomm_except - " + JSON.stringify(error), getErrorLogUrl, "applogs", logvisitId);
                                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                                    errorAction("ERROR", "LoopQual", error.message, "applogs", '', dispatch, false, "");
                                    vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                                });
                        }
                        else {
                            cookies.set('visit_id', logvisitId, { path: '/', 'domain': domain });
                            logKafka("ERROR", "15G", "15G_token_failure - " + JSON.stringify(accessData), getErrorLogUrl, "applogs", logvisitId);
                        }
                    })
                        .catch(error => {
                            // updatePageLogs(props.appState, logvisitId, false);
                            loaderActive({ isLoaderActive: false }, dispatch);
                            // logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.FIFTENG, logvisitId, '15g_token_failure', "accessToken response not received - ex occured"));
                            cookies.set('visit_id', logvisitId, { path: '/', 'domain': domain });
                            logKafka("ERROR", "15G", "15G_token_failure - " + JSON.stringify(error), getErrorLogUrl, "applogs", logvisitId);
                            catchJSException('accessTokenUrl', '15gifts', error);
                            errorAction("ERROR", "accessTokenUrl", error.message, "applogs", '', dispatch, false, "");
                            vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                        });

                }
                catch (ex) {
                    catchJSException('loopQual', '', '15Gifts', ex);
                    cookies.set('visit_id', logvisitId, { path: '/', 'domain': domain });
                    logKafka("ERROR", "15G", "15G_except - " + JSON.stringify(ex), getErrorLogUrl, "applogs", logvisitId);
                }
            }

            return;

        } catch (ex) {
            const currentDate = new Date();
            const timestamp = currentDate.getTime();
            let logvisitId = "15G" + timestamp;
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            catchJSException('loopQual', '', '15Gifts', ex);
            logKafka("ERROR", "15G", "15G_except - " + JSON.stringify(ex), getErrorLogUrl, "applogs", logvisitId);
        }
    }
};

export const saveTwsCustomerDetails = async(response, visitId) => {
    try {
        const { attributes } = response?.data;
        let url = apiUrl().twsSiginInDetails;
        var reqObject = attributes.reduce(
            (obj, item) => Object.assign(obj, { [item.handle]: item?.value }), {});
        let request = {
            clientId: "vzcom",
            requestTrackingNumber: visitId,
            emailId: reqObject?.email,
            twsData: {
                firstName: reqObject?.fname,
                lastName: reqObject?.lname,
                email: reqObject?.email,
                uuid: reqObject?.uuid,
                zip: reqObject?.zip,
                group: response?.status,
                status: response?.transaction,
            }
        }
        api(url, 'POST', JSON.stringify(request)).then(resp => {
            console.log(resp)
            if (resp) {
                console.log(resp, "success")
            }
            else {
                console.log("failure")
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:saveTwsCustomerDetails,errorMessage:${error.message}`;
                logKafka("ERROR", "xpsEntry", errorMsg, getErrorLogUrl, "applogs", visitId);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'saveTwsCustomerDetails', errorMsg, PAGEACTIVITY.UA));
            });
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.LQ, visitId, 'saveTwsCustomerDetails', ex);
    }
};

export async function handleGroupVerificationNew(response, dispatch) {
    try {
        let SweetnerMessageMFRT = {
            currentMsg: '',
            isDisplay: true,
            bgColor: '',
            discountEligible: false
        };
        const verified = response?.transaction ? response?.transaction : false;
        if (verified) {
            SweetnerMessageMFRT.discountEligible = true;
            MFRTEligible(true, dispatch);
            const mfrtType = response?.status ? response?.status : false;
            updateMFRTType(dispatch, mfrtType);
        }
        SweetnerMsgMFRT(SweetnerMessageMFRT, dispatch);
    } catch (e) {
        console.error(e);
    }
}

export const callIDmeGroupVerificationNew = async (accessCode, visitorid, visitid, dispatch, lqState, appState, signIn) => {
    try {
        let SweetnerMessageMFRT = {
            currentMsg: '',
            isDisplay: true,
            bgColor: '',
            discountEligible: false
        };
        let dtmTransactionsMFRT = {
            TwsTransactionID: '',
            UNID: '',
            Status: '',
            Vendor: '',
            TWSsegment: '',
            TWSsubgroup: '',
            Startdatetimestamp: '',
            Enddatetimestamp: ''
        };

        let url = '/inhome/groupverificationnew'
        let ismvflow = InHomeUtils.isNotEmpty(appState.flowType) && appState.flowType == "MV" ? "Y" : "N";
        // url = 'https://localhost.verizon.com:8080/groupverificationnew' //localDev
        const response = await api(url, 'POST', JSON.stringify({ code: accessCode, mfrtType: lqState.mfrtType, ismvflow: ismvflow, visitorid: visitorid, visitid: visitid }))
        //console.log(response);
        // api(url,'POST',JSON.stringify({code: accessCode})).then(response => {
        console.log("IDME Response : " + response);
        // console.log("IDME Response : " + response.responseData);
        if (response) {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callIDmeGroupVerification', "response received", PAGEACTIVITY.UA));
            //  var idmeresponse = require('./IDmeResponse.json'); 
            try {
                // let jsonstr = JSON.stringify({ uuid: idmeresponse.attributes[0].value, group: idmeresponse.status[0].group,status:idmeresponse.transaction.results[0].verified });
                let verified = InHomeUtils.isNotNull(response.transaction) ? response.transaction : false;

                if (verified) {
                    // SweetnerMessageMFRT.currentMsg = "You're eligible for this discount.  Now check if services are available at your address.";
                    // SweetnerMessageMFRT.bgColor = 'success-bg';
                    SweetnerMessageMFRT.discountEligible = true;

                    MFRTEligible(true, dispatch);
                    // MFRTVerified(true, dispatch);
                } else {
                    //SweetnerMessageMFRT.currentMsg = "We are unable to recognize your discount eligibility and you will not be eligible for the Fios Home Internet Discount offer. You can continue to make changes to your order below."
                    SweetnerMessageMFRT.discountEligible = false;
                    // tempSCData.detailPageName = "tws disc ineligible| fios eligible";
                    // tempVzdlSCData.detail = "tws disc ineligible| fios eligible";    // ACT111-2184
                    tempSCData.detailPageName = "tws discount not eligible - fios";
                    tempVzdlSCData.detail = "tws discount not eligible - fios";
                    tempSCData.TwsTransactionID = accessCode;
                    tempVzdlSCData.TwsTransactionID = accessCode;
                    dtmTransactionsMFRT.TwsTransactionID = accessCode;
                    tempSCData.UNID = response.uuid;
                    tempVzdlSCData.UNID = response.uuid;
                    dtmTransactionsMFRT.UNID = response.uuid;
                    tempSCData.Status = response.transaction ? "Valid" : "inValid";
                    tempVzdlSCData.Status = response.transaction ? "Valid" : "inValid";
                    dtmTransactionsMFRT.Status = response.transaction ? "Valid" : "inValid";
                    tempSCData.Vendor = "ID.me";
                    tempVzdlSCData.Vendor = "ID.me";
                    dtmTransactionsMFRT.Vendor = "ID.me";
                    tempSCData.TWSsegment = response.status;
                    tempVzdlSCData.TWSsegment = response.status;
                    dtmTransactionsMFRT.TWSsegment = response.status;
                    tempSCData.TWSsubgroup = response.subgroup;
                    tempVzdlSCData.TWSsubgroup = response.subgroup;
                    dtmTransactionsMFRT.TWSsubgroup = response.subgroup;
                    tempSCData.Startdatetimestamp = lqState.startdatetimestamp;
                    tempVzdlSCData.Startdatetimestamp = lqState.startdatetimestamp;
                    dtmTransactionsMFRT.Startdatetimestamp = lqState.startdatetimestamp;
                    tempSCData.Enddatetimestamp = new Date().toUTCString;
                    tempVzdlSCData.Enddatetimestamp = new Date().toUTCString();
                    dtmTransactionsMFRT.Enddatetimestamp = tempSCData.Enddatetimestamp;
                    mfrtInitialLoad(false, dispatch);
                    updateSCcustomEvent("buildTwsInit", "pageViewUpdate", "detailPageName");
                    updateVzdlSCCustomEvent("buildTwsInit", "pageViewOmni", "detail");

                }
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callIDmeGroupVerification', "response received | verified" + verified, PAGEACTIVITY.UA));
                SweetnerMsgMFRT(SweetnerMessageMFRT, dispatch);

                //microservice call
                let memberid = InHomeUtils.isNotEmpty(response.uuid) ? response.uuid : "";
                let jsonstr = JSON.stringify({ uuid: memberid, group: response.status, status: response.transaction, transactionId: accessCode,reverify: signIn.response?.reverify });
                let MFRTNRes = {
                    vendorType: 'id.me',
                    flow: response.status[0].group,
                    status: verified,
                    transactionId: accessCode

                }
                let mfrtnurl = apiUrl().mfrtnFlow;
                console.log("mfrtnurl: " + mfrtnurl);
                api(mfrtnurl, 'POST', jsonstr).then(resp => {
                    if (InHomeUtils.isNotNull(resp)) {
                        dispatch({
                            type: 'MFRTN_SERVICE',
                            value: MFRTNRes
                        });
                        if(resp && resp.data != null){
                            resp.data == 'Y' ? dispatch({type: 'DISPLAY_STUDENT_REVERIFY_SUCCESS_VERBAIGE',value: 'SUCCESS'}) : dispatch({type: 'DISPLAY_STUDENT_REVERIFY_SUCCESS_VERBAIGE',value: 'FAILURE'}) 
                        }
                        if (verified && (signIn.response.reverify == undefined || signIn.response?.reverify == 'N')) {
                            updateCRMMRefresh(visitid, dispatch, memberid, 'Y', appState.flowType).then(result => {
                               // tempSCData.detailPageName = "tws disc eligible| fios eligible";
                               // tempVzdlSCData.detail = "tws disc eligible| fios eligible";   // ACT111-2184
                               tempSCData.detailPageName = "tws discount eligible - fcp fios"; 
                               tempVzdlSCData.detail = " tws discount eligible - fcp fios";  
                                tempSCData.TwsTransactionID = accessCode;
                                tempVzdlSCData.TwsTransactionID = accessCode;
                                dtmTransactionsMFRT.TwsTransactionID = accessCode;
                                tempSCData.UNID = response.uuid;
                                tempVzdlSCData.UNID = response.uuid;
                                dtmTransactionsMFRT.UNID = response.uuid;
                                tempSCData.Status = "Valid";
                                tempVzdlSCData.Status = "Valid";
                                dtmTransactionsMFRT.Status = "Valid";
                                tempSCData.Vendor = "ID.me";
                                tempVzdlSCData.Vendor = "ID.me";
                                dtmTransactionsMFRT.Vendor = "ID.me";
                                tempSCData.TWSsegment = response.status;
                                tempVzdlSCData.TWSsegment = response.status;
                                dtmTransactionsMFRT.TWSsegment = response.status;
                                tempSCData.TWSsubgroup = response.subgroup;
                                tempVzdlSCData.TWSsubgroup = response.subgroup;
                                dtmTransactionsMFRT.TWSsubgroup = response.subgroup;
                                dtmTransactionsMFRT.Startdatetimestamp = lqState.startdatetimestamp;
                                tempSCData.Startdatetimestamp = lqState.startdatetimestamp;
                                tempVzdlSCData.Startdatetimestamp = lqState.startdatetimestamp;
                                tempSCData.Enddatetimestamp = new Date().toUTCString();
                                tempVzdlSCData.Enddatetimestamp = new Date().toUTCString();
                                dtmTransactionsMFRT.Enddatetimestamp = tempSCData.Enddatetimestamp;
                                updateSCcustomEvent("buildTwsInit", "pageViewUpdate", "detailPageName");
                                updateVzdlSCCustomEvent("buildTwsInit", "pageViewOmni", "detail");
                                DtmTransactionsMFRT(dtmTransactionsMFRT, dispatch);
                                let ECMFRTSMARTCART = (lqState.runtimeKey && lqState.runtimeKey.ECMFRTSMARTCART && signIn.response.state && (lqState.runtimeKey.ECMFRTSMARTCART.toLowerCase().indexOf(signIn.response.state.toLowerCase()) > -1 || lqState.runtimeKey.ECMFRTSMARTCART == "*")) ? true : true;
                                if (appState.flowType === "AF" && (signIn.response.smartCartFound && !ECMFRTSMARTCART)) {
                                    window.location.href = Pages.RegistrationbridgeEC + "?isMFRT=y"
                                }
                                console.log("inside then updateCRMMRefresh");
                                loaderActive({ isLoaderActive: false }, dispatch);
                                MFRTCompleted(true, dispatch);
                                // MFRTVerified(true, dispatch);
                            })
                                .catch(error => {
                                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                                    // tempSCData.detailPageName = "tws disc ineligible| fios eligible";
                                    // tempVzdlSCData.detail = "tws disc ineligible| fios eligible";
                                    tempSCData.detailPageName = "tws discount not eligible - fios";
                                    tempVzdlSCData.detail = "tws discount not eligible - fios";
                                    tempSCData.TwsTransactionID = accessCode;
                                    tempVzdlSCData.TwsTransactionID = accessCode;
                                    dtmTransactionsMFRT.TwsTransactionID = accessCode;
                                    tempSCData.UNID = response.uuid;
                                    tempVzdlSCData.UNID = response.uuid;
                                    dtmTransactionsMFRT.UNID = response.uuid;
                                    tempSCData.Status = "inValid";
                                    tempVzdlSCData.Status = "inValid";
                                    dtmTransactionsMFRT.Status = "inValid";
                                    tempSCData.Vendor = "ID.me";
                                    tempVzdlSCData.Vendor = "ID.me";
                                    dtmTransactionsMFRT.Vendor = "ID.me";
                                    tempSCData.TWSsegment = response.status;
                                    tempVzdlSCData.TWSsegment = response.status;
                                    dtmTransactionsMFRT.TWSsegment = response.status;
                                    tempSCData.TWSsubgroup = response.subgroup;
                                    tempVzdlSCData.TWSsubgroup = response.subgroup;
                                    dtmTransactionsMFRT.TWSsubgroup = response.subgroup;
                                    tempSCData.Startdatetimestamp = lqState.startdatetimestamp;
                                    tempVzdlSCData.Startdatetimestamp = lqState.startdatetimestamp;
                                    dtmTransactionsMFRT.Startdatetimestamp = lqState.startdatetimestamp;
                                    tempSCData.Enddatetimestamp = new Date().toUTCString();
                                    tempVzdlSCData.Enddatetimestamp = new Date().toUTCString();
                                    dtmTransactionsMFRT.Enddatetimestamp = tempSCData.Enddatetimestamp;
                                    updateSCcustomEvent("buildTwsInit", "pageViewUpdate", "detailPageName");
                                    updateVzdlSCCustomEvent("buildTwsInit", "pageViewOmni", "detail");
                                    DtmTransactionsMFRT(dtmTransactionsMFRT, dispatch);
                                    MFRTCompleted(true, dispatch);
                                });
                        }
                        else {
                            DtmTransactionsMFRT(dtmTransactionsMFRT, dispatch);
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            if(signIn.response && signIn.response?.reverify == 'Y'){
                                MFRTCompleted(true, dispatch);
                            }
                            //  MFRTCompleted(true, dispatch);
                            //  MFRTVerified(false, dispatch);
                        }

                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callIDmeGroupVerification', "response received | succ saved to DB", PAGEACTIVITY.UA));
                    }
                })
                    .catch(error => {
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        MFRTCompleted(true, dispatch);
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callIDmeGroupVerification', "response received | fail saved to DB", PAGEACTIVITY.UA));
                        errorAction("ERROR", "LoopQual", error.message, "applogs", '', dispatch, false, "");
                        vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                    });
            }
            catch (ex) {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                catchJSException('loopQual', '', 'existingService', ex);
            }
            //  return response;
        }
        return response;

        // MFRTCompleted(true, dispatch);


    } catch (ex) {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        MFRTCompleted(true, dispatch);
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callIDmeGroupVerification', "response not received - ex occured", PAGEACTIVITY.UA));
        catchJSException('loopQual', '', 'IdmeGroupverification', ex);
    }
}
export const callMilvetGroupVerificationNew = async (accessCode, visitorid, visitid, dispatch, lqState, milvetnotVerified, appState, signIn) => {
    {
        try {
            let SweetnerMessageMFRT = {
                currentMsg: '',
                isDisplay: true,
                bgColor: '',
                discountEligible: false
            };
            let dtmTransactionsMFRT = {
                TwsTransactionID: '',
                UNID: '',
                Status: '',
                Vendor: '',
                TWSsegment: '',
                Startdatetimestamp: '',
                Enddatetimestamp: ''
            };
            if (milvetnotVerified) {
                try {
                    let jsonstr = JSON.stringify({ uuid: "", group: "MILITARY", status: false, transactionId: accessCode });
                    let mfrtnurl = apiUrl().mfrtnFlow;
                    let MFRTNRes = {
                        vendorType: 'milvet',
                        status: false,
                        transactionId: accessCode
                    }
                    console.log("mfrtnurl: " + mfrtnurl);
                    api(mfrtnurl, 'POST', jsonstr).then(response => {
                        if (InHomeUtils.isNotNull(response)) {
                            dispatch({
                                type: 'MFRTN_SERVICE',
                                value: MFRTNRes
                            });
                            // SweetnerMessageMFRT.currentMsg = "We are unable to recognize your discount eligibility and you will not be eligible for the Fios Home Internet Discount offer. You can continue to make changes to your order below.";
                            SweetnerMessageMFRT.discountEligible = false;
                            // tempSCData.detailPageName = "tws disc ineligible| fios eligible";
                            // tempVzdlSCData.detail = "tws disc ineligible| fios eligible";
                            tempSCData.detailPageName = "tws discount not eligible - fios";
                            tempVzdlSCData.detail = "tws discount not eligible - fios";
                            tempSCData.TwsTransactionID = accessCode;
                            tempVzdlSCData.TwsTransactionID = accessCode;
                            dtmTransactionsMFRT.TwsTransactionID = accessCode;
                            tempSCData.Status = "inValid";
                            tempVzdlSCData.Status = "inValid";
                            dtmTransactionsMFRT.Status = "inValid";
                            tempSCData.Vendor = "milvet";
                            tempVzdlSCData.Vendor = "milvet";
                            dtmTransactionsMFRT.Vendor = "milvet";
                            tempSCData.TWSsegment = "MILITARY";
                            tempVzdlSCData.TWSsegment = "MILITARY";
                            dtmTransactionsMFRT.TWSsegment = "MILITARY";
                            tempSCData.Startdatetimestamp = lqState.startdatetimestamp;
                            tempVzdlSCData.Startdatetimestamp = lqState.startdatetimestamp;
                            tempSCData.Enddatetimestamp = new Date().toUTCString();
                            tempVzdlSCData.Enddatetimestamp = new Date().toUTCString();
                            dtmTransactionsMFRT.Startdatetimestamp = lqState.startdatetimestamp;
                            dtmTransactionsMFRT.Enddatetimestamp = tempSCData.Enddatetimestamp;
                            updateSCcustomEvent("buildTwsInit", "pageViewUpdate", "detailPageName");
                            updateVzdlSCCustomEvent("buildTwsInit", "pageViewOmni", "detail");
                            SweetnerMsgMFRT(SweetnerMessageMFRT, dispatch);
                            DtmTransactionsMFRT(dtmTransactionsMFRT, dispatch);
                            mfrtInitialLoad(false, dispatch);
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            //  MFRTCompleted(true, dispatch);
                            //  MFRTVerified(false, dispatch);
                        }
                    })
                        .catch(error => {
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            MFRTCompleted(true, dispatch);
                            errorAction("ERROR", "LoopQual", error.message, "applogs", '', dispatch, false, "");
                            vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                        });
                }
                catch (ex) {
                    catchJSException('loopQual', '', 'MilvetGroupVerification', ex);
                }
            }
            else {
                let url = '/inhome/milvetgroupverification'
                const response = await api(url, 'POST', JSON.stringify({ transactionId: accessCode, visitorid: visitorid, visitid: visitid }))
                if (InHomeUtils.isNotEmpty(response)) {
                    console.log("inside response");
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callMilvetGroupVerification', "response received", PAGEACTIVITY.UA));
                    //  var idmeresponse = require('./IDmeResponse.json'); 
                    let verified = InHomeUtils.isNotEmpty(response.memberId) && !milvetnotVerified ? true : false;
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callMilvetGroupVerification', "response received | verified" + verified, PAGEACTIVITY.UA));

                    if (verified) {

                        //   SweetnerMessageMFRT.currentMsg = "You're eligible for this discount.  Now check if services are available at your address.";
                        //  SweetnerMessageMFRT.bgColor = 'success-bg';
                        SweetnerMessageMFRT.discountEligible = true;

                        MFRTEligible(true, dispatch);
                        // MFRTVerified(true, dispatch);
                    } else {
                        // SweetnerMessageMFRT.currentMsg = "We are unable to recognize your discount eligibility and you will not be eligible for the Fios Home Internet Discount offer. You can continue to make changes to your order below.";
                        SweetnerMessageMFRT.discountEligible = false;
                        // tempSCData.detailPageName = "tws disc ineligible| fios eligible";
                        // tempVzdlSCData.detail = "tws disc ineligible| fios eligible";    // ACT111-2184
                        tempSCData.detailPageName = "tws discount not eligible - fios";
                        tempVzdlSCData.detail = "tws discount not eligible - fios";
                        tempSCData.TwsTransactionID = accessCode;
                        tempVzdlSCData.TwsTransactionID = accessCode;
                        dtmTransactionsMFRT.TwsTransactionID = accessCode;
                        tempSCData.UNID = response.memberId;
                        tempVzdlSCData.UNID = response.memberId;
                        dtmTransactionsMFRT.UNID = response.uuid;
                        tempSCData.Status = response.verified ? "Valid" : "inValid";
                        tempVzdlSCData.Status = response.verified ? "Valid" : "inValid";
                        dtmTransactionsMFRT.Status = response.verified ? "Valid" : "inValid";
                        tempSCData.Vendor = "milvet";
                        tempVzdlSCData.Vendor = "milvet";
                        dtmTransactionsMFRT.Vendor = "milvet";
                        tempSCData.TWSsegment = "MILITARY";
                        tempVzdlSCData.TWSsegment = "MILITARY";
                        dtmTransactionsMFRT.TWSsegment = "MILITARY";
                        tempSCData.Startdatetimestamp = lqState.startdatetimestamp;
                        tempVzdlSCData.Startdatetimestamp = lqState.startdatetimestamp;
                        tempSCData.Enddatetimestamp = new Date().toUTCString();
                        dtmTransactionsMFRT.Startdatetimestamp = lqState.startdatetimestamp;
                        tempVzdlSCData.Enddatetimestamp = new Date().toUTCString();
                        dtmTransactionsMFRT.Enddatetimestamp = tempSCData.Enddatetimestamp;
                        mfrtInitialLoad(false, dispatch);
                        updateSCcustomEvent("buildTwsInit", "pageViewUpdate", "detailPageName");
                        updateVzdlSCCustomEvent("buildTwsInit", "pageViewOmni", "detail");
                    }
                    SweetnerMsgMFRT(SweetnerMessageMFRT, dispatch);
                    try {
                        // let jsonstr = JSON.stringify({uuid:"",group:"",status:""}); 
                        let memberid = InHomeUtils.isNotEmpty(response.memberId) ? response.memberId : "";
                        let jsonstr = JSON.stringify({ uuid: memberid, group: "MILITARY", status: verified, transactionId: accessCode });
                        // let jsonstr = JSON.stringify({ uuid: response.attributes[0].value, group: response.status[0].group,status:response.transaction.results[0].verified });                
                        let mfrtnurl = apiUrl().mfrtnFlow;
                        let MFRTNRes = {
                            vendorType: 'milvet',
                            status: verified,
                            transactionId: accessCode
                        }
                        console.log("mfrtnurl: " + mfrtnurl);
                        api(mfrtnurl, 'POST', jsonstr).then(resp => {
                            if (InHomeUtils.isNotNull(resp)) {
                                dispatch({
                                    type: 'MFRTN_SERVICE',
                                    value: MFRTNRes
                                });
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callMilvetGroupVerification', "response received | succ saved to DB", PAGEACTIVITY.UA));
                                if (verified && (signIn.response.reverify == undefined || signIn.response?.reverify == 'N')) {
                                    updateCRMMRefresh(visitid, dispatch, memberid, 'Y', appState.flowType).then(result => {
                                       // tempSCData.detailPageName = "tws disc eligible| fios eligible";
                                       // tempVzdlSCData.detail = "tws disc eligible| fios eligible";    // ACT111-2184
                                       tempSCData.detailPageName = "tws discount eligible - fcp fios"; 
                                       tempVzdlSCData.detail = " tws discount eligible - fcp fios";  
                                        tempSCData.TwsTransactionID = accessCode;
                                        tempVzdlSCData.TwsTransactionID = accessCode;
                                        dtmTransactionsMFRT.TwsTransactionID = accessCode;
                                        tempSCData.UNID = memberid;
                                        tempVzdlSCData.UNID = memberid;
                                        dtmTransactionsMFRT.UNID = memberid;
                                        tempSCData.Status = "Valid";
                                        tempVzdlSCData.Status = "Valid";
                                        dtmTransactionsMFRT.Status = "Valid";
                                        tempSCData.Vendor = "milvet";
                                        tempVzdlSCData.Vendor = "milvet";
                                        dtmTransactionsMFRT.Vendor = "milvet";
                                        tempSCData.TWSsegment = "MILITARY";
                                        tempVzdlSCData.TWSsegment = "MILITARY";
                                        dtmTransactionsMFRT.TWSsegment = "MILITARY";
                                        dtmTransactionsMFRT.Startdatetimestamp = lqState.startdatetimestamp;
                                        tempSCData.Startdatetimestamp = lqState.startdatetimestamp;
                                        tempVzdlSCData.Startdatetimestamp = lqState.startdatetimestamp;
                                        tempSCData.Enddatetimestamp = new Date().toUTCString();
                                        tempVzdlSCData.Enddatetimestamp = new Date().toUTCString();
                                        dtmTransactionsMFRT.Enddatetimestamp = tempSCData.Enddatetimestamp;
                                        updateSCcustomEvent("buildTwsInit", "pageViewUpdate", "detailPageName");
                                        updateVzdlSCCustomEvent("buildTwsInit", "pageViewOmni", "detail");
                                        DtmTransactionsMFRT(dtmTransactionsMFRT, dispatch);
                                        let ECMFRTSMARTCART = (lqState.runtimeKey && lqState.runtimeKey.ECMFRTSMARTCART && signIn.response.state && (lqState.runtimeKey.ECMFRTSMARTCART.toLowerCase().indexOf(signIn.response.state.toLowerCase()) > -1 || lqState.runtimeKey.ECMFRTSMARTCART == "*")) ? true : true;
                                        if (appState.flowType === "AF" && (signIn.response.smartCartFound && !ECMFRTSMARTCART)) {
                                            window.location.href = Pages.RegistrationbridgeEC + "?isMFRT=y"

                                        }
                                        console.log("inside then updateCRMMRefresh");
                                        loaderActive({ isLoaderActive: false }, dispatch);
                                        MFRTCompleted(true, dispatch);
                                        // MFRTVerified(true, dispatch);
                                    }).catch(error => {
                                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                                        // tempSCData.detailPageName = "tws disc ineligible| fios eligible";
                                        // tempVzdlSCData.detail = "tws disc ineligible| fios eligible";
                                        tempSCData.detailPageName = "tws discount not eligible - fios";
                                        tempVzdlSCData.detail = "tws discount not eligible - fios";
                                        tempSCData.TwsTransactionID = accessCode;
                                        tempVzdlSCData.TwsTransactionID = accessCode;
                                        dtmTransactionsMFRT.TwsTransactionID = accessCode;
                                        tempSCData.UNID = memberid;
                                        tempVzdlSCData.UNID = memberid;
                                        dtmTransactionsMFRT.UNID = memberid;
                                        tempSCData.Status = "inValid";
                                        tempVzdlSCData.Status = "inValid";
                                        dtmTransactionsMFRT.Status = "inValid";
                                        tempSCData.Vendor = "milvet";
                                        tempVzdlSCData.Vendor = "milvet";
                                        dtmTransactionsMFRT.Vendor = "milvet";
                                        tempSCData.TWSsegment = "MILITARY";
                                        tempVzdlSCData.TWSsegment = "MILITARY";
                                        dtmTransactionsMFRT.TWSsegment = "MILITARY";
                                        tempSCData.Startdatetimestamp = lqState.startdatetimestamp;
                                        tempVzdlSCData.Startdatetimestamp = lqState.startdatetimestamp;
                                        tempSCData.Enddatetimestamp = new Date().toUTCString();
                                        dtmTransactionsMFRT.Startdatetimestamp = lqState.startdatetimestamp;
                                        tempVzdlSCData.Enddatetimestamp = new Date().toUTCString();
                                        dtmTransactionsMFRT.Enddatetimestamp = tempSCData.Enddatetimestamp;
                                        updateSCcustomEvent("buildTwsInit", "pageViewUpdate", "detailPageName");
                                        updateVzdlSCCustomEvent("buildTwsInit", "pageViewOmni", "detail");
                                        DtmTransactionsMFRT(dtmTransactionsMFRT, dispatch);
                                        MFRTCompleted(true, dispatch);
                                    });
                                }
                                else {
                                    DtmTransactionsMFRT(dtmTransactionsMFRT, dispatch);
                                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                                    if(signIn.response && signIn.response?.reverify == 'Y'){
                                        MFRTCompleted(true, dispatch);
                                    }
                                    // MFRTCompleted(true, dispatch);
                                    // MFRTVerified(false, dispatch);                                    
                                }

                                console.log("after updateCRMMRefresh");
                            }
                        })
                            .catch(error => {
                                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                                MFRTCompleted(true, dispatch);
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callMilvetGroupVerification', "response received | fail saved to DB", PAGEACTIVITY.UA));
                                errorAction("ERROR", "LoopQual", error.message, "applogs", '', dispatch, false, "");
                                vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                            });
                    }
                    catch (ex) {
                        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitid, 'callMilvetGroupVerification', "response not received - ex occured", PAGEACTIVITY.UA));
                        catchJSException('loopQual', '', 'existingService', ex);
                    }
                }
                console.log("before return response callMilvetGroupVerificationNew");
                //MFRTCompleted(true, dispatch);
                return response;
            }
            //  MFRTCompleted(true, dispatch);
            return;

        } catch (ex) {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            MFRTCompleted(true, dispatch);
            catchJSException('loopQual', '', 'MilvetGroupVerification', ex);
        }
    }
};

export const updateState = (selectedState, dispatch) => {
    dispatch({ type: CheckLQ.onZipcodeSelected, value: selectedState });
};

export const updateStateLocus = (selectedState, dispatch, showLQBtn) => {
    dispatch({ type: CheckLQ.onZipcodeSelected, value: selectedState });
    dispatch({ type: CheckLQ.onStreetAddrSelected, value: { streetAddr: selectedState, isdisplayUnit: showLQBtn } });
};

export const newService = (status, dispatch) => {
    dispatch({ type: CheckLQ.newService, value: status })
};

export const lqRevisit = (status, dispatch) => {
    dispatch({ type: CheckLQ.lqRevisit, value: status })
};

export const updateInitLoadSec = (sec, dispatch) => {
    dispatch({ type: CheckLQ.updateInitLoad, value: sec })
};

export const updateDOFlowDetails = (doidvalue, dispatch) => {
    dispatch({ type: DOFlow.onDoFlowCreation, value: doidvalue })
};

export const updateHoaFlow = (hoaValue, dispatch) => {
    dispatch({ type: HOAFlow.onHoaFlowCreation, value: hoaValue })
};

export const quickCheckout = (dispatch, val) => {
    dispatch({ type: 'QUICK_CHECKOUT', value: val })
}
export const moversIntent = (dispatch, val) => {
    dispatch({ type: 'UPDATE_MOVERSINTENT', value: val })
}

export const emptyBuildProductState = (dispatch) => {
    dispatch({ type: 'EMPTYBUILDFIOSSTATE', value: "" });
}

export const emptyCheckoutState = (dispatch) => {
    dispatch({ type: 'EMPTY_CHECKOUT', value: "" });
    dispatch({ type: 'EMPTY_PERSONAL_INFO', value: "" });
    dispatch({ type: 'EMPTY_CREDITCHECK', value: "" });
    dispatch({ type: 'EMPTY_PFBAUTOPAY', value: "" });
    dispatch({ type: 'EMPTY_TOS', value: "" });
    dispatch({ type: 'CANCEL_MON', value: "" });
}

export const emptyCartState = (dispatch) => {
    dispatch({ type: 'EMPTYCARTSTATE', value: "" });
}

export const emptyLQState = (dispatch) => {

    dispatch({ type: 'EMPTYLQSSTATE', value: "" });
}

export const emptyDOFlowState = (dispatch) => {
    dispatch({ type: DOFlow.onEmptyDoFlowStatus, value: "" });
}

export const chatEnable = (chatEnable, dispatch) => {
    dispatch({ type: CheckLQ.chatEnable, value: chatEnable })
};

export const isFCPflow = (isFCPflow, dispatch) => {
    if (isFCPflow) {
        tempSCData.isMixMatch = true;
    }
    else {
        tempSCData.isMixMatch = false;
    }
    dispatch({ type: CheckLQ.isFCPflow, value: isFCPflow })
};

export const isoneLQFlow = (isoneLQFlow, dispatch) => {
    dispatch({ type: CheckLQ.isoneLQFlow, value: isoneLQFlow })
};

export const isQAMLessFlow = (isQAMLessFlow, dispatch) => {
    dispatch({ type: CheckLQ.isQAMLessFlow, value: isQAMLessFlow })
};

export const isamazonmovers = (isamazonmoversFlow, dispatch) => {
    dispatch({ type: CheckLQ.isamazonmover, value: isamazonmoversFlow })
};

export const isoneLQFlowDev = (isoneLQFlowDev, dispatch) => {
    dispatch({ type: CheckLQ.isoneLQFlowDev, value: isoneLQFlowDev })
};

export const isMultiadr = (isMultiadr, dispatch) => {
    dispatch({ type: CheckLQ.isMultiadr, value: isMultiadr })
};

export const skipCaptcha = (skipCaptcha, dispatch) => {
    dispatch({ type: CheckLQ.skipCaptcha, value: skipCaptcha })
};

export const OtpBypassFlow = (isOtpBypassFlow, dispatch) => {
    dispatch({ type: "OTP_BYPASSFLOW", value: isOtpBypassFlow })
};

export const updateVendorDetails = (value, dispatch) => {
    dispatch({ type: 'VENDOR_DETAILS', value: value })
};

// Vendor flow : Visitid and visitor id QS issue fix without doid check - Need to test 
// export const updatevendorSalesDetails = (value, dispatch) => {
//     dispatch({ type: 'VENDOR_SALESDETAILS', value: value })
// };

export const updateLBORedirectOOF = (dispatch, value) => {
    dispatch({ type: 'LBOREDIRECTOOF', value: value })
};

export const resetZipStreetNotFound = (dispatch, value) => {
    dispatch({ type: 'RESETZIPSTREETNOTFOUND', value: value })
};

export const updateJMPOfferFlowStatus = (value, dispatch) => {
    dispatch({ type: 'IS_ENABLE_JMP_OFFER_FLOW', value: value })
}

export const redirectToFYH = (flowType) => {
    let queryString = window.location.search;
    if (flowType === "VzConnection") {
        let params = new URLSearchParams(window.location.search);
        let VzConnType = params.get('flow');
        if (VzConnType === "getaffinity")
            VzConnType = "gtaffinity"
        window.location.href = Pages.GenerateCoupon + VzConnType;
    }

    else if (flowType === "Resume")
        window.location.href = Pages.XpsEntry + queryString
    else
        window.location.href = Pages.CheckAvail + queryString
};

export const updateRuntimeKeys = async (dispatch, flowType, retry = false) => {
    try {
        let url = '/personal/services/getaccordionmapping.runtimekeys.json';
        //let url = '/inhome/getruntimekeys';//apiUrl().configEntry;
        // url = 'https://localhost.verizon.com:8080/getruntimekeys'; //localDev
        var host = window.location.host;
        (window.location.href.indexOf('http://localhost') > -1) && (url = apiUrl().configEntry);
        if (host.indexOf("sit") > -1 || host.indexOf("nte3") > -1 || host.indexOf("nte1") > -1) {
            url = '/inhome/getruntimekeys';
        }
        if ( host.indexOf("preprod") > -1 || host.indexOf("98") > -1 || window.location.href.indexOf('http://localhost') > -1) {
            url = 'https://sales-bau-sit2-publisher.ebiz.verizon.com/personal/services/getaccordionmapping.runtimekeys.json';
        }
        console.log("runtime key url",url)
        return new Promise((resolve, reject) => {
            api(url, 'GET', '').then(async response => {
                let orderedKeys = response;
                if (InHomeUtils.isNotNull(response) && response !== "") {
                    if (typeof response === 'object' && Object.keys(response).length) {
                        orderedKeys = Object.keys(response).sort().reduce(
                            (obj, key) => {
                                obj[key] = response[key];
                                return obj;
                            },
                            {}
                        );
                    }
                    //From LQState -- lqState.runtimeKey we can refer the respective runtimeKey whereever required
                    dispatch({ type: 'RUNTIME_KEY', value: orderedKeys })
                }
                else {
                    let errorMsg = "AEM response not returned";
                    logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", this.props.appState.visitId);
                    if (!retry) {
                        updateRuntimeKeys(dispatch, flowType, true)
                    }
                }
                resolve(orderedKeys);
            })
                .catch(error => {
                    let errorMsg = `MethodName:runtimeEntry,errorMessage:${error.message}`;
                    logKafka("ERROR", "LoopQual", errorMsg, getErrorLogUrl, "applogs", "");
                    vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
                });
        });
    }
    catch (ex) {
        catchJSException('LoopQual', this.props.appState.visitId, 'updateRuntimeKeys', ex);
    }
}

export const updatePgLoggerObjConfig = (obj) => {
    getPgLoggerObj(obj);
}

export const updateTargetOrdering = (value, dispatch) => {
    dispatch({ type: 'IS_TARGETORDERING', value: value })
};

export const updateToken = (status, dispatch) => {
    dispatch({ type: CheckLQ.updateToken, value: status })
};

export const updateCouponLQPage = (dispatch, val) => {
    dispatch({ type: CheckLQ.updateCouponLQPage, value: val })
}

export const connFlowNCClick = (dispatch, val) => {
    dispatch({ type: 'CONNFLOW_NCCLICK', value: val })
}

export const updatePushNotification = (dispatch, val) => {
    dispatch({ type: CheckLQ.PushNotificationEnable, value: val })
}

export const updateCouponFlowPageLoad = (dispatch, val) => {
    dispatch({ type: 'CONNFLOW_PAGELOAD', value: val })
}

export const getCart = async (dispatch, visitId, flowType, lqState = null, buildProductState = null) => {
    try {
        const url = apiUrl().getCartAcc + '/' + visitId;
        api(url, 'GET', "").then(resp => {
            if (InHomeUtils.isNotNull(resp) && InHomeUtils.isNotNull(resp.meta) && InHomeUtils.getIndexOf(resp.meta.code, '200')) {
                dispatch({
                    type: "UPDATE_CART",
                    value: {
                        cartResponse: resp.data.cartTierPricing,
                        cartHeader: getCartHeader(resp.data.cartTierPricing.tierContent, visitId),
                        cartData: getCartData(resp.data.cartTierPricing.tierContent, visitId),
                        cartOrderDetail: resp.data.orderDetail,
                        cartOrderProperty: InHomeUtils.isNull(resp.data.cartOrderProperty) ? null : resp.data.cartOrderProperty
                    }
                });
                let servicesInCart = InHomeUtils.isNotNull(resp.data.orderDetail) && InHomeUtils.isNotNull(resp.data.orderDetail.servicesOrdered) ? resp.data.orderDetail.servicesOrdered : '';
                let contract = InHomeUtils.isNotNull(resp.data.orderDetail) && InHomeUtils.isNotNull(resp.data.orderDetail.contract) ? resp.data.orderDetail.contract : 'MTM';
                let addlInfo = {
                    isDoFlow: InHomeUtils.isNotNull(lqState.doFlowDetails) ? lqState.doFlowDetails.isDoFlow : false,
                    zip: InHomeUtils.isNotNull(lqState.selectedState) ? lqState.selectedState?.zip : null,
                    tarCode: lqState?.tarCode,
                    state: lqState?.selectedState?.state,
                    couponFlowType: lqState?.couponFlowType,
                    EquipmentState: null,
                    masterpackageview: InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.masterpackageview) ? buildProductState.tv.masterpackageview : [],
                    selectedProductId: '',
                    isFCPflow: lqState?.isFCPflow,
                    isAlaCarte: false,
                    flowType: flowType,
                    servicesQualified: InHomeUtils.isNotNull(lqState?.servicesQualified) ? lqState.servicesQualified : null,
                    regionId: InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.fiosFiveSearchVhoParams) && InHomeUtils.isNotNull(buildProductState.tv.fiosFiveSearchVhoParams.regionId) ? buildProductState.tv.fiosFiveSearchVhoParams.regionId : ''
                }
                // doPrefetch("REFRESH", dispatch, visitId, addlInfo, contract, servicesInCart, false, false,
                // false, false, false, servicesInCart, null, null)
                const promotionsSection = resp?.data?.cartTierPricing?.tierContent?.[0]?.sections?.section?.filter(x => x?.sectionName?.toLowerCase() === 'promotions');
                const promotionsSubSection = promotionsSection?.[0]?.subSections?.subSection?.filter(x => x?.sectionType?.toLowerCase() === "offers");
                if(promotionsSubSection?.[0]?.promos?.find((promo) => (promo?.promoId === "R4071" || promo?.promoId === "R4072"))) {
                    dispatch({ type: "SET_VZF_NY_DISCOUNT", value: true });
                }
            }
        })
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getMnhcartcheckoutinfo', ex);
    }


}

export const getMnhCheckoutInfo = async (dispatch, visitId, isFromMHMLPPage, isCustomerAddrChanged, lqState = null, buildProductState = null) => {
    try {

        // const response = {
        //     "meta": {
        //         "code": 200.01,
        //         "description": "Retreiving customer personal info is successful",
        //         "timestamp": "Wed May 20 16:56:47 CDT 2020"
        //     },
        //     "data": {
        //         "accountNumber": "288015612-1",
        //         "mtn": "6166101839",
        //         "firstName": "passlow",
        //         "lastName": "customer",
        //         "emailId": "passlowcust@yahoo.com",
        //         "smsOptin": "Y",
        //         "isAutopayEnrolled": "Y",
        //         "isPFBEnrolled": "Y",
        //         "autopayType": "BANK",
        //         "autoPayLast4Digits": "6789",
        //         "expiryDate": "",
        //         "tokenNumber": "WRLKMNWBQR",
        //         "creditStatus": "SUCCESS",
        //         "bankRoutingNumber": "011736279",
        //         "maxSpeedQualified": "1024",
        //         "planType": "unlimited",
        //         "address": {
        //             "addressLine1": "1611 n greenbrier st",
        //             "addressLine2": "",
        //             "city": "arlington",
        //             "state": "VA",
        //             "zipCode": "22205"
        //         }
        //     }

        // }
        // dispatch({
        //     type: CheckLQ.mnhCheckoutInfo,
        //     value: response.data
        // });
        // dispatch({
        //     type: CheckLQ.MNHFlow,
        //     value: true
        // });
        // return response;
        if (lqState && lqState.mnh) {
            if (!lqState.mnh.getCheckoutDataCalled) {
                let additionalParams = "";
                if (isFromMHMLPPage || isCustomerAddrChanged) {
                    additionalParams = `?${(isFromMHMLPPage) ? 'isFromMHMLPPage=Y' : ""}${(isFromMHMLPPage && isCustomerAddrChanged) ? '&' : ""}${(isCustomerAddrChanged) ? 'isCustomerAddrChanged=Y' : ""}`
                }
                let url = apiUrl().wlCustomerCheckoutInfo + additionalParams;
                return api(url, 'GET').then(response => {
                    if (InHomeUtils.isNotNull(response) && response.meta && response.meta.code === 200.01 && InHomeUtils.isNotNull(response.data)) {
                        if (lqState.runtimeKey && lqState.runtimeKey.skipAutoPayMH && lqState.runtimeKey.skipAutoPayMH === 'Y') {
                            response.data['isAutopayEnrolled'] = 'N';
                            response.data['isPFBEnrolled'] = 'N';
                            response.data['autoPayLast4Digits'] = '';
                        }
                        dispatch({
                            type: CheckLQ.mnhCheckoutInfo,
                            value: response.data
                        });
                        if (response.data.creditStatus && response.data.creditStatus.toLowerCase() === 'success') {
                            isMNHCreditCompleted(dispatch, true);
                            if (response.data.targetView && response.data.targetView.toLowerCase() === 'checkout') {
                                dispatch({
                                    type: 'CANCEL_PROPENSITY_CALL_REQUIRED',
                                    value: true
                                });
                                if (lqState.mnh && lqState.mnh.isGigqualified) {
                                    updateCheckoutBtnStatus(true, dispatch)
                                    getCart(dispatch, visitId, "", lqState, buildProductState)
                                    setCartDirtyFlag(true, dispatch)
                                    if (!lqState.mnh.isChangeAdr) {
                                        dispatch({
                                            type: CheckLQ.MNHONECLICKFLOW,
                                            value: true
                                        });
                                        showMNHCartOnCheckOut(dispatch, true);
                                    }
                                }
                            }
                        }
                    }
                    return response;
                })
                    .catch(error => {
                        errorAction("ERROR", "LoopQual", error.message, "applogs", dispatch, false, "");
                        vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                        return false;
                    })
            }
            else {
                dispatch({
                    type: CheckLQ.mnhCheckoutInfo,
                    value: lqState.mnh.checkoutData
                });
            }
        }
    } catch (ex) {
        catchJSException('loopQual', visitId, 'getMnhCheckoutInfo', ex);
        return false;
    }

}

export const validateToken = async (tokenValue, dispatch, visitId, redirectingTo = null) => {
    try {
        let url = apiUrl().validateCouponToken;
        let jsonstr = JSON.stringify({ customertoken: tokenValue });
        api(url, 'POST', jsonstr).then(response => {
            //response={"meta":{"code":200.01,"description":"AffinityToken Completed successfully .","timestamp":"Fri May 10 07:08:14 UTC 2019"},"data":{"result":{"status":"InValid","msg":"User Token is already expired"},"affinityCategoryDesc":"Employee Ultimate Offer"}}
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                if (response.data.result.status === "InValid" && response.data.result.msg.indexOf("expired") > -1) {
                    redirectTo(Pages.conflictMessage, dispatch);
                }
                else {
                    if (response.data.result.status === "InValid" && response.data.result.msg.indexOf("pending") > -1) {
                        dispatch({
                            type: CheckLQ.updatecouponFlowStatus,
                            value: "pending"
                        });
                    }

                    dispatch({
                        type: CheckLQ.updateCouponFlowType,
                        value: response.data.result.status === "Valid" ? response.data.flowType : null
                    });

                    if (response.data.result.status === "Valid" && response.data.flowType === "Affinity") {
                        try {
                            if (typeof setExtraCustomerInfo !== 'undefined') {
                                window.setExtraCustomerInfo('VZ_CONNECTIONS_DISCOUNT', 'Y');
                                window.reInit();
                            }
                        }
                        catch (ex) {
                            catchJSException('loopQual', visitId, 'setBannerType', ex);
                        }
                    }

                    if (redirectingTo === null) {
                        tempSCData.detailPageName = "lq check avail - care";
                        updateSCcustomEvent("checkAvaillqInit", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                        //vzdl changes 
                        tempVzdlSCData.detail = "lq check avail - care";
                        updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail");
                    }
                    else {
                        if (redirectingTo === "PendingOrder") {
                            redirectTo(Pages.PendingOrder, dispatch)
                        }
                        else if (redirectingTo === "BuildProducts") {
                            redirectTo(Pages.BuildProduct, dispatch)
                        }
                    }
                }

            }

            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            return response;
        })
            .catch(error => {
                let errorMsg = `MethodName:validateToken,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'validateToken', ex);
    }
};

export const existingService = (dispatch, visitId, holdService, roomate, moversIntent) => {
    try {
        let jsonstr = JSON.stringify({ holdforworkingservice: holdService, roomatescenario: roomate, moversIntent: moversIntent });
        let url = apiUrl().getExistingService;
        api(url, 'POST', jsonstr).then(response => {
            if (InHomeUtils.isNotNull(response)) {

                dispatch({
                    type: 'EXISTING_SERVICE',
                    value: response
                });
            }
        })
            .catch(error => {
                errorAction("ERROR", "LoopQual", error.message, "applogs", visitId, dispatch, false, "");
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'existingService', ex);
    }
};

const sortUnits = (a, b) => {
    if (a.displayValue.length < b.displayValue.length) {
        return -1;
    }
    if (a.displayValue.length > b.displayValue.length) {
        return 1;
    }
    if ((a.displayValue < b.displayValue)) {
        return -1;
    }
    if (a.displayValue > b.displayValue) {
        return 1;
    }
};

const sortString = (a, b) => {
    const displayValueA = a.displayValue.toUpperCase(); // ignore upper and lowercase
    const displayValueB = b.displayValue.toUpperCase(); // ignore upper and lowercase

    return (displayValueA < displayValueB) ? -1 : ((displayValueA > displayValueB) ? 1 : 0);
};

export const updateStreetAddr = (streetAddr, lqState, visitId, dispatch) => {
    try {
        let isdisplayUnit = false; let checkUnitUrl = '';
        if (streetAddr != null) {
            updateSCTags("street address validation");
            updateSCTags("street address select");
            if (lqState.isoneLQFlow)
                checkUnitUrl = apiUrl().getUnit + "?baseAddressId=" + streetAddr.ntasAddrID;
            else
                checkUnitUrl = apiUrl().getUnit + "?baseAddressId=" + streetAddr.addressID;
            const streetLoader = {
                type: CheckLQ.onShowStreetLoader,
                value: true
            }
            dispatch(streetLoader);
            api(checkUnitUrl, 'GET', '', '', true).then(response => {
                streetLoader.value = false;
                dispatch(streetLoader);
                dispatch({ type: "SET_STREET_FETCH_DONE", value: true })
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.unitDetails) &&
                        response.data.unitDetails.length > 0) {
                        isdisplayUnit = true;
                        if (response.data.unitDetails.length > TOTAL_UNITS_CUTOFF) {
                            updateSCTags("units more than 10");
                            //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'updateStreetAddr', PAGEACTIVITY.MSG.unitCount + " - " + response.data.unitDetails.length, PAGEACTIVITY.UA));
                        }
                        else {
                            updateSCTags("units less than 10");
                        }

                        let unitsList = [];
                        let totalUnits = Number(response.data.total);
                        if (totalUnits <= TOTAL_UNITS_CUTOFF) {
                            defaultUnit.map(obj => response.data.unitDetails.push(obj));

                            unitsList = response.data.unitDetails.map(unitDetailsObj => {
                                return { value: unitDetailsObj, displayValue: unitDetailsObj.unit.toLowerCase() };
                            });
                            //sort units
                            unitsList.sort(sortUnits);
                        }
                        // lqState.showCaptchaFromVisitId && lqState.isCaptchaTest && lqState.captchaState !== 'COMPLETED' && updateCaptcha(dispatch, '');
                        lqState.showCaptchaFromVisitId && lqState.captchaState !== 'COMPLETED' && updateCaptcha(dispatch, '');
                        dispatch({
                            type: 'LQ_ON_UNIT_CHECK',
                            value: unitsList
                        });
                        dispatch({
                            type: 'LQ_DISABLE_UNIT_TYPEAHEAD',
                            value: (unitsList.length > 0) ? true : false
                        });

                    }
                    else {
                        // (lqState.showCaptchaFromVisitId && lqState.isCaptchaTest && !lqState.captchaState) &&  updateCaptcha(dispatch, 'INITIATED');
                        (lqState.showCaptchaFromVisitId && !lqState.captchaState) && updateCaptcha(dispatch, 'INITIATED');
                        dispatch({ type: "UNIT_NOT_FOUND", value: false });
                        dispatch({ type: "SET_SHOW_MTN_EMAIL", value: true })
                        //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'updateStreetAddr', PAGEACTIVITY.MSG.NoUnit, PAGEACTIVITY.UA));
                    }
                }
                // updateSelectedStreetAddr(dispatch,{streetAddr:streetAddr,isdisplayUnit:isdisplayUnit});
                dispatch({ type: CheckLQ.onStreetAddrSelected, value: { streetAddr: streetAddr, isdisplayUnit: isdisplayUnit } });
            })
                .catch(error => {
                    streetLoader.value = false;
                    dispatch(streetLoader);
                    let errorMsg = `MethodName:updateStreetAddr,errorMessage:${error.message}`;
                    logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                    vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
                })


        }
        else {
            // updateSelectedStreetAddr(dispatch,{streetAddr:streetAddr,isdisplayUnit:isdisplayUnit});

            dispatch({ type: CheckLQ.onStreetAddrSelected, value: { streetAddr: null, isdisplayUnit: isdisplayUnit } });
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'updateStreetAddr', ex);
    }
};

export const updateUnit = (unit, dispatch) => {
    let selectedUnit = unit;
    dispatch({ type: CheckLQ.onUnitSelected, value: selectedUnit });
    unit && dispatch({ type: "SET_SHOW_MTN_EMAIL", value: true })
};

export const hideLQButton = (value, dispatch) => {
    dispatch({ type: CheckLQ.showLQonAdrEntry, value: value });
};

export const getZipcode = (zipCode, visitId, dispatch) => {
    try {
        let zipChangeReducer = {
            type: CheckLQ.onZipCodeChange,
            value: []
        };
        let zipSelectedReducer = {
            type: CheckLQ.onZipcodeSelected,
            value: null
        };
        const zipLoader = {
            type: CheckLQ.onShowZipLoader,
            value: !!(zipCode.length === 5)
        }
        dispatch(zipLoader);

        if (zipCode.length < 5) {
            dispatchLQonAdrEntry(dispatch, false);
            dispatch(zipSelectedReducer);
            dispatch(zipChangeReducer);
        }

        let getZipUrl = apiUrl().getZipcode + "?zipcityterm=" + zipCode;
        api(getZipUrl, 'GET', '', '', true).then(response => {
            dispatch({ type: 'FIVEGELIGIBLEZIP', value: (InHomeUtils.isNotNull(response) && InHomeUtils.isNotEmpty(response.fiveGEligible) && response.fiveGEligible === "Y") ? true : false });
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotEmpty(response.fiveGEligible) && response.fiveGEligible === "Y") {
                updateSCTags('fiveG Eligbile Zip');
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                InHomeUtils.isNotNull(response.zips) && response.zips.length) {
                if (!zipCode.length) {
                    dispatch(zipSelectedReducer);
                    dispatch(zipChangeReducer);
                } else if (zipCode.length === 5) {
                    zipSelectedReducer.value = response.zips[0];
                    updateSCTags("zip code validation");
                    tempVzdlSCData.detail = "existing service";
                    updateVzdlObjectValues("pageView", response.zips[0], "pageViewOmni", response.data, visitId);
                    dispatch(zipChangeReducer);
                    dispatch(zipSelectedReducer);
                } else {
                    let zipsList = response.zips.map(zipDetailsObj => {
                        return { value: zipDetailsObj, displayValue: zipDetailsObj.zip };
                    });
                    zipsList.sort(sortUnits);
                    dispatch({
                        type: 'SET_ZIP_CODES',
                        value: zipsList
                    });
                }
            } else {
                if (zipCode.length === 5) {
                    if (response && response.meta && response.meta.code && parseInt(response.meta.code) === 500 || response.status && response.status !== 200) {
                        updateSCTags("zip code bypass");
                        zipSelectedReducer.value = {
                            altCity: '',
                            city: '',
                            state: '',
                            zip: zipCode
                        };
                        dispatch(zipChangeReducer);
                        dispatch(zipSelectedReducer);
                    } else {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getZipcode', PAGEACTIVITY.MSG.ZipNotFound, PAGEACTIVITY.UA));
                        tempSCData.servicePostalCode = zipCode;
                        tempSCData.detailPageName = "zip code oof";
                        tempVzdlSCData.detail = "zip code oof";
                        updateSCcustomEvent("outOfFranchise", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                        updateVzdlSCCustomEvent("outOfFranchise", "pageViewOmni", "detail");
                        dispatch({ type: 'ZIP_NOT_FOUND', value: null });
                    }
                }
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:getZipCode,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'updateStreetAddr', ex);
    }

};

export const updateSigninBtnStatus = (dispatch, val) => {
    dispatch({ type: CheckLQ.updateSigninBtnStatus, value: val });
}

export const bypassLqAddressInput = (queryStringObj, lqState, visitId, dispatch) => {
    //zip
    try {
        let selectedZipObj = {
            altCity: queryStringObj.city,
            city: queryStringObj.city,
            state: queryStringObj.state,
            zip: queryStringObj.zip
        };
        let zipSelectedReducer = {
            type: CheckLQ.onZipcodeSelected,
            value: selectedZipObj
        };
        dispatch(zipSelectedReducer);

        //getStreetAddr
        let zip = queryStringObj.zip;
        let streetAddr = queryStringObj.addressline1;
        const invalidSequenceCheck = new RegExp('(.)\\1{10,}')
        if (streetAddr && invalidSequenceCheck.test(streetAddr)) {
            return;
        }
        const street = streetAddr.replace(/[-_\/\\^$*+?.()|[\]{}]/g, '').replace(/^\s+|\s+$/g, "").replace(/,/g, ' ').replace(/\s+/g, " ");

        let getStreetUrl = apiUrl().getStreetAddr + "?zip=" + zip + "&streetterm=" + street.trim();
        getStreetUrl = encodeURI(getStreetUrl);
        api(getStreetUrl, 'GET', '', '', true).then(response => {
            if ((InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) &&
                InHomeUtils.isNotNull(response.addressesbau) && response.addressesbau.length > 0) {

                let arrAddress = response.addressesbau.map(streetDetailsObj => {
                    return { value: streetDetailsObj, displayValue: streetDetailsObj.street.toLowerCase() };
                });
                arrAddress.sort(sortString);
                arrAddress.push(defaultStreet);
                dispatchAddr(dispatch, arrAddress);
                //added
                let selectedAdr = arrAddress[0].value;
                dispatch({
                    type: CheckLQ.onStreetAddrSelected,
                    value: { streetAddr: selectedAdr, isdisplayUnit: false }
                });

                //unit
                if (queryStringObj.addressline2) {
                    let unit = encodeURI(queryStringObj.addressline2);
                    let getUnitUrl = apiUrl().getUnit + "?baseAddressId=" + selectedAdr.addressID + "&unitterm=" + unit;
                    api(getUnitUrl, 'GET', '').then(response => {
                        if ((InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                            InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.unitDetails) && response.data.unitDetails)) {
                            let unitsList;
                            if (unit === '' && response.data.total > TOTAL_UNITS_CUTOFF) {
                                unitsList = [];
                            } else if (InHomeUtils.isNotNull(response.data.unitDetails)) {
                                defaultUnit.map(obj => response.data.unitDetails.push(obj));
                                unitsList = response.data.unitDetails.map(unitDetailsObj => {
                                    return { value: unitDetailsObj, displayValue: unitDetailsObj.unit.toLowerCase() };
                                });
                                //sort units
                                unitsList.sort(sortUnits);
                            }
                            dispatch({ type: 'LQ_ON_UNIT_CHANGE', value: unitsList });
                            //added update unit
                            if (InHomeUtils.isNotNull(response.data.unitDetails)) {
                                dispatch({ type: CheckLQ.onUnitSelected, value: response.data.unitDetails[0] });
                            }
                        } else {
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            errorAction("LBO", "CheckLQ", "", "applogs", visitId, dispatch, true, "GBBERR");
                            vzdlErrorUpdate(response.meta.code, "GBBERR");
                        }
                    })
                        .catch(error => {
                            let errorMsg = `MethodName:bypassLqAddressInput-getUnit,errorMessage:${error.message}`;
                            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                            vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
                        });
                }
            } else {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                let errorMsg = `MethodName:bypassLqAddressInput,errorMessage:GBBERR`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);

                errorAction("LBO", "loopQual", "", "applogs", visitId, dispatch, true, "GBBERR");
                vzdlErrorUpdate(response.meta.code, "GBBERR");
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:bypassLqAddressInput-getStreetAdr,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'bypassLqAddressInput', ex);
    }

};

export const updateSelectedStreetAddr = (dispatch, valueToDispatch) => {
    dispatch({ type: CheckLQ.onStreetAddrSelected, value: valueToDispatch });
}

export const setSelectedState = (dispatch, valueToDispatch) => {
    dispatch({ type: CheckLQ.setSelectedState, value: valueToDispatch });
}

export const updateSelectedState = (dispatch, value) => {
    dispatch({ type: 'ZIP_NOT_FOUND', value });
}

export const updateCaptcha = (dispatch, valueToDispatch) => {
    dispatch({ type: CheckLQ.captchaChanged, value: valueToDispatch });
}

export const showCaptchaLBOFromVisitId = (dispatch, showCaptchaFromVisitId, showLBOFromVisitId) => {
    dispatch({ type: CheckLQ.showCaptchaLBOFromVisitId, showCaptchaFromVisitId, showLBOFromVisitId });
}

export const showStadiaOffer = (dispatch, showStadia) => {
    dispatch({ type: CheckLQ.showStadiaOffer, showStadia });
}

export const showMarvelOffer = (dispatch, showMarvel) => {
    dispatch({ type: CheckLQ.showMarvelOffer, showMarvel });
}

export const updateMFRTType = (dispatch, mfrtType) => {
    dispatch({ type: CheckLQ.updateMFRTType, mfrtType });
}

export const MilvetHeaderhide = (dispatch, mfrtHeaderhide) => {
    dispatch({ type: CheckLQ.MilvetHeaderhide, mfrtHeaderhide });
}

export const updateAgencyId = (dispatch, agencyId) => {
    dispatch({ type: CheckLQ.updateAgencyId, agencyId });
}

export const update5GRecommended = (dispatch, is5GRecommended) => {
    dispatch({ type: CheckLQ.update5GRecommended, is5GRecommended });
}

export const update4GRecommended = (dispatch, is4GRecommended) => {
    dispatch({ type: CheckLQ.update4GRecommended, is4GRecommended });
}

const sortbyNTASAddressID = (a, b) => {
    const displayValueA = parseInt(a.value.ntasAddrID || '0');
    const displayValueB = parseInt(b.value.ntasAddrID || '0');
    return (displayValueA < displayValueB) ? 1 : ((displayValueA > displayValueB) ? -1 : 0);
};

const oneLQPrefState = { NJ: 'NJ', NY: 'NY', RI: 'RI', CT: 'CT', DC: 'DC', MD: 'MD', MA: 'MA', VA: 'VA', PA: 'PA', NC: 'NC', DE: 'DE' };

const dispatchAddrNLQ = (dispatch, address, show) => {
    dispatchAddr(dispatch, address);
    dispatchLQonAdrEntry(dispatch, show);
}

const dispatchAddr = (dispatch, address) => {
    dispatch({
        type: 'LQ_ON_STREETADDR_CHANGE',
        value: address || []
    })
}

const dispatchLQonAdrEntry = (dispatch, show) => {
    dispatch({ type: CheckLQ.showLQonAdrEntry, value: show || false });

}

export const getStreetAddr = (streetAddr, lqState, visitId, dispatch, apiCall) => {
    try {
        let errMsg = ""; let status = "";
        let getStreetUrl = ''; let arrAddress = [];
        let userSt = window.sessionStorage.getItem('prefSt');
        let priorityAddArr = [], nonPriorityAddrArr = [];
        userSt = (userSt && oneLQPrefState[userSt]) || '';
        const { isoneLQFlow, showLQBtnAdrEntry, isoneLQFlowDev, selectedState } = lqState;
        if (streetAddr.length) {
            const invalidSequenceCheck = new RegExp('(.)\\1{10,}')
            if (streetAddr && invalidSequenceCheck.test(streetAddr)) {
                return;
            }
            let street = streetAddr.replace(/[-_\/\\&:';"^$*+?,.()|[\]{}]/g, ' ').replace(/^\s+|\s+$/g, "").replace(/\s+/g, " ");
            const showLQBtn = !!(street.length > 5);
            // if (lqState.isMultiadr) {
            (showLQBtnAdrEntry !== showLQBtn) && dispatchLQonAdrEntry(dispatch, showLQBtn);
            apiCall && dispatch({ type: CheckLQ.adrEntered, value: street.trim() });
            // }  
            if (!window.location.host.includes('.ebiz.verizon.com') && isoneLQFlow) {
                getStreetUrl = apiUrl().getStreetAddrLocus2 + street.trim();
                if (userSt !== "")
                    getStreetUrl = getStreetUrl + "&sortByState=" + userSt.trim() + '&countrycode=USA';
            }
            else {
                getStreetUrl = apiUrl().getStreetAddr + "?streetterm=" + street.trim();
            }

            getStreetUrl = encodeURI(getStreetUrl);
            api(getStreetUrl, 'GET', '', '', true).then(response => {
                if (!response) {
                    errMsg = "ResponseNull";
                }
                if (response && response.message) {
                    errMsg = response.message;
                    if (response.response && response.response.status)
                        status = response.response.status;
                }
                response = response || {};
                const { meta, addressesbau, addresses } = response;
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.addresses) && InHomeUtils.isNotNull(response.addressesbau) && apiCall && meta && (parseInt(meta.code) === 200) &&
                    (addressesbau && addressesbau.length) ||
                    (apiCall && isoneLQFlow && addresses && addresses.length)) {
                    // response.addressesbau.push(defaultStreet);
                    if (streetAddr === '') {
                        dispatchAddrNLQ(dispatch);
                    } else if (isoneLQFlow) {
                        /* let  userSt = window.sessionStorage.getItem('prefSt'); 
                        let priorityAddArr = [], nonPriorityAddrArr = [];
                        userSt = (userSt && oneLQPrefState[userSt]) || ''; */

                        response.addresses.map((streetDetailsObj, idx) => {

                            const viewAddress = (streetDetailsObj.disprawstr.substring(0, streetDetailsObj.disprawstr.length - 3)).toLowerCase(), lowStreet = street.toLowerCase();
                            const countryAdd = streetDetailsObj.disprawstr.substring(streetDetailsObj.disprawstr.length - 3, streetDetailsObj.disprawstr.length);
                            const dispAddress = viewAddress + countryAdd;

                            //const dispAddress = streetDetailsObj.disprawstr.toLowerCase(), lowStreet = street.toLowerCase();
                            // const bldText = (street.length   <= streetDetailsObj.houseNumber.length  ) ? streetDetailsObj.houseNumber : streetDetailsObj.dispstr;
                            const matchingStreet = dispAddress.indexOf(lowStreet) > -1 ? lowStreet : ''; //lowStreet.indexOf(streetDetailsObj.houseNumber) > -1 ? streetDetailsObj.houseNumber : '' ; commenting this as we highlighting matching string in street 
                            const houseNumber = !matchingStreet.length && lowStreet.indexOf(streetDetailsObj.houseNumber) > -1 && streetDetailsObj.houseNumber || '';
                            // const otherTxt = dispAddress.slice(bldText.length).toLowerCase();
                            // const normalTextArr = bldText.length ? dispAddress.split(bldText) : [dispAddress];
                            const modifiedAddress = {
                                value: streetDetailsObj,
                                matchingStreet,
                                normalText: dispAddress, //otherTxt,
                                oneLq: 1,
                                houseNumber,
                                displayValue: dispAddress
                            };

                            /* if ( userSt  )
                            {
                                (streetDetailsObj.state === userSt) ? priorityAddArr = [...priorityAddArr, modifiedAddress] : nonPriorityAddrArr = [...nonPriorityAddrArr, modifiedAddress];
                            }else {
                                (streetDetailsObj.ntasAddrID.length ) ? priorityAddArr = [...priorityAddArr, modifiedAddress] : nonPriorityAddrArr = [...nonPriorityAddrArr, modifiedAddress];  
                            }
                            Uncomment this if below logic is not addressing all the use case */
                            if (userSt) {
                                /* added additional condition to prioritize NTAS address in prefSt.
                                 (streetDetailsObj.state === userSt) ? 
                                  (streetDetailsObj.ntasAddrID.length ) ? priorityAddArr = [...priorityAddArr, modifiedAddress] : nonPriorityAddrArr = [...nonPriorityAddrArr, modifiedAddress] 
                                  : nonPriorityAddrArr = [...nonPriorityAddrArr, modifiedAddress]; */

                                //Below is the latest sorting which is working
                                //  (streetDetailsObj.state === userSt && streetDetailsObj.ntasAddrID &&
                                //    streetDetailsObj.ntasAddrID.length)? priorityAddArr = [...priorityAddArr, modifiedAddress] : nonPriorityAddrArr = [...nonPriorityAddrArr, modifiedAddress]; 

                                //Trying the below for testing
                                (streetDetailsObj.state === userSt && streetDetailsObj.ntasAddrID && streetDetailsObj.ntasAddrID.length) ? priorityAddArr = [...priorityAddArr, modifiedAddress] :
                                    nonPriorityAddrArr = (streetDetailsObj.ntasAddrID && streetDetailsObj.ntasAddrID.length) ? [modifiedAddress, ...nonPriorityAddrArr] : [...nonPriorityAddrArr, modifiedAddress];

                            } else {
                                (streetDetailsObj.ntasAddrID && streetDetailsObj.ntasAddrID.length) ? priorityAddArr = [...priorityAddArr, modifiedAddress] : nonPriorityAddrArr = [...nonPriorityAddrArr, modifiedAddress];
                            }
                            /* (streetDetailsObj.state === userSt) ? prefStArr = [...prefStArr, modifiedAddress] : lessPrefStArr = [...lessPrefStArr, modifiedAddress];  
                            (streetDetailsObj.ntasAddrID.length ) ? ntasAddress = [...ntasAddress, modifiedAddress] : nonNtasAddress = [...nonNtasAddress, modifiedAddress];   */
                        });
                        // arrAddress = prefStArr.length ? prefStArr.concat(lessPrefStArr) : ntasAddress.concat(nonNtasAddress);
                        arrAddress = priorityAddArr.concat(nonPriorityAddrArr);
                    }
                    else {
                        arrAddress = response.addressesbau.map(streetDetailsObj => {
                            return { value: streetDetailsObj, displayValue: streetDetailsObj.street.toLowerCase() };
                        });
                        arrAddress.length && arrAddress.sort(sortString);

                    }
                    // if (isoneLQFlow && arrAddress.length ){ // Don't remove this, until we certify new changes in prod
                    //   const userSt = window.sessionStorage.getItem('prefSt'); 
                    //   let prefStArr = [], lessPrefStArr = [];
                    //   if(userSt && oneLQPrefState[userSt]){
                    //     arrAddress.map(suggAddr  => {
                    //          (suggAddr.value.state === userSt) ? prefStArr = [...prefStArr, suggAddr] : lessPrefStArr = [...lessPrefStArr, suggAddr];  
                    //     });
                    //      arrAddress = prefStArr.concat(lessPrefStArr);
                    //   } else { 
                    //     arrAddress.sort(sortbyNTASAddressID);
                    //     const ntasAddress = arrAddress.filter(elem => elem.value.ntasAddrID.length).sort(sortString);
                    //     ntasAddress.length && ( arrAddress = ntasAddress.concat( arrAddress.slice(ntasAddress.length) ));
                    //  }

                    //  }else {
                    // arrAddress.length && arrAddress.sort(sortString);
                    // } 
                    streetAddr.length && arrAddress.push(defaultStreet);

                    dispatchAddr(dispatch, arrAddress);
                }
                else {
                    if (apiCall && isoneLQFlow) {
                        let regex = /^(.).*\1$/;
                        let streetTrim = street.trim();
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getStreetAddr', PAGEACTIVITY.MSG.StreetNotFoundinLocus, PAGEACTIVITY.UA));
                        getStreetUrl = apiUrl().getPartialStreetAddr + street.trim();
                        getStreetUrl = encodeURI(getStreetUrl);
                        api(getStreetUrl, 'GET', '', '', true).then(response => {
                            if (InHomeUtils.isNull(response)) {
                                errMsg = "ResponseNull";
                            }
                            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.message)) {
                                errMsg = response.message;
                                if (InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.status))
                                    status = response.response.status;
                            }
                            if (streetAddr === '') {
                                dispatchAddrNLQ(dispatch, []);
                            } else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                                (InHomeUtils.isNotNull(response.addresses) && response.addresses.length > 0)) {
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getStreetAddr', PAGEACTIVITY.MSG.StreetfoundinNtas, PAGEACTIVITY.UA));
                                arrAddress = response.addresses.map(streetDetailsObj => {
                                    return { value: streetDetailsObj, displayValue: streetDetailsObj.disprawstr.toLowerCase() };
                                });
                                arrAddress.length && arrAddress.sort(sortString);
                                arrAddress.push(defaultStreet);

                                dispatchAddr(dispatch, arrAddress);

                            }
                            else if (streetTrim.length > 10 && regex.test(streetTrim)) {
                                street = streetTrim.slice(0, -1)
                                getStreetUrl = apiUrl().getPartialStreetAddr + street;
                                getStreetUrl = encodeURI(getStreetUrl);
                                api(getStreetUrl, 'GET', '', '', true).then(response => {
                                    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                                        (InHomeUtils.isNotNull(response.addresses) && response.addresses.length > 0)) {
                                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getStreetAddr', PAGEACTIVITY.MSG.StreetfoundinNtas, PAGEACTIVITY.UA));
                                        arrAddress = response.addresses.map(streetDetailsObj => {
                                            return { value: streetDetailsObj, displayValue: streetDetailsObj.disprawstr.toLowerCase() };
                                        });
                                        arrAddress.length && arrAddress.sort(sortString);
                                        arrAddress.push(defaultStreet);
                                        dispatchAddr(dispatch, arrAddress);
                                    }
                                    else {
                                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getStreetAddr', PAGEACTIVITY.MSG.StreetnotfoundinNtas, PAGEACTIVITY.UA));
                                        dispatchAddr(dispatch, []);
                                    }
                                })
                            }
                            else {
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getStreetAddr', PAGEACTIVITY.MSG.StreetnotfoundinNtas, PAGEACTIVITY.UA));
                                dispatchAddr(dispatch, []);
                            }
                        })
                    }
                    else {
                        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getStreetAddr', PAGEACTIVITY.MSG.StreetNotFound, PAGEACTIVITY.UA));
                        }
                        else if (status !== "" || errMsg !== "") {
                            // logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getStreetAddr', PAGEACTIVITY.MSG.lqError + "-" + errMsg + " - " + status, PAGEACTIVITY.UA));         
                        }
                        dispatchAddr(dispatch, []);
                    }
                }
            })
                .catch(error => {
                    let errorMsg = `MethodName:getStreetAddr,errorMessage:${error.message}`;
                    logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                    vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
                });
        }
        else {
            dispatchAddrNLQ(dispatch)
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getStreetAddr', ex);
    }
};

export const getUnit = (unit, lqState, visitId, dispatch) => {
    try {
        let getUnitUrl = '';
        /*   if (unit !== "") {       
              dispatch({ type: CheckLQ.unitEntered, value: unit.trim() });
          } */
        if (unit === "" && lqState.lqResponse !== null) {
            resetLqResponse({}, dispatch);
        }
        let locusUnit = (lqState && lqState.runtimeKey && lqState.runtimeKey.LocusUnit) || 'N';
        if (lqState.isoneLQFlow) {
            if (locusUnit === "Y" && lqState && lqState.selectedAdr && lqState.selectedAdr.locusID)
                getUnitUrl = apiUrl().getUnitLocus + "?locusID=" + lqState.selectedAdr.locusID + "&baseAddressId=" + lqState.selectedAdr.ntasAddrID + "&unitterm=" + encodeURI(unit);
            else
                getUnitUrl = apiUrl().getUnit + "?baseAddressId=" + lqState.selectedAdr.ntasAddrID + "&unitterm=" + encodeURI(unit);
        } else
            getUnitUrl = apiUrl().getUnit + "?baseAddressId=" + lqState.selectedAdr.addressID + "&unitterm=" + encodeURI(unit);

        api(getUnitUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.unitDetails) &&
                    response.data.unitDetails.length > 0) {
                    processUnitResponse(response, unit, dispatch);
                }
                else {
                    /* if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getStreetAddr', PAGEACTIVITY.MSG.StreetNotFound, PAGEACTIVITY.UA));                                      
                    }  */
                    /* dispatch({
                        type: 'LQ_ON_UNIT_CHANGE',
                        value: []
                    })  */
                    if (isoneLQFlow && locusUnit === "Y") {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getUnit', PAGEACTIVITY.MSG.UnitNotFoundinLocus, PAGEACTIVITY.UA));
                        getUnitUrl = apiUrl().getUnit + "?baseAddressId=" + lqState.selectedAdr.addressID + "&unitterm=" + encodeURI(unit);
                        api(getUnitUrl, 'GET', '').then(response => {
                            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.unitDetails) &&
                                    response.data.unitDetails.length > 0) {
                                    processUnitResponse(response, unit, dispatch);
                                }
                            }
                        });
                    }
                }
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:getUnit,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getUnit', ex);
    }
};


const processUnitResponse = (response, unit, dispatch) => {
    let unitsList;

    if (unit === '' && response.data.total > TOTAL_UNITS_CUTOFF) {
        unitsList = [];
    } else {
        defaultUnit.map(obj => response.data.unitDetails.push(obj));
        unitsList = response.data.unitDetails.map(unitDetailsObj => {
            return { value: unitDetailsObj, displayValue: unitDetailsObj.unit.toLowerCase() };
        });
        //sort units
        unitsList.sort(sortUnits);
    }
    dispatch({
        type: 'LQ_ON_UNIT_CHANGE',
        value: unitsList
    });
}

export const resetAddressSuggestion = (dispatch) => {
    dispatch({ type: CheckLQ.suggestedAddress, value: [] });

}

export const resetLqData = (dispatch) => {
    dispatch({ type: CheckLQ.resetLqData });
}
export const retriveQualification = async (checkAddrResponse, visitId, lqState, dispatch,addrID,zip,isTwsFlow,isAcpFlow,mtnValue,emailValue, isLq2Flow, appState) => {
    loaderActive({ isLoaderActive: false }, dispatch);
    let inservice = checkAddrResponse?.data?.inService === 'Y';
    let ispendingOrder = checkAddrResponse?.data?.pendingOrder === 'Y';
    let ispendingOrderDisconnect = checkAddrResponse?.data?.pendingOrderDisconnect === 'Y';
    let isSmartCartFlow = !!(store?.getState()?.save && store?.getState()?.issmartcartflow);
    let isLoggedIn = false;
    const loggedInCookie = InHomeUtils.getCookie('loggedIn', document.cookie);
    let lqResponseServices = checkAddrResponse?.data?.services ?? [];
    let isMnhFlow = lqState?.mnh?.mnhFlow ?? false;
    let isFiosHappyPath=(!inservice && !isSmartCartFlow && !ispendingOrder && !isAcpFlow && !isTwsFlow && appState.flowType !== "MV" && !lqState.couponFlowType)?true:false;   
    const lqaCalledFlag = window.sessionStorage.getItem('lqaCalled') ?? 'N';
    const isActiveLqaInvoked = window.sessionStorage.getItem('activeLqaCalled') ?? 'N';
    const isPassiveLqaInvoked = window.sessionStorage.getItem('passiveLqaCalled') ?? 'N';
    const activelqsCalledInvoked = window.sessionStorage.getItem('activelqsCalled') ?? 'N';
    const passivelqsCalledInvoked = window.sessionStorage.getItem('passivelqsCalled') ?? 'N';
    const isEmployeeFlow = window.sessionStorage.getItem('couponType');
    if(isEmployeeFlow !== '' && isEmployeeFlow!== null && isEmployeeFlow!== undefined){
        dispatch({
            type: CheckLQ.updateCouponFlowType,
            value: isEmployeeFlow
        });
    }
    if (loggedInCookie === 'true') {
        isLoggedIn = true;
    }
    let lennarFlow = false;
    let isLQSuccess = false;
    let connectionFlow = (lqState && InHomeUtils.isNotNull(lqState.couponFlowType) && (lqState.couponFlowType === "Employee" || lqState.couponFlowType === "Retiree" || lqState.couponFlowType === "Affinity"));
    if(loggedInCookie === 'true' && passivelqsCalledInvoked === 'N' && (isPassiveLqaInvoked === 'Y' &&  (isActiveLqaInvoked === 'N'|| lqaCalledFlag ==='N')) && isFiosHappyPath){
        passiveVzTagLqs(lqResponseServices);
        window.sessionStorage.setItem('passivelqsCalled', 'Y');
    }
    if(activelqsCalledInvoked === 'N' && (isActiveLqaInvoked === 'Y' || lqaCalledFlag === 'Y') && isFiosHappyPath){
        loopQualVzTaglqs(addrID, lqResponseServices, zip, emailValue, mtnValue, isMnhFlow, ispendingOrderDisconnect);
        window.sessionStorage.setItem('activelqsCalled', 'Y');
    }
    if(inservice){
        existingService(dispatch, visitId,'Y','N');//skipped from LQ widget and to BYOB- performance
    }
    if (!checkAddrResponse) {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', "LQ Response is empty or null", PAGEACTIVITY.UA));
        errorMsg = "LQResponseNull";
    }
    if(checkAddrResponse.data?.isRuralBroadBandAddress){
        dispatch({ type: 'IS_RURAL_BROADBAND_ADDRESS', value: true });
    }
    if (lqState?.runtimeKey?.EnableMHFiosSignIn === "Y" && (checkAddrResponse?.data?.wirelessPlanType === 'METERED' || checkAddrResponse?.data?.wirelessPlanType === 'UNLIMITED') && !window.location.href.includes('lq2=y')) {
         callValidateAPI();
     }
     if(lqState?.runtimeKey?.mnhAuthCustomerRibbon === "Y" && (checkAddrResponse?.data?.wirelessPlanType === 'METERED' || checkAddrResponse?.data?.wirelessPlanType === 'UNLIMITED')){
        callGetNameMnhDetails(dispatch);
    }
     // FIOSVEC-4 Lift change order restriction
    if (lqState?.runtimeKey?.isVECEnabled === "Y" && checkAddrResponse?.data?.hoaFlag === "Y") {
        console.log(checkAddrResponse?.data?.hoaFlag, 'hoaFlag')
        updateHoaFlow(true, dispatch);
        lqState.hoaFlowDetails = { isHoaFlow: true };    
    }
    try{
       if (checkAddrResponse?.data?.hoaFlag === "Y" && (checkAddrResponse?.data?.availableFlag === "N" || checkAddrResponse?.data?.availableFlag === null)) {
           logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'HOA', PAGEACTIVITY.MSG.HOA, PAGEACTIVITY.UA));
           errorAction("LBO", "CheckLQ", "HOA", "", visitId, dispatch, true, "HOA");
       }
       else if (checkAddrResponse?.data?.hoaFlag === "Y" && (!(lqState?.runtimeKey?.EnableHOA === "Y")||( appState?.flowType === "MV" || connectionFlow || (inservice && lqState?.runtimeKey?.EnableVEC_ExistService !== 'Y')))) {
           logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'HOA', PAGEACTIVITY.MSG.HOA, PAGEACTIVITY.UA));
           errorAction("LBO", "CheckLQ", "HOA", "", visitId, dispatch, true, "HOA");
       }
       //movechange
       else if (appState?.flowType == "MV" && checkAddrResponse?.data?.mvStopOrder) {
        errorAction("LBO", "CheckLQ", "mvStopOrder", "", visitId, dispatch, true, "mvStopOrder");
        vzdlErrorUpdate(checkAddrResponse.meta.code, "mvStopOrder");
       }
       else if (checkAddrResponse?.meta?.code &&
        (InHomeUtils.getIndexOf(checkAddrResponse.meta.code, '200') || InHomeUtils.getIndexOf(checkAddrResponse.meta.code, '200.01')) && checkAddrResponse?.data) {
         if (checkAddrResponse?.data?.services) {
            isLQSuccess = true;
            
            const dispatchValue = { type: CheckLQ.suggestedAddress, value: [] };
            dispatch(dispatchValue);
            if (checkAddrResponse?.data?.isFCP) {
                isFCPflow(checkAddrResponse.data.isFCP, dispatch);
            }
            //lennar change                    
            if (checkAddrResponse?.data?.isLennarEligible === 'Y') {
                lennarFlow = true;
            }
            if (!isLq2Flow) {
                dispatch({ type: 'EMPTYBUILDFIOSSTATE', value: "" });
                dispatch({ type: CartActions.clearcartstate, value: "" });
                emptyCheckoutState(dispatch);
            }
            let addrIdsel = lqState?.selectedAdr?.addressID;
            dispatch({ type: 'ADDRESSID', value: addrIdsel });
            if (lqState?.quickCheckout) {
                updateCheckoutBtnStatus(true, dispatch);
            }
        }
    }
    }catch (e){
       console.log("exception in retriveQualification" + e);
    }
     // One Signal API Changes
     try {
        if (lqState?.runtimeKey?.PushNotification === "Y") {
            console.log("Invoked oneSignal API in LQ");
            console.log(lqState.runtimeKey.OneSignalAppID);
            let LQStatus = isLQSuccess ? "SUCCESS" : "FAILURE"
            //let visitId = this.props.appState.visitId;
            window.OneSignal.push(function () {
                console.log("Invoked push");
                window.OneSignal.sendTags({
                    "Pagename": "LQ",
                    "App_id": "inhome",
                    "Flow": "Desktop",
                    "SessionID": visitId,
                    "Order_Submit": "N",
                    "LQStatus": LQStatus
                }).then(function (tagsSent) {
                    // Callback called when tags have finished sending 
                    console.log("tagsSent: ", tagsSent);
                });
            });
        }
    }
    catch (e) {
        console.log("exception while invoking oneSignal API in LQ" + e);
    }
    let retrieveQualdetailsUrl = apiUrl().retrieveQualdetails;
    dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: checkAddrResponse.data });
                            servicesQualified(checkAddrResponse.data, dispatch);
                            let mnhCheckoutData = null;
                            console.log(lqState,'lqState',lqState.mnh,'lqStatemnh',lqState.mnh.mnhFlow,'lqStatemnhFlow');
                            if (lqState && lqState.mnh && lqState.mnh.mnhFlow) {
                                mnhCheckoutData = await getMnhCheckoutInfo(dispatch, visitId, lqState.mnh.isMNHQS, lqState.mnh.isChangeAdr, lqState);
                            }
                            console.log(mnhCheckoutData,'mnhCheckoutData');
    api(retrieveQualdetailsUrl, 'GET', '').then(response => {
        if (InHomeUtils.isNull(response) || response === "") {
            errorMsg = "RetrievequalResponseNull";
        }
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
            dispatch({ type: 'LQ_ON_RETRIEVE_QUALDETAILS', value: response.data });
            if(response.data?.getBroadbandAvailabilityResult?.fttpAvailabilityDetailsAGR?.isRuralBroadBandAddress){
                dispatch({ type: 'IS_RURAL_BROADBAND_ADDRESS', value: true });
            }     
            let nsiIndicator = "";
            if (InHomeUtils.isNotNull(response.data.addressValidationRecordAGR) && response.data.addressValidationRecordAGR.length) {
                nsiIndicator = response.data.addressValidationRecordAGR[0].nonStandardAddressFlag;
                dispatch({ type: 'NSI_INDICATOR', value: nsiIndicator });
                if (nsiIndicator === "Y") {
                    let nsiUrl = apiUrl().nsiNotify
                    api(nsiUrl, 'POST', getNsiRequest(addrID, lqState.selectedState.state)).then(response => {
                        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                            dispatch({ type: 'NSI_STATUS', value: response.data });
                        }
                        else if (InHomeUtils.isNull(response) || (InHomeUtils.isNotNull(response) && (InHomeUtils.getIndexOf(response.meta.code, '500') || InHomeUtils.getIndexOf(response.meta.code, '400')))) {
                            dispatch({ type: 'NSI_FAILED', value: true });
                        }
                    })
                }
            }
            if (InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR)
                && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.ofsPresaleEligible) && response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.ofsPresaleEligible === "Y") {
                dispatch({ type: "PRESALE_ELIGIBLE", value: true })
                if (response.data.getAdditionalInfo !== null && response.data.getAdditionalInfo !== undefined && response.data.getAdditionalInfo.ofsEstimateDays !== "") {
                    dispatch({ type: "PRESALE_ESTIMATEDAYS", value: response.data.getAdditionalInfo.ofsEstimateDays })
                }
            }
            if (InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR)
                && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent) && response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent === "Y") {
                logOtherInfo(detailsInfo('loopQual', visitId, 'checkAddr', "IONT Eligible", PAGEACTIVITY.UA));
                dispatch({ type: "IONT_ELIGIBLE", value: true })
                dispatch({ type: "IONT_STATUS", value: true })
                tempSCData.IONTEligible = true;
                isIONTAddr = true;
            }
            if (InHomeUtils.isNotNull(response.data.getAdditionalInfo) && InHomeUtils.isNotNull(response.data.getAdditionalInfo.isBOSTONDMA)) {
                dispatch({ type: "BOSTONDMA", value: response.data.getAdditionalInfo.isBOSTONDMA })
            }
            //Advantage Offer
            if (InHomeUtils.isNotNull(response.data.getAdditionalInfo) && InHomeUtils.isNotEmpty(response.data.getAdditionalInfo.vzwOffer)) {
                updateVZWResponse(dispatch, response.data.getAdditionalInfo.vzwOffer)
            }
            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.vendorName) && lqState.vendorName === "amazon")
                loaderActive({ isLoaderActive: false }, dispatch);

        }
        else {
            let errMsg = ""; let stat = "";
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && (response.meta.code))
                stat = response.meta.code;
            loaderActive({ isLoaderActive: false }, dispatch);
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.message)) {
                errMsg = response.message;
                if (InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.status))
                    stat = response.response.status;
            }
            if (errMsg !== "" || stat !== "")
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr_RetrieveQual', PAGEACTIVITY.MSG.lqError + "-" + errMsg + " - " + stat, PAGEACTIVITY.UA));
        }
    })
        .catch(error => {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lqError + "-" + "CatchBlock1" + " - " + error.message, PAGEACTIVITY.UA));
            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                tempSCData.statePostLQA = lqState.selectedState.state;
                tempSCData.servicePostalCode = lqState.selectedState.zip;
            }
            else if (InHomeUtils.isNotEmpty(parserState) && InHomeUtils.isNotEmpty(parserZip)) {
                tempSCData.statePostLQA = parserState;
                tempSCData.servicePostalCode = parserZip;
            }
            tempSCData.detailPageName = "lq address verification - cache failure";
            //tempVzdlSCData.detail = "lq address verification - cache failure";
            if (InHomeUtils.isNotNull(lqState) && lqState.isoneLQFlow)
                tempSCData.events = "event5,event8,event88";
            else
                tempSCData.events = "event5,event8";

            //tempVzdlSCData.events = "event137,event160";
            vzdlSystemfailure(tempSCData.servicePostalCode, error?.message,addrID);
            updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
            //updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
            errorAction("ERROR", "RetrieveQual", error.message, "applogs", visitId, dispatch, false, "");
            loaderActive({ isLoaderActive: false }, dispatch);
            vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
        });
}

export const checkAddr = async (lqState, dispatch, visitId, email, mtn, isLqRetry = false, isLqRetryDataNull = false, nrTimeState, appState, revisitResponse = null, streetInputParser = null, isLq2Flow = false,validateSigninlq2Info=null , twsTransaction=false) => {
    let resetVisitId = false;
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.InsideCheckAddr, PAGEACTIVITY.UA));
        let addrID = (lqState.selectedUnit
            && lqState.selectedUnit.addressId
            && lqState.selectedUnit.addressId !== "N") ? lqState.selectedUnit.addressId :
            (lqState.selectedAdr
                && lqState.selectedAdr.addressID
                && lqState.selectedAdr.addressID !== "N") ? lqState.selectedAdr.addressID : revisitResponse && revisitResponse.addressId ? revisitResponse.addressId : lqState.streetAddrs && lqState.streetAddrs.length > 0  && lqState.streetAddrs[0].value && lqState.streetAddrs[0].value.addressID ? lqState.streetAddrs[0].value.addressID : "0";
        //Remove the unrequired junk characters in MTN Info
        if (InHomeUtils.isNotNull(mtn) && InHomeUtils.isNotEmpty(mtn)) {
            mtn = mtn.replace(/[^0-9]/g, '');
        }
        let changeinadrId = "N";
        if (InHomeUtils.isNotEmpty(lqState.addressIDSelected) && addrID !== lqState.addressIDSelected) {
            changeinadrId = "Y";
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.changeinadrId, PAGEACTIVITY.UA));
        }
        let mtnValue = (mtn && mtn !== "") ? '&mtn=' + mtn : "";
        let emailValue = (email && email !== "") ? '&email=' + email : "";
        let isRememberMe = lqState.isRememberMeChecked ? "Y" : "N";
        let state = lqState.selectedState && lqState.selectedState.state ? lqState.selectedState.state : lqState.selectedAdr && lqState.selectedAdr.state ? lqState.selectedAdr.state : revisitResponse && revisitResponse.state ? revisitResponse.state : lqState.streetAddrs && lqState.streetAddrs.length > 0 && lqState.streetAddrs[0].value && lqState.streetAddrs[0].value.state ? lqState.streetAddrs[0].value.state : "0";
        let zip = lqState.selectedState && lqState.selectedState.zip ? lqState.selectedState.zip : revisitResponse && revisitResponse.zip ? revisitResponse.zip : lqState.streetAddrs && lqState.streetAddrs.length > 0 && lqState.streetAddrs[0].value && lqState.streetAddrs[0].value.zip ? lqState.streetAddrs[0].value.zip : "0";
        let city = lqState.selectedState && lqState.selectedState.altCity ? lqState.selectedState.altCity : revisitResponse && revisitResponse.city ? revisitResponse.city : "";
        /* let unit = lqState.unitEntered ? lqState.unitEntered : ""; */
        let errorMsg = ''; let status = ''; let parserState = ''; let parserZip = '';
        let doCheckLQUrl = "";

        if (addrID === "0" && lqState.isoneLQFlow) {
            addrID = lqState.selectedState && lqState.selectedState.ntasAddrID ? lqState.selectedState.ntasAddrID : "0";
        }

        /* if ((lqState.selectedUnit === undefined || lqState.selectedUnit === null) && unit !== "") //unit typed [parser]
            addrID = 0  */

        //checking Moves Previous Page

        if (appState !== undefined && InHomeUtils.isNotNull(appState) &&
            appState.prevPage !== "" && appState.prevPage !== undefined &&
            appState.prevPage.pathname !== undefined && InHomeUtils.isNotNull(appState.prevPage.pathname) && appState.prevPage.pathname !== "" &&
            appState.prevPage.pathname.indexOf('/moves/') !== -1 && appState.flowType === "") {
            dispatch({
                type: "UPDATE_FLOWTYPE",
                value: {
                    flowType: "MV"
                }
            });
        }
        //movechange
        if (appState.flowType == "MV") {
            const isClassicUTD = lqState.isClassicUTD ? 'y' : 'n'
            doCheckLQUrl = apiUrl().checkAddr + parseInt(addrID) + "&state=" + state + '&zip=' + zip + mtnValue + emailValue + '&isRememberMe=' + isRememberMe + '&appId=' + appState.flowType + '&vCustId=' + lqState.vCustId + '&vAcctId=' + lqState.vAcctId + '&isClassicUTD=' + isClassicUTD ;
            console.log('DEBUG: DOCHECKLQ', doCheckLQUrl);
        }
        else if (InHomeUtils.isNotNull(validateSigninlq2Info) && InHomeUtils.isNotNull(validateSigninlq2Info.data)) {
            const isClassicUTD = lqState.isClassicUTD ? 'y' : 'n'
            doCheckLQUrl = apiUrl().checkAddr + addrID + "&state=" + lqState.selectedState.state + '&zip=' + lqState.selectedState.zip + mtnValue + emailValue + '&isRememberMe=' + isRememberMe + '&appId=MV&vCustId=' + validateSigninlq2Info.data.visionCustomerId + '&vAcctId=' + validateSigninlq2Info.data.visionAccountId + '&isClassicUTD=' + validateSigninlq2Info.data.isClassicUTD;
        }
        else {
            doCheckLQUrl = apiUrl().checkAddr + parseInt(addrID) + "&state=" + state + '&zip=' + zip + mtnValue + emailValue + '&isRememberMe=' + isRememberMe + lqState.agencyId;
        } 
        let isAcpFlow = false;
        let isTwsFlow = false;
        if(window.location && window.location.search){
            if(window.location.search.includes("acpFlow")){
                doCheckLQUrl = doCheckLQUrl + "&acpFlow=Y"
                isAcpFlow = true;
            }
            else if(window.location.search.includes("acpTestFlow")){
                doCheckLQUrl = doCheckLQUrl + "&acpTestFlow=Y"
                isAcpFlow = true;
            }
            else if(window.location.search.includes("vzfwd")){
                doCheckLQUrl = doCheckLQUrl + "&vzfwd=Y"
            }
            else if(window.location.search.includes("vfTestFlow")){
                doCheckLQUrl = doCheckLQUrl + "&vfTestFlow=Y"
            } 
            else if(window.location.search.includes('MN=Y') || window.sessionStorage.getItem('isMidnight') === 'true') {
                doCheckLQUrl = doCheckLQUrl + "&isMnFlow=Y";
            }

            if( twsTransaction && window.location.search.includes('type') && window.location.search.includes('code')){
                isTwsFlow = true;
                const search = window.location.search;
                const parameters = new URLSearchParams(search);
                let typeVal = InHomeUtils.isNotNull(parameters.get('type')) ? parameters.get('type') : '';
                let codeVal = InHomeUtils.isNotNull(parameters.get('code')) ? parameters.get('code') : '';
                let appendedString = '';
                if(typeVal){
                    if(typeVal === 'milvet'){
                        typeVal = 'military';
                    }
                    appendedString = appendedString+'&type=' + typeVal;
                }
                if(codeVal){
                    appendedString = appendedString+ '&code=' + codeVal;
                }
                doCheckLQUrl = doCheckLQUrl + appendedString;
            }
            else if (window.location.search.includes('type') && window.location.search.includes('code')){
                isTwsFlow = true;
            }
        }
        if (lqState.isQAMLessFlow) {
            doCheckLQUrl = doCheckLQUrl + "&isQamLess=Y";
        }

        if ((InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.couponFlowType)) ||
            (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.couponFlowStatus) && lqState.couponFlowStatus.indexOf("pending") > -1)) {
            if (InHomeUtils.isNotNull(lqState.couponFlowStatus) && lqState.couponFlowStatus.indexOf("pending") > -1) {
                doCheckLQUrl = doCheckLQUrl + "&isCareFlow=Y&isPendingToken=Y";
            }
            else {
                doCheckLQUrl = doCheckLQUrl + "&isCareFlow=Y";
            }
        }
        if (lqState.isFCPflow) {
            doCheckLQUrl = doCheckLQUrl + "&fcp=Y";
        }
        if (lqState.isoneLQFlow) {
            doCheckLQUrl = doCheckLQUrl + "&oneLQ=Y";
            let city1 = lqState.selectedAdr && lqState.selectedAdr.muni ? lqState.selectedAdr.muni : lqState.selectedAdr && lqState.selectedAdr.city ? lqState.selectedAdr.city : lqState.streetAddrs && lqState.streetAddrs.length > 0 && lqState.streetAddrs[0].value && lqState.streetAddrs[0].value.muni ? lqState.streetAddrs[0].value.muni : "";
            doCheckLQUrl = doCheckLQUrl + "&city=" + encodeURI(city1);
        }
        if (lqState.isamazonMovers) {
            doCheckLQUrl = doCheckLQUrl + "&amazonmovers=y"
        }
        if (lqState.showMarvel) {
            doCheckLQUrl = doCheckLQUrl + "&marvel=y"
        }
        if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.vendorName) && lqState.vendorName === "amazon") {
            doCheckLQUrl = doCheckLQUrl + "&vendorname=amazon"
        }

        let adr1 = "";
        if (!(parseInt(addrID))) {  //parser logic for both onelq and non-onelq 
            let adrentered = streetInputParser ? (streetInputParser.dispstr + " " + streetInputParser.muni + " " + streetInputParser.state + " " + streetInputParser.zip) : "";
            adr1 = lqState.selectedAdr && lqState.selectedAdr.dispstr ? lqState.selectedAdr.dispstr : lqState.selectedAdr && lqState.selectedAdr.street ? lqState.selectedAdr.street : adrentered ? adrentered : lqState.adrEntered ? lqState.adrEntered : "";
            /* if (adr1 !== "" && unit !== "")
                  adr1 = adr1 + " " + unit  //Commenting code for unit parser */
            if (!lqState.isoneLQFlow) {
                if (adr1 !== "" && city !== "" && state !== "")
                    adr1 = adr1 + "," + city + "," + state;
                if (adr1 === "")
                    adr1 = lqState.selectedAdr && lqState.selectedAdr.street ? lqState.selectedAdr.street : "";
            }
            if (adr1 !== "")
                doCheckLQUrl = doCheckLQUrl + "&addressLine1=" + encodeURI(adr1);
        }

        if (((!parseInt(zip) && !parseInt(state)) || (!parseInt(addrID) && adr1 === "")) && !lqState.isoneLQFlow) {
            // added to avoid address qualification when state, zip and addressID is 0            
            updateLBORedirectOOF(dispatch, 'Y');
            dispatch({ type: "ZIP_NOT_FOUND", value: null });
            loaderActive({ isLoaderActive: false }, dispatch);

            var lqError = new Error('LQ Error');
            var errorStack = lqError.stack.replace(/^[^\(]+?[\n$]/gm, '') // remove lines without '('
                .replace(/^\s+at\s+/gm, '') // remove prefix text ' at '
                .split('\n');
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', errorStack, PAGEACTIVITY.UA));
            return;
        }


        if (InHomeUtils.isNotNull(lqState) && lqState.selectedAdr && lqState.selectedAdr.multipleAddress && lqState.selectedAdr.multipleAddress === "Y")
            doCheckLQUrl = doCheckLQUrl + "&multiadr=Y"
        if (mtnValue !== '')
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.mtnEntered, PAGEACTIVITY.UA));
        if (emailValue !== '')
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.emailEntered, PAGEACTIVITY.UA));
        if (isRememberMe !== '' && isRememberMe === 'N')
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.RememberMe + '-N', PAGEACTIVITY.UA));

        let retrieveQualdetailsUrl = apiUrl().retrieveQualdetails;

        let NonFDVFlow = false;//fiosVoice alone not Qualified.
        let fDataQualified = false;
        let fVideoQualified = false;
        let hsiFlow = false; //non-fios flow
        let lennarFlow = false; //lennar eligible customers
        let qualificationString = 'QUALIFIED-';
        let qualResponse = null;
        let isLQSuccess = false;
        let connectionFlow = (lqState && InHomeUtils.isNotNull(lqState.couponFlowType) && (lqState.couponFlowType === "Employee" || lqState.couponFlowType === "Retiree" || lqState.couponFlowType === "Affinity"));
        return api(doCheckLQUrl, 'GET', '').then(async response => {            
           /* if (!response) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', "LQ Response is empty or null", PAGEACTIVITY.UA));
                errorMsg = "LQResponseNull";
            }
            // if(!response.data.isFCP && (window.location.pathname.indexOf('/inhome/buildproductsRskn')>-1)){
            //     let params = window.location.search
            //     dispatch({type: 'UPDATERESKIN', value: false});
            //     window.location.href = `/inhome/buildproducts${params}`;
            //     return true;
            // }
            if(response.data?.isRuralBroadBandAddress){
                dispatch({ type: 'IS_RURAL_BROADBAND_ADDRESS', value: true });
            }
            if(lqState && lqState.runtimeKey && lqState.runtimeKey.EnableMHFiosSignIn && lqState.runtimeKey.EnableMHFiosSignIn === "Y" && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && response.data.wirelessPlanType && (response.data.wirelessPlanType === 'METERED' ||response.data.wirelessPlanType === 'UNLIMITED')
               && !(window.location.href.indexOf('lq2=y') > -1)){
                callValidateAPI();
            }
            console.log(lqState && lqState.runtimeKey && lqState.runtimeKey.isVECEnabled && lqState.runtimeKey.isVECEnabled === "Y" && InHomeUtils.isNotNull(response) && response.data && response.data.hoaFlag === "Y",'cond1');
            console.log(lqState && lqState.runtimeKey && lqState.runtimeKey.isVECEnabled && lqState.runtimeKey.isVECEnabled === "Y",'cond2');
            console.log(InHomeUtils.isNotNull(response) && response.data && response.data.hoaFlag === "Y", 'cond3');
            console.log(response.data.hoaFlag, 'hoa');
            if( lqState && lqState.runtimeKey && lqState.runtimeKey.mnhAuthCustomerRibbon && lqState.runtimeKey.mnhAuthCustomerRibbon === "Y" &&
                InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && response.data.wirelessPlanType && (response.data.wirelessPlanType === 'METERED' || response.data.wirelessPlanType === 'UNLIMITED')){
                callGetNameMnhDetails(dispatch);
                console.log(lqState && lqState.runtimeKey && lqState.runtimeKey.isVECEnabled && lqState.runtimeKey.isVECEnabled === "Y" && InHomeUtils.isNotNull(response) && response.data && response.data.hoaFlag === "Y",'cond2');
            }
            
            // FIOSVEC-4 Lift change order restriction
            else if (lqState && lqState.runtimeKey && lqState.runtimeKey.isVECEnabled && lqState.runtimeKey.isVECEnabled === "Y" && InHomeUtils.isNotNull(response) && response.data && response.data.hoaFlag === "Y" ) {
                updateHoaFlow(true, dispatch);
                lqState.hoaFlowDetails = { isHoaFlow: true };
               
            }*/
           /* if (InHomeUtils.isNotNull(response) && !response.data) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', "Data null", PAGEACTIVITY.UA));
                errorMsg = "DataNull";
                if (InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.status))
                    status = response.response.status;
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.message)) {
                errorMsg = response.message;
                if (InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.status))
                    status = response.response.status;
            } */
            try {
               /* if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && ((InHomeUtils.isNotNull(response.data.fiveG) && response.data.fiveG) || (InHomeUtils.isNotNull(response.data.qualified4GHome) && response.data.qualified4GHome) || (InHomeUtils.isNotNull(response.data.qualifiedCBand) && response.data.qualifiedCBand))) {
                    dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: response.data });

                    if (response.data.fiveG || response.data.qualifiedCBand) {
                        update5GRecommended(dispatch, true);
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkfor5G', PAGEACTIVITY.MSG.CaptchaShown, PAGEACTIVITY.UA));
                        updateSCTags("lq check avail - captcha 5G shown");
                        update5GResponse(dispatch, response.data);
                        redirectTo(Pages.nonfiosRedirect, dispatch);
                    } else if (response.data.qualified4GHome) {
                        update4GRecommended(dispatch, true);
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkfor4G', PAGEACTIVITY.MSG.CaptchaShown, PAGEACTIVITY.UA));
                        updateSCTags("lq check avail - captcha 4G shown");
                        update5GResponse(dispatch, response.data);
                        redirectTo(Pages.nonfiosRedirect, dispatch);
                    }
                    if (lqState.captchaState === "COMPLETED" || lqState.captchaState === "VERIFIED") {
                        if (lqState.is4GRecommended) {
                            tempSCData.detailPageName = "lq address verification - lte eligible - Redirecting to Wireless";
                            tempVzdlSCData.detail = "lq address verification - lte eligible - Redirecting to Wireless";
                        }
                        else if (lqState.is5GRecommended) {
                            tempSCData.detailPageName = "lq address verification - 5G eligible - Redirecting to Wireless";
                            tempVzdlSCData.detail = "lq address verification - 5G eligible - Redirecting to Wireless";
                        }
                        else {
                            tempSCData.detailPageName = "lq address verification - captcha Issue";
                        }
                        tempSCData.events = "event5,event8,event88";
                        if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                            tempSCData.statePostLQA = lqState.selectedState.state;
                            tempSCData.servicePostalCode = lqState.selectedState.zip;
                        }
                        else if (response.data.state && response.data.zip) {
                            tempSCData.statePostLQA = response.data.state;
                            tempSCData.servicePostalCode = response.data.zip;
                        }
                        updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                        tempVzdlSCData.events = "event137,event160";
                        updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
                        //console.log("FiveG Success");   
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, '5G', PAGEACTIVITY.MSG.FIVEG, PAGEACTIVITY.UA));
                        let addressString = response.data.encryptedAddressFor5G ? response.data.encryptedAddressFor5G : "";
                        window.location.href = apiUrl().Wireless5Gurl
                    }
                    else {
                        loaderActive({ isLoaderActive: false }, dispatch);
                        update5GRecommended(dispatch, true);
                        updateCaptcha(dispatch, 'INITIATED');
                        updateStateLocus(lqState.selectedAdr, dispatch, true);
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.CaptchaShown, PAGEACTIVITY.UA));
                        updateSCTags("lq check avail - captcha 5G shown");
                    }

                    return;
                }
                else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.hoaFlag) && response.data.hoaFlag === "Y" && ((InHomeUtils.isNotNull(response.data.availableFlag) && response.data.availableFlag === "N") || InHomeUtils.isNull(response.data.availableFlag))) {
                    updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'HOA', PAGEACTIVITY.MSG.HOA, PAGEACTIVITY.UA));
                    errorAction("LBO", "CheckLQ", "HOA", "", visitId, dispatch, true, "HOA");
                }
                else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.hoaFlag) && response.data.hoaFlag === "Y" && (!(InHomeUtils.isNotEmpty(lqState.runtimeKey) && InHomeUtils.isNotNull(lqState.runtimeKey.EnableHOA) && lqState.runtimeKey.EnableHOA === "Y") || appState.flowType === "MV" || connectionFlow || (inservice && lqState && lqState.runtimeKey && lqState.runtimeKey.EnableVEC_ExistService === 'Y'))) {
                    tempSCData.detailPageName = "lq address verification - HOA eligible";
                    tempVzdlSCData.detail = "lq address verification - HOA eligible";

                    if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                        tempSCData.statePostLQA = lqState.selectedState.state;
                        tempSCData.servicePostalCode = lqState.selectedState.zip;
                    }
                    if (InHomeUtils.isNotNull(lqState) && lqState.isoneLQFlow)
                        tempSCData.events = "event5,event8,event88";
                    else
                        tempSCData.events = "event5,event8";

                    updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'HOA', PAGEACTIVITY.MSG.HOA, PAGEACTIVITY.UA));
                    errorAction("LBO", "CheckLQ", "HOA", "", visitId, dispatch, true, "HOA");
                }
                //movechange
                else if (appState.flowType == "MV" && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && response.data.mvStopOrder !== undefined && response.data.mvStopOrder) {
                    tempSCData.detailPageName = "lq address verification - MoveStopOrder eligible";
                    tempVzdlSCData.detail = "lq address verification - MoveStopOrder eligible";
                    if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                        tempSCData.statePostLQA = lqState.selectedState.state;
                        tempSCData.servicePostalCode = lqState.selectedState.zip;
                    }
                    if (InHomeUtils.isNotNull(lqState) && lqState.isoneLQFlow)
                        tempSCData.events = "event5,event8,event88";
                    else
                        tempSCData.events = "event5,event8";
                    updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                    errorAction("LBO", "CheckLQ", "mvStopOrder", "", visitId, dispatch, true, "mvStopOrder");
                    vzdlErrorUpdate(response.meta.code, "mvStopOrder");
                }*/
                 if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) &&
                    (InHomeUtils.getIndexOf(response.meta.code, '200') || InHomeUtils.getIndexOf(response.meta.code, '200.01')) && InHomeUtils.isNotNull(response.data)) {
                    /*if (response.data.parsedAddress && response.data.parsedAddress.length > 1) {
                        loaderActive({ isLoaderActive: false }, dispatch);
                        //console.log('CheckLQ.suggestedAddress', CheckLQ.suggestedAddress || 'not found');
                        const dispatchValue = { type: CheckLQ.suggestedAddress, value: response.data.parsedAddress };
                        dispatch(dispatchValue);
                    }
                    else if (response.data && response.data.futureNotification && response.data.futureNotification === "Y") {
                        dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: response.data });
                        loaderActive({ isLoaderActive: false }, dispatch);
                        redirectTo(Pages.FutureNotification, dispatch);
                    }*/
                     if (response.data.services) {
                        isLQSuccess = true;
                        /*if (response.data.parsedAddress && response.data.parsedAddress.length === 1) {
                            setParsedaddress(dispatch, response.data.parsedAddress[0]);
                            parserState = response.data.parsedAddress[0].state;
                            parserZip = response.data.parsedAddress[0].zipCode;
                        }*/
                        const dispatchValue = { type: CheckLQ.suggestedAddress, value: [] };
                        dispatch(dispatchValue);
                        if (InHomeUtils.isNotNull(response.data.isFCP)) {
                            isFCPflow(response.data.isFCP, dispatch);
                        }
                       /* response.data.services.forEach(key => {
                            if (Service.hsi.indexOf(key.servicename.toUpperCase()) >= 0 && key.qualified === "Y") {
                                qualificationString = qualificationString + Service.hsi + ',';
                            }
                            else if (Service.voice.indexOf(key.servicename.toUpperCase()) >= 0) {
                                if (key.qualified === "Y") {
                                    qualificationString = qualificationString + Service.voice + ',';
                                } //else {
                                //     NonFDVFlow = true;
                                // }
                            }
                            else if (Service.FiOSData.indexOf(key.servicename.toUpperCase()) >= 0 && key.qualified === "Y") {
                                qualificationString = qualificationString + Service.FiOSData + ',';
                            }
                            else if (Service.video.indexOf(key.servicename.toUpperCase()) >= 0 && key.qualified === "Y") {
                                qualificationString = qualificationString + Service.video + ',';
                            }
                        }
                        );
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', qualificationString, PAGEACTIVITY.UA));
                        //Temporary fix  if (qualificationString === "QUALIFIED-HSI,")
                        if (qualificationString === "QUALIFIED-" || qualificationString === "QUALIFIED-HSI,")
                            hsiFlow = true;
                        else {
                            if (!InHomeUtils.getIndexOf(qualificationString, Service.voice)) {
                                NonFDVFlow = true;

                                if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                                    tempSCData.statePostLQA = lqState.selectedState.state;
                                    tempSCData.servicePostalCode = lqState.selectedState.zip;
                                }
                                else if (InHomeUtils.isNotEmpty(parserState) && InHomeUtils.isNotEmpty(parserZip)) {
                                    tempSCData.statePostLQA = parserState;
                                    tempSCData.servicePostalCode = parserZip;
                                }
                                tempSCData.detailPageName = "lq address verification - Non FDV eligible";
                                //tempVzdlSCData.detail = "lq address verification - Non FDV eligible";
                                if (InHomeUtils.isNotNull(lqState) && lqState.isoneLQFlow)
                                    tempSCData.events = "event5,event8,event88";
                                else
                                    tempSCData.events = "event5,event8";

                                updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                                //tempVzdlSCData.events = "event137,event160";
                                //updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
                            }

                        }*/
                        //lennar change                    
                      /*  if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.isLennarEligible)) {
                            if (response.data.isLennarEligible === 'Y')
                                lennarFlow = true;
                        }
                        if (hsiFlow || lennarFlow) {
                            var Qstring = "";
                            if(InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedAdr)){
                                updateLQZip(lqState.selectedAdr.zip);
                            }
                            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                                tempSCData.statePostLQA = lqState.selectedState.state;
                                tempSCData.servicePostalCode = lqState.selectedState.zip;
                                updateLQZip(lqState.selectedState.zip);
                            }
                            else if (InHomeUtils.isNotEmpty(parserState) && InHomeUtils.isNotEmpty(parserZip)) {
                                tempSCData.statePostLQA = parserState;
                                tempSCData.servicePostalCode = parserZip;
                                updateLQZip(parserZip);
                            }
                            tempSCData.detailPageName = "lq address verification";
                            tempVzdlSCData.detail = "lq address verification";
                            if (InHomeUtils.isNotNull(lqState) && lqState.isoneLQFlow)
                                tempSCData.events = "event5,event8,event88";
                            else
                                tempSCData.events = "event5,event8";

                            updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                            tempVzdlSCData.events = "event137,event160";
                            updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
                            Qstring = "?src=frmAtom";
                            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.accessCode) && lqState.accessCode) {
                                Qstring += "&mfrtflow=Y";
                            }
                            if (lqState.isoneLQFlow)
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.OneLqredirectingBAU, PAGEACTIVITY.UA));
                            else
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.redirectingBAU, PAGEACTIVITY.UA));
                            dispatch({ type: 'REDIRECTINGFYH', value: "Y" });
                            var host = window.location.host;
                            if (host.indexOf("orderinglite") > -1)
                                window.location.href = Pages.CheckAvailPilot + Qstring;
                            else
                                if (appState.flowType == "MV") {
                                    //window.location.href = Pages.CheckAvailFromMoves + "?src=frmAtom&mvfrmAtom=Y&ISMVFLOW=Y";
                                    errorAction("LBO", "CheckLQ", "HsiLQ", "", visitId, dispatch, true, "HsiLQ");
                                } else {
                                    if (response.data.qualified4GHome) {
                                        dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: response.data });
                                        redirectTo(Pages.nonfiosRedirect, dispatch);
                                    } else {
                                        window.location.href = Pages.CheckAvail + Qstring;
                                    }
                                }
                            return;
                        }*/

                        // const qParam  = window.location.search;   
                       /* if (!isLq2Flow) {
                            dispatch({ type: 'EMPTYBUILDFIOSSTATE', value: "" });
                            dispatch({ type: CartActions.clearcartstate, value: "" });
                            emptyCheckoutState(dispatch);
                        }
                        let addrIdsel = lqState && lqState.selectedAdr && lqState.selectedAdr.addressID;
                        dispatch({ type: 'ADDRESSID', value: addrIdsel });
                        if (lqState.quickCheckout) {
                            updateCheckoutBtnStatus(true, dispatch);
                        }*/
                        //Call runtime Entry Configuration
                        //updateRuntimeKeys(dispatch, "LQ");
                       /* if (!hsiFlow && !lennarFlow) {
                            if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                                tempSCData.statePostLQA = lqState.selectedState.state;
                                tempSCData.servicePostalCode = lqState.selectedState.zip;
                            }
                            else if (InHomeUtils.isNotEmpty(parserState) && InHomeUtils.isNotEmpty(parserZip)) {
                                tempSCData.statePostLQA = parserState;
                                tempSCData.servicePostalCode = parserZip;
                            }
                            //dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: response.data });
                            //loaderActive({ isLoaderActive: false }, dispatch);
                            if (!NonFDVFlow) {
                                if (!isLq2Flow) {
                                    if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                                        tempSCData.statePostLQA = lqState.selectedState.state;
                                        tempSCData.servicePostalCode = lqState.selectedState.zip;
                                        tempVzdlSCData.detail = "existing service";
                                        updateVzdlObjectValues("pageView", { ...lqState.selectedState, addressID: addrID }, "pageViewOmni", response.data, visitId);
                                    }
                                    else if (InHomeUtils.isNotEmpty(parserState) && InHomeUtils.isNotEmpty(parserZip)) {
                                        tempSCData.statePostLQA = parserState;
                                        tempSCData.servicePostalCode = parserZip;
                                        tempVzdlSCData.detail = "existing service";
                                        updateVzdlObjectValues("pageView", { zip: parserZip, addressID: addrID }, "pageViewOmni", response.data, visitId);
                                    }
                                    tempSCData.detailPageName = "lq address verification";

                                    if (InHomeUtils.isNotNull(lqState) && lqState.isoneLQFlow)
                                        tempSCData.events = "event5,event8,event88";
                                    else
                                        tempSCData.events = "event5,event8";
                                    updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                                    tempVzdlSCData.events = "event137,event160";
                                    tempVzdlSCData.detail = "lq address verification";
                                  
                                  try{
                                    setTimeout(() => {
                                    updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
                                    }, 1000);  
                                }
                            catch{
                                console.log('updateVzdlSCCustomEvent');
                            }}
                                //S&H Fee Changes 
                                if (InHomeUtils.isNotEmpty(lqState.selectedAdr) && InHomeUtils.isNotEmpty(lqState.selectedAdr)) {
                                    let buffalozips = BuffaloDMA.BuffaloDMA;
                                    for (let dmacount = 0; dmacount < buffalozips.length; dmacount++) {
                                        if (buffalozips[dmacount] === parseInt(lqState.selectedAdr.zip)) {
                                            dispatch({ type: CheckLQ.isBuffalloDMA, value: true })
                                        }
                                    }
                                }
                            }

                            if (lqState.isoneLQFlow) {
                                if (NonFDVFlow)
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.OneLqNonFDVEligible, PAGEACTIVITY.UA));
                                else
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.OneLqFiosQual, PAGEACTIVITY.UA));
                            }*/
                            
                            // dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: response.data });
                            // servicesQualified(response.data, dispatch);
                            // qualResponse = response;
                            // let mnhCheckoutData = null;
                            // if (lqState && lqState.mnh && lqState.mnh.mnhFlow) {
                            //     mnhCheckoutData = await getMnhCheckoutInfo(dispatch, visitId, lqState.mnh.isMNHQS, lqState.mnh.isChangeAdr, lqState);
                            // }
                            // api(retrieveQualdetailsUrl, 'GET', '').then(response => {
                            //     if (InHomeUtils.isNull(response) || response === "") {
                            //         errorMsg = "RetrievequalResponseNull";
                            //     }
                            //     if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                            //         dispatch({ type: 'LQ_ON_RETRIEVE_QUALDETAILS', value: response.data });
                            //         if(response.data?.getBroadbandAvailabilityResult?.fttpAvailabilityDetailsAGR?.isRuralBroadBandAddress){
                            //             dispatch({ type: 'IS_RURAL_BROADBAND_ADDRESS', value: true });
                            //         }     
                            //         let nsiIndicator = "";
                            //         if (InHomeUtils.isNotNull(response.data.addressValidationRecordAGR) && response.data.addressValidationRecordAGR.length) {
                            //             nsiIndicator = response.data.addressValidationRecordAGR[0].nonStandardAddressFlag;
                            //             dispatch({ type: 'NSI_INDICATOR', value: nsiIndicator });
                            //             if (nsiIndicator === "Y") {
                            //                 let nsiUrl = apiUrl().nsiNotify
                            //                 api(nsiUrl, 'POST', getNsiRequest(addrID, lqState.selectedState.state)).then(response => {
                            //                     if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                            //                         dispatch({ type: 'NSI_STATUS', value: response.data });
                            //                     }
                            //                     else if (InHomeUtils.isNull(response) || (InHomeUtils.isNotNull(response) && (InHomeUtils.getIndexOf(response.meta.code, '500') || InHomeUtils.getIndexOf(response.meta.code, '400')))) {
                            //                         dispatch({ type: 'NSI_FAILED', value: true });
                            //                     }
                            //                 })
                            //             }
                            //         }
                            //         if (InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR)
                            //             && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.ofsPresaleEligible) && response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.ofsPresaleEligible === "Y") {
                            //             dispatch({ type: "PRESALE_ELIGIBLE", value: true })
                            //             if (response.data.getAdditionalInfo !== null && response.data.getAdditionalInfo !== undefined && response.data.getAdditionalInfo.ofsEstimateDays !== "") {
                            //                 dispatch({ type: "PRESALE_ESTIMATEDAYS", value: response.data.getAdditionalInfo.ofsEstimateDays })
                            //             }
                            //         }
                            //         if (InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR)
                            //             && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent) && response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent === "Y") {
                            //             logOtherInfo(detailsInfo('loopQual', visitId, 'checkAddr', "IONT Eligible", PAGEACTIVITY.UA));
                            //             dispatch({ type: "IONT_ELIGIBLE", value: true })
                            //             dispatch({ type: "IONT_STATUS", value: true })
                            //             tempSCData.IONTEligible = true;
                            //             isIONTAddr = true;
                            //         }
                            //         if (InHomeUtils.isNotNull(response.data.getAdditionalInfo) && InHomeUtils.isNotNull(response.data.getAdditionalInfo.isBOSTONDMA)) {
                            //             dispatch({ type: "BOSTONDMA", value: response.data.getAdditionalInfo.isBOSTONDMA })
                            //         }
                            //         //Advantage Offer
                            //         if (InHomeUtils.isNotNull(response.data.getAdditionalInfo) && InHomeUtils.isNotEmpty(response.data.getAdditionalInfo.vzwOffer)) {
                            //             updateVZWResponse(dispatch, response.data.getAdditionalInfo.vzwOffer)
                            //         }
                            //         if (!isLq2Flow) {
                            //             qualResponseHandling(dispatch, qualResponse, lqState, visitId, email, mtn, nrTimeState, appState.flowType, mnhCheckoutData);
                            //         }
                            //         //set bannerType on LQ success
                            //         setBannerType(dispatch, lqState, visitId, qualResponse.data);
                            //         if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.vendorName) && lqState.vendorName === "amazon")
                            //             loaderActive({ isLoaderActive: false }, dispatch);

                            //     }
                            //     else {
                            //         let errMsg = ""; let stat = "";
                            //         if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && (response.meta.code))
                            //             stat = response.meta.code;
                            //         loaderActive({ isLoaderActive: false }, dispatch);
                            //         if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.message)) {
                            //             errMsg = response.message;
                            //             if (InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.status))
                            //                 stat = response.response.status;
                            //         }
                            //         if (errMsg !== "" || stat !== "")
                            //             logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr_RetrieveQual', PAGEACTIVITY.MSG.lqError + "-" + errMsg + " - " + stat, PAGEACTIVITY.UA));
                            //     }
                            // })
                            //     .catch(error => {
                            //         logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lqError + "-" + "CatchBlock1" + " - " + error.message, PAGEACTIVITY.UA));
                            //         if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                            //             tempSCData.statePostLQA = lqState.selectedState.state;
                            //             tempSCData.servicePostalCode = lqState.selectedState.zip;
                            //         }
                            //         else if (InHomeUtils.isNotEmpty(parserState) && InHomeUtils.isNotEmpty(parserZip)) {
                            //             tempSCData.statePostLQA = parserState;
                            //             tempSCData.servicePostalCode = parserZip;
                            //         }
                            //         tempSCData.detailPageName = "lq address verification - cache failure";
                            //         //tempVzdlSCData.detail = "lq address verification - cache failure";
                            //         if (InHomeUtils.isNotNull(lqState) && lqState.isoneLQFlow)
                            //             tempSCData.events = "event5,event8,event88";
                            //         else
                            //             tempSCData.events = "event5,event8";

                            //         //tempVzdlSCData.events = "event137,event160";
                            //         vzdlSystemfailure(tempSCData.servicePostalCode, error?.message,addrID);
                            //         updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                            //         //updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
                            //         errorAction("ERROR", "RetrieveQual", error.message, "applogs", visitId, dispatch, false, "");
                            //         loaderActive({ isLoaderActive: false }, dispatch);
                            //         vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                            //     });
                            loaderActive({ isLoaderActive: false }, dispatch);
                            let checkAddrResponse = response
                            retriveQualification(checkAddrResponse, visitId, lqState, dispatch,addrID,zip,isTwsFlow,isAcpFlow,mtnValue,emailValue, isLq2Flow, appState)
                       // }
                        // qParam.indexOf('stadia=Y') > -1 && dispatch({type: BuildProduct.showStadiaOffer, showStadia:true});
                    }
                    //https://api.verizon.com/atomapi/v1/addressqualification/address/qualification?addressID=0&state=TX&zip=75038&isRememberMe=Y&oneLQ=Y&city=IRVING&addressLine1=5307%20N%20MACARTHUR%20BLVD
                    //{"meta":{"code":200.01,"description":"Qualification  Completed successfully .","timestamp":"Wed Aug 07 20:48:42 UTC 2019"},"data":{"fiveG":false,"addressNotFound":false,"encryptedAddressFor5G":""}}
                    //time beting addressNotFound =true or false - below scanrio sendinng to OOF pagee in oneLQ- anyhow this scanrio need to OOF Only 
                    else if (response.data.addressNotFound || lqState.isoneLQFlow) {
                        //dispatch({ type: "LQ_CANT_FIND_ADDRESS_CLICKED", value: true }); 
                        //redirectTo(Pages.Help, dispatch)     
                        loaderActive({ isLoaderActive: false }, dispatch)
                        if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                            tempSCData.statePostLQA = lqState.selectedState.state;
                            tempSCData.servicePostalCode = lqState.selectedState.zip;
                        }
                        else if (InHomeUtils.isNotEmpty(parserState) && InHomeUtils.isNotEmpty(parserZip)) {
                            tempSCData.statePostLQA = parserState;
                            tempSCData.servicePostalCode = parserZip;
                        }
                        tempSCData.detailPageName = "lq address verification - Address not found";
                        tempVzdlSCData.detail = "lq address  - Address not found";
                        if (InHomeUtils.isNotNull(lqState) && lqState.isoneLQFlow)
                            tempSCData.events = "event5,event8,event88";
                        else
                            tempSCData.events = "event5,event8";

                        updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                        tempVzdlSCData.events = "event137,event160";
                        updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.AddressNotFound, PAGEACTIVITY.UA));
                        dispatch({ type: "STREET_NOT_FOUND", value: null });
                        if (response.data.state && response.data.zip) {
                            tempSCData.statePostLQA = response.data.state
                            tempSCData.servicePostalCode = response.data.zip
                        }
                        tempSCData.detailPageName = "street address oof";
                        tempVzdlSCData.detail = "street address oof";
                        updateSCcustomEvent("outOfFranchise", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                        updateVzdlSCCustomEvent("outOfFranchise", "pageViewOmni", "detail");
                    }
                }
                else if (!isLqRetry) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lqRetry, PAGEACTIVITY.UA));
                    isLqRetry = true;
                    resetVisitId = await checkAddr(lqState, dispatch, visitId, emailValue, mtnValue, isLqRetry, false, "", appState, revisitResponse, streetInputParser, isLq2Flow, validateSigninlq2Info, twsTransaction);
                }
                else {
                    if (!isLq2Flow) {
                        if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                            tempSCData.statePostLQA = lqState.selectedState.state;
                            tempSCData.servicePostalCode = lqState.selectedState.zip;
                        }
                        else if (InHomeUtils.isNotEmpty(parserState) && InHomeUtils.isNotEmpty(parserZip)) {
                            tempSCData.statePostLQA = parserState;
                            tempSCData.servicePostalCode = parserZip;
                        }
                        tempSCData.detailPageName = "lq address verification";
                        tempVzdlSCData.detail = "lq address verification";
                        if (InHomeUtils.isNotNull(lqState) && lqState.isoneLQFlow)
                            tempSCData.events = "event5,event8,event88";
                        else
                            tempSCData.events = "event5,event8";

                        updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                        tempVzdlSCData.events = "event137,event160";
                        updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
                    }
                    let errMessge = "MethodName:loopQual,errorMessage:API response error";
                    if (status === "" && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code))
                        status = response.meta.code;
                    if (errorMsg !== "" || status !== "")
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr_error1', PAGEACTIVITY.MSG.lqError + "-" + errorMsg + " - " + status, PAGEACTIVITY.UA));

                    if ((status === 404 || status === 401 || status === 405) || (status === "404" || status === "401" || status === "405")) {
                        if (status !== '') {
                            errorAction("LBO", "CheckLQ", errMessge, "applogs", visitId, dispatch, true, "GBBERR-" + status);
                            vzdlErrorUpdate(response.meta.code, "GBBERR-" + status);
                            emptyLQState(dispatch);
                        }
                        loaderActive({ isLoaderActive: false }, dispatch);
                    }
                    else if (errorMsg === "DataNull") {
                        if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.lqResponse) && InHomeUtils.isNotNull(lqState.lqResponse.services) && lqState.lqResponse.services.length > 0 && lqState.lqResponse.services[0].servicename === "FiOSData" && lqState.lqResponse.services[0].qualified === "Y") {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lqDataNullProceed, PAGEACTIVITY.UA));
                            loaderActive({ isLoaderActive: false }, dispatch);
                        }
                        else if (!isLqRetryDataNull) {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lqDataNullRetry, PAGEACTIVITY.UA));
                            isLqRetryDataNull = true;
                            resetVisitId = await checkAddr(lqState, dispatch, visitId, emailValue, mtnValue, isLqRetry, isLqRetryDataNull, "", appState, revisitResponse, streetInputParser, isLq2Flow, validateSigninlq2Info, twsTransaction);
                        }
                        else {
                            updateLBORedirectOOF(dispatch, 'Y');
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lboRedirectOOF, PAGEACTIVITY.UA));
                            // dispatch({ type: "STREET_NOT_FOUND", value: null });
                            dispatch({ type: "ZIP_NOT_FOUND", value: null });
                            loaderActive({ isLoaderActive: false }, dispatch);
                            InHomeUtils.clearMemory();
                            resetVisitId = true;
                            updateLBORedirectOOF(dispatch, 'Y');
                        }
                    }
                    else {
                        updateLBORedirectOOF(dispatch, 'Y');
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lboRedirectOOF, PAGEACTIVITY.UA));
                        // dispatch({ type: "STREET_NOT_FOUND", value: null });
                        dispatch({ type: "ZIP_NOT_FOUND", value: null });
                        loaderActive({ isLoaderActive: false }, dispatch);
                        if (isLqRetry || isLqRetryDataNull) {
                            InHomeUtils.clearMemory();
                            resetVisitId = true;
                            updateLBORedirectOOF(dispatch, 'Y');
                        }
                    }
                }
            }
            catch (ex) {

            }

            // One Signal API Changes
           /* try {
                if ((InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotEmpty(lqState.runtimeKey.PushNotification) && lqState.runtimeKey.PushNotification === "Y")) {
                    console.log("Invoked oneSignal API in LQ");
                    console.log(lqState.runtimeKey.OneSignalAppID);
                    let LQStatus = isLQSuccess ? "SUCCESS" : "FAILURE"
                    //let visitId = this.props.appState.visitId;
                    window.OneSignal.push(function () {
                        console.log("Invoked push");

                        window.OneSignal.sendTags({
                            "Pagename": "LQ",
                            "App_id": "inhome",
                            "Flow": "Desktop",
                            "SessionID": visitId,
                            "Order_Submit": "N",
                            "LQStatus": LQStatus
                        }).then(function (tagsSent) {
                            // Callback called when tags have finished sending 
                            console.log("tagsSent: ", tagsSent);
                        });

                    });
                }
            }
            catch (e) {
                console.log("exception while invoking oneSignal API in LQ" + e);
            }*/
            return resetVisitId;
        })
            .catch(error => {
                if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.selectedState)) {
                    tempSCData.statePostLQA = lqState.selectedState.state;
                    tempSCData.servicePostalCode = lqState.selectedState.zip;
                }
                else if (InHomeUtils.isNotEmpty(parserState) && InHomeUtils.isNotEmpty(parserZip)) {
                    tempSCData.statePostLQA = parserState;
                    tempSCData.servicePostalCode = parserZip;
                }
                tempSCData.detailPageName = "lq address verification - cache failure";
                //tempVzdlSCData.detail = "lq address verification - cache failure";
                if (InHomeUtils.isNotNull(lqState) && lqState.isoneLQFlow)
                    tempSCData.events = "event5,event8,event88";
                else
                    tempSCData.events = "event5,event8";
                vzdlSystemfailure(tempSCData.servicePostalCode, error?.message,addrID);
                updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                //tempVzdlSCData.events = "event137,event160";
                //updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
                if (error.message !== '')
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lqError + "-" + "CatchBlock2" + " - " + error.message, PAGEACTIVITY.UA));
                if (status !== '') {
                    errorAction("LBO", "CheckLQ", error.message, "applogs", visitId, dispatch, true, "GBBERR-" + status);
                    vzdlErrorUpdate(error.code, "GBBERR-" + status);
                }
                else if (errorMsg === "RetrievequalResponseNull" || errorMsg === "LQResponseNull" || errorMsg === "DataNull") {
                    errorAction("LBO", "CheckLQ", error.message, "applogs", visitId, dispatch, true, "GBBERR-" + errorMsg);
                    vzdlErrorUpdate(error.code, "GBBERR-" + errorMsg);
                }
                else if (errorMsg !== '') {
                    errorAction("LBO", "CheckLQ", error.message, "applogs", visitId, dispatch, true, "GBBERR-Null");
                    vzdlErrorUpdate(error.code, "GBBERR-" + "GBBERR-Null");
                }
                if (checkAdrAPICount < 3) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lqRetry, PAGEACTIVITY.UA));
                    isLqRetry = true;
                    checkAdrAPICount = checkAdrAPICount + 1;
                    checkAddr(lqState, dispatch, visitId, emailValue, mtnValue, isLqRetry, false, "", appState, revisitResponse, streetInputParser, isLq2Flow, validateSigninlq2Info, twsTransaction);
                }
                else
                    errorAction("LBO", "CheckLQ", error.message, "applogs", visitId, dispatch, true, "GBBERR");
                emptyLQState(dispatch);
                loaderActive({ isLoaderActive: false }, dispatch);
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                return resetVisitId;
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'checkAddr', ex);
        return resetVisitId;
    }
};

export const servicesQualified = (lqResponse, dispatch) => {
    let servicesQualified = {
        isDataQualified: false,
        isHsiQualified: false,
        isVideoQualified: false,
        isVoiceQualified: false
    };
    let qualificationStatus = false;
    if (InHomeUtils.isNotEmpty(lqResponse) && InHomeUtils.isNotEmpty(lqResponse.services) && lqResponse.services.length > 0) {
        for (let serviceCount = 0; serviceCount <= lqResponse.services.length; serviceCount++) {
            if (InHomeUtils.isNotEmpty(lqResponse.services[serviceCount])) {
                qualificationStatus = lqResponse.services[serviceCount].qualified === "Y";
                if (lqResponse.services[serviceCount].servicename.toUpperCase() === Service.FiOSData) {
                    servicesQualified.isDataQualified = qualificationStatus;
                }
                else if (lqResponse.services[serviceCount].servicename.toUpperCase() === Service.video) {
                    servicesQualified.isVideoQualified = qualificationStatus;
                }
                else if (lqResponse.services[serviceCount].servicename.toUpperCase() === Service.FiOSVoice) {
                    servicesQualified.isVoiceQualified = qualificationStatus;
                }
                else if (lqResponse.services[serviceCount].servicename.toUpperCase() === Service.hsi) {
                    servicesQualified.isHsiQualified = qualificationStatus;
                }
            }
        }
        dispatch({ type: 'LQ_SET_QUALIFIED_SERVICES', value: servicesQualified });
    }
}

export const qualResponseHandling = (dispatch, qualResponse, lqState, visitId, email, mtn, nrTimeState, flowType, mnhCheckoutData = null) => {
    try {
        let smartCartStatusResponse = '';
        if ((qualResponse.data.isFCP && lqState.mfrtType) &&
            InHomeUtils.isNotNull(qualResponse.data.services) &&
            qualResponse.data.services.length > 0 &&
            qualResponse.data.services[0].servicename === "FiOSData" &&
            qualResponse.data.services[0].qualified === "Y") {
            logNRTime(window.nrTimeState, dispatch, 'TwsDiscount');
            redirectTo(Pages.TwsDiscount, dispatch)
        }
        //movechange
        else if (flowType != "MV") {
            //Adding GateKeeper for Initial Release
            if (Save.smartCartFlowFlag === 'true' && InHomeUtils.isNotNull(qualResponse.data.smartCartDetails) && qualResponse.data.smartCartDetails.smartCartAvailable) {

                const fetchSmartCartStatus = saveAction.processSaveCart(visitId, dispatch, lqState, email, mtn);
                //  if (InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotNull(lqState.runtimeKey.enableSCFromLQ) &&  InHomeUtils.isNotEmpty(lqState.runtimeKey.enableSCFromLQ) && lqState.runtimeKey.enableSCFromLQ.toLowerCase() === "y")
                //   {
                smartCartStatusResponse = 'pending';// fetchSmartCartStatus;
                Promise.all([fetchSmartCartStatus]).then(function (values) {
                    smartCartStatusResponse = 'completed';
                    if (qualResponse.data.inService === "N" && (InHomeUtils.isNotNull(values) && InHomeUtils.isNotEmpty(values) && InHomeUtils.isNotNull(values[0].data) && InHomeUtils.isNotEmpty(values[0].data) && InHomeUtils.isNotNull(values[0].data.cartRetrieved) && InHomeUtils.isNotNull(values[0].data.addressLine1) && InHomeUtils.isNotEmpty(values[0].data.addressLine1) && InHomeUtils.isNotNull(values[0].data.mon) && InHomeUtils.isNotEmpty(values[0].data.mon) && values[0].data.cartRetrieved)) {

                        if (qualResponse.data.type === 'EmailId' || qualResponse.data.type === 'Mtn') {
                            tempSCData.detailPageName = "smart cart resume entry| continue your cart| provide mtn or email";
                            tempVzdlSCData.detail = "smart cart resume entry - continue your cart - provide mtn or email";
                        }
                        else if (qualResponse.data.type === 'Mon') {
                            tempSCData.detailPageName = "smart cart resume entry| continue your cart| provide cart number";
                            tempVzdlSCData.detail = "smart cart resume entry - continue your cart - provide cart number";
                        }
                        else {
                            tempSCData.detailPageName = "smart cart resume entry| continue your cart| no cart number";
                            tempVzdlSCData.detail = "smart cart resume entry - continue your cart - no cart number";
                        }

                        updateSCcustomEvent("smartSave", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                        setTimeout(() => {
                            updateVzdlSCCustomEvent("smartSave", "pageViewOmni", "detail");
                        }, 1000);
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.SmartCartFound + "-Y", PAGEACTIVITY.UA));
                        redirectTo(Pages.SmartSave, dispatch);
                        loaderActive({ isLoaderActive: false }, dispatch)
                    }
                    else {
                        // Smart  Cart not retrieved in process smart cart response or addressline is null, considering it as Smart cart not found
                        if (qualResponse.data.inService === "N" && qualResponse.data.pendingOrder === "N") {
                            dispatch({ type: CheckLQ.updateInitLoad, value: 5000 });
                        }
                        if (qualResponse.data.inService === "N") {
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.ExistingService + "-N", PAGEACTIVITY.UA));
                            let ismnhCheckoutFlow = lqState.mnh && lqState.mnh.mnhFlow && lqState.mnh.isGigqualified && mnhCheckoutData && mnhCheckoutData.data && mnhCheckoutData.data.creditStatus && mnhCheckoutData.data.creditStatus.toLowerCase() === 'success' && mnhCheckoutData.data.targetView && mnhCheckoutData.data.targetView.toLowerCase() === 'checkout';
                            if (lqState.quickCheckout || ismnhCheckoutFlow) {
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.SmartCartFound + "-N", PAGEACTIVITY.UA));
                                redirectTo(Pages.Checkout, dispatch)
                            }
                            else if ((lqState && lqState.runtimeKey && lqState.runtimeKey.DisableMHFiosSignIn &&  lqState.runtimeKey.DisableMHFiosSignIn !== "Y") && (lqState&&lqState.runtimeKey&&lqState.runtimeKey.EnableMHFiosSignIn&&lqState.runtimeKey.EnableMHFiosSignIn ==="N") && !(qualResponse.data.wirelessPlanType && qualResponse.data.wirelessPlanType === "METERED" || qualResponse.data.wirelessPlanType === "UNLIMITED") && qualResponse.data.pendingOrder === "Y") {
                                updateSCcustomEvent("pendingOrder", "ddCheckAvailabilityPageViewEvent", "");
                                updateVzdlSCCustomEvent("pendingOrder", "pageViewOmni", "");
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.PendingOrder + "-Y", PAGEACTIVITY.UA));
                                redirectTo(Pages.PendingOrder, dispatch);
                            } else if ((lqState && lqState.runtimeKey && lqState.runtimeKey.DisableMHFiosSignIn &&  lqState.runtimeKey.DisableMHFiosSignIn !== "Y") && (lqState&&lqState.runtimeKey&&lqState.runtimeKey.EnableMHFiosSignIn&&lqState.runtimeKey.EnableMHFiosSignIn ==="Y") && (qualResponse.data.wirelessPlanType && qualResponse.data.wirelessPlanType === "METERED" || qualResponse.data.wirelessPlanType === "UNLIMITED")) {
                                redirectTo(Pages.CheckLQ, dispatch);
                            } else {
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.SmartCartFound + "-N", PAGEACTIVITY.UA));
                                redirectTo(Pages.BuildProduct, dispatch)
                            }
                        }
                        else {
                            updateSCcustomEvent("existingSrvc", "ddCheckAvailabilityPageViewEvent", "");
                            // updateVzdlSCCustomEvent("existingSrvc", "pageViewOmni", "");
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.ExistingService + "-Y", PAGEACTIVITY.UA));
                        }
                        loaderActive({ isLoaderActive: false }, dispatch)
                    }
                });
                // }
            }
            if (qualResponse.data.inService === "N" && qualResponse.data.pendingOrder === "N") {
                dispatch({ type: CheckLQ.updateInitLoad, value: 5000 });
            }
            if (qualResponse.data.inService === "N") {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.ExistingService + "-N", PAGEACTIVITY.UA));
                //Adding GateKeeper for Initial Release
                let ismnhCheckoutFlow = lqState.mnh && lqState.mnh.mnhFlow && lqState.mnh.isGigqualified && mnhCheckoutData && mnhCheckoutData.data && mnhCheckoutData.data.creditStatus && mnhCheckoutData.data.creditStatus.toLowerCase() === 'success' && mnhCheckoutData.data.targetView && mnhCheckoutData.data.targetView.toLowerCase() === 'checkout';
                if (!ismnhCheckoutFlow && !lqState.quickCheckout && Save.smartCartFlowFlag === 'true' && InHomeUtils.isNotNull(qualResponse.data.smartCartDetails) && qualResponse.data.smartCartDetails.smartCartAvailable) {

                    /* if (InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotNull(lqState.runtimeKey.enableSCFromLQ)  && InHomeUtils.isNotEmpty(lqState.runtimeKey.enableSCFromLQ)  && lqState.runtimeKey.enableSCFromLQ.toLowerCase() === "n"){
                        if (qualResponse.data.type === 'EmailId' || qualResponse.data.type === 'Mtn') {
                            tempSCData.detailPageName = "smart cart resume entry| continue your cart| provide mtn or email";
                            tempVzdlSCData.detail = "smart cart resume entry - continue your cart - provide mtn or email";
                        }
                        else if (qualResponse.data.type === 'Mon') {
                            tempSCData.detailPageName = "smart cart resume entry| continue your cart| provide cart number";
                            tempVzdlSCData.detail = "smart cart resume entry - continue your cart - provide cart number";
                        }
                        else {
                            tempSCData.detailPageName = "smart cart resume entry| continue your cart| no cart number";
                            tempVzdlSCData.detail = "smart cart resume entry - continue your cart - no cart number";
                        }
    
                        updateSCcustomEvent("smartSave", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                        updateVzdlSCCustomEvent("smartSave", "pageViewOmni", "detail");
    
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.SmartCartFound + "-Y", PAGEACTIVITY.UA));
                        redirectTo(Pages.SmartSave, dispatch);
                     }*/
                }
                else if (lqState.quickCheckout || ismnhCheckoutFlow) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.SmartCartFound + "-N", PAGEACTIVITY.UA));
                    redirectTo(Pages.Checkout, dispatch)
                }
                else if (qualResponse.data.pendingOrder === "Y") {
                    updateSCcustomEvent("pendingOrder", "ddCheckAvailabilityPageViewEvent", "");
                    updateVzdlSCCustomEvent("pendingOrder", "pageViewOmni", "");
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.PendingOrder + "-Y", PAGEACTIVITY.UA));
                    redirectTo(Pages.PendingOrder, dispatch);
                }
                else {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.SmartCartFound + "-N", PAGEACTIVITY.UA));
                    redirectTo(Pages.BuildProduct, dispatch)
                }
            }
            else {
                updateSCcustomEvent("existingSrvc", "ddCheckAvailabilityPageViewEvent", "");
                updateVzdlSCCustomEvent("existingSrvc", "pageViewOmni", "");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.ExistingService + "-Y", PAGEACTIVITY.UA));
            }
        }
        //movechange
        else if (flowType === "MV" && qualResponse.data.inService === "N") {
            // redirectTo(Pages.moveLanding, dispatch)
            //settimeout temp fix
            let lqStateTemp = {
                lqResponse: {
                    isFCP: qualResponse.data.isFCP,
                },
                isFcpInProfile: lqState.isFcpInProfile,
                selectedAdr: {
                    addressID: lqState.selectedAdr.addressID
                },
                custFromAddrId: lqState.custFromAddrId
            }
            moveExpAction.getMoveLandingExperience(dispatch, visitId, true, lqStateTemp)
        }
        if (smartCartStatusResponse === "pending") {

            //wait till processSmart call complete and close the Loader
        }
        else {
            // if((lqState.hoaFlowDetails && lqState.hoaFlowDetails.isHoaFlow)){
            //             redirectTo(Pages.BuildProduct, dispatch);
            //         }
            loaderActive({ isLoaderActive: false }, dispatch)
        }
        /* if ((InHomeUtils.isNotNull(lqState.runtimeKey) && InHomeUtils.isNotNull(lqState.runtimeKey.enableSCFromLQ) && InHomeUtils.isNotEmpty(lqState.runtimeKey.enableSCFromLQ) && lqState.runtimeKey.enableSCFromLQ.toLowerCase() === "n")) {
 
             if (qualResponse.data.inService === "Y" || (qualResponse.data.inService === "N" && !smartCartStatusResponse === "pending") || (qualResponse.data.inService === "N" && !smartCartStatusResponse === "pending")) {
                 loaderActive({ isLoaderActive: false }, dispatch)
             }
             else {
                 loaderActive({ isLoaderActive: true }, dispatch)
             }
         } 
         else {
             loaderActive({ isLoaderActive: false }, dispatch)
         } */
        if (window.nrTimeState && window.nrTimeState.fromTime) {
            logNRTime(window.nrTimeState, dispatch, 'ExistingService');
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'qualResponseHandling', ex);
    }
}

export const setCantFindAddress = (value, dispatch) => {
    dispatch({ type: 'LQ_CANT_FIND_ADDRESS_CLICKED', value: value });
};

export const validateSigninlq2 = (dispatch, visitId,MovesValue, lqState = null) => {
    try {
        let request = {
            "token": "LwM4IVMiygS8lgiyosbht5M3JznjDU4WHiPbtebCJaZcYMiefodtv5XtjvWt1WLTfqZELl1ZZIxhXkUJi%2BrVhGGWz8MNBEmTZHaANFTgnvpJyux4EV0mBmjgpqTROynpy0QbkSYBvEuAiT2QtKIQ%2F1UVPm4Epyt2ByvlE3jsBP1YVJcUipLVxlNhd4vHSpiE",
            "caller": "ACCOUNT_ACCESS",
            "queryString": "token=LwM4IVMiygS8lgiyosbht5M3JznjDU4WHiPbtebCJaZcYMiefodtv5XtjvWt1WLTfqZELl1ZZIxhXkUJi%252BrVhGGWz8MNBEmTZHaANFTgnvpJyux4EV0mBmjgpqTROynpy0QbkSYBvEuAiT2QtKIQ%252F1UVPm4Epyt2ByvlE3jsBP1YVJcUipLVxlNhd4vHSpiE&test=bundle"
        };
        let responseapi = "API Returning Null";

        let url = '';
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        if (MovesValue.fromTestPage != undefined && MovesValue.fromTestPage == "Y" && MovesValue.vCustId != undefined && MovesValue.vCustId != null && MovesValue.vAcctId != undefined && MovesValue.vAcctId != null) {
            url = apiUrl().getAccount + '/validateSignInforMoves' + '?fromTestPage=Y&vCustId=' + MovesValue.vCustId + '&vAcctId=' + MovesValue.vAcctId;
            if(window && window?.location?.search?.includes('agency=CETCORDER2') || window && window.sessionStorage && (window.sessionStorage.getItem('isWIFI7') === 'true')){
                url = url + '&agency=CETCORDER2';
            }
        } else {
            url = apiUrl().getAccount + '/validateSignInforMoves';
            let agencyID = window.sessionStorage.getItem('agencyID')
            if(agencyID !== null && agencyID !== undefined){
                url = url + '?agency=' + agencyID;
            } 
        }
        return new Promise((resolve, reject) => {
            api(url, 'GET').then(response => {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                if (InHomeUtils.isNotNull(response) && response != undefined) {
                    responseapi = response;
                }
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.data)
                    && response.data != undefined && response.data != null && (response.meta.code === 200 || response.meta.code === 200.01) &&
                    response.data.profileFailReason == "SUCCESS") {
                    dispatch({
                        type: CheckLQ.validateSignin,
                        value: response.data.isPendingOrderAvailable
                    });
                    dispatch({
                        type: 'accountAndCustomerId',
                        value: response.data
                    });
                    tempVzdlSCData.flowName = "accord move";
                    updateVzdlSCCustomEvent("loginSuccessful", "ddLoginSuccessful", "");
                    if (response.data.isHsiInProfile) {
                        errorAction("LBO", "CheckLQ", "profileFailReason", "", visitId, dispatch, true, "HsiInProfile");
                        vzdlErrorUpdate(response.meta.code, "GBBERR-" + "HsiInProfile");
                        return;
                    } else if (response.data.isLecInProfile) {
                        if (lqState && lqState.runtimeKey && lqState.runtimeKey.enableRBBLboPage == "Y"){
                            errorAction("LBO", "CheckLQ", "RuralBroadBand", "", visitId, dispatch, true, "RuralBroadBand");
                            //errorAction("LBO", "CheckLQ", "profileFailReason", "", visitId, dispatch, true, "LecInProfile");
                            vzdlErrorUpdate(response.meta.code, "GBBERR-" + "LecInProfile");
                            return;
                        }    
                    } else if (response.data.isPendingOrderAvailable) {
                        errorAction("LBO", "CheckLQ", "profileFailReason", "", visitId, dispatch, true, "Business_Err_PendingInProfile");
                        vzdlErrorUpdate(response.meta.code, "GBBERR-" + "Business_Err_PendingInProfile");
                        return;
                    }

                } else if (response.meta.code === 200 || response.meta.code === 200.01 && response.data != undefined && response.data != null && response.data.profileFailReason == "signinRequired") {
                    updateSCTags("continue-move service");
                    dispatch({ type: "UPDATE_FLOWTYPE", value: { flowType: "MV" } });
                    dispatch({ type: 'UPDATE_FLOWPURPOSE', value: { flowPurpose: "MV" } });
                    let isLoggedIn = false;
                    const loggedInCookie = InHomeUtils.getCookie('loggedIn', document.cookie);
                    if (loggedInCookie === 'true') {
                        isLoggedIn = true;
                    }
                    if(!isLoggedIn){
                        redirectTo(Pages.MoveSignIn, dispatch);
                    }else{
                        window.location.href = Pages.MyVerizonSignInMv;
                    }
                    tempVzdlSCData.flowName = "accord move";
                    updateVzdlSCCustomEvent("loginSuccessful", "ddLoginSuccessful", "");
                } else {
                    errorAction("LBO", "CheckLQ", "profileFailReason", "", visitId, dispatch, true, response.data.profileFailReason);
                    vzdlErrorUpdate(response.meta.code, "GBBERR-" + response.data.profileFailReason);
                }
                resolve(response);
            })
                .catch(error => {
                    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                    logKafka("ERROR", "looQual", error.message + ":" + responseapi, getErrorLogUrl, "applogs", visitId);
                    errorAction("LBO", "CheckLQ", "profileFailReason", "", visitId, dispatch, true, "ValidateSigninForMoves");
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                    vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                });
        });
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.RC, visitId, 'ValidateSigninForMoveslq2', ex);
    }
}
export const validateSignin = (dispatch, visitId, fromTestPage, vCustId, vAcctId) => {
    let request = {
        "token": "LwM4IVMiygS8lgiyosbht5M3JznjDU4WHiPbtebCJaZcYMiefodtv5XtjvWt1WLTfqZELl1ZZIxhXkUJi%2BrVhGGWz8MNBEmTZHaANFTgnvpJyux4EV0mBmjgpqTROynpy0QbkSYBvEuAiT2QtKIQ%2F1UVPm4Epyt2ByvlE3jsBP1YVJcUipLVxlNhd4vHSpiE",
        "caller": "ACCOUNT_ACCESS",
        "queryString": "token=LwM4IVMiygS8lgiyosbht5M3JznjDU4WHiPbtebCJaZcYMiefodtv5XtjvWt1WLTfqZELl1ZZIxhXkUJi%252BrVhGGWz8MNBEmTZHaANFTgnvpJyux4EV0mBmjgpqTROynpy0QbkSYBvEuAiT2QtKIQ%252F1UVPm4Epyt2ByvlE3jsBP1YVJcUipLVxlNhd4vHSpiE&test=bundle"
    };
    let responseapi = "API Returning Null";

    let url = '';
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
    if (fromTestPage != undefined && fromTestPage == "Y" && vCustId != undefined && vCustId != null && vAcctId != undefined && vAcctId != null) {
        url = apiUrl().getAccount + '/validateSignInforMoves' + '?fromTestPage=' + fromTestPage + '&vCustId=' + vCustId + '&vAcctId=' + vAcctId;
        if(window && window?.location?.search?.includes('agency=CETCORDER2') || window && window.sessionStorage && (window.sessionStorage.getItem('isWIFI7') === 'true')){
            url = url + '&agency=CETCORDER2';
        }
        } else {
            url = apiUrl().getAccount + '/validateSignInforMoves';
            let agencyID = window.sessionStorage.getItem('agencyID')
            if(agencyID !== null && agencyID !== undefined){
                url = url + '?agency=' + agencyID;
            }     
    }
    api(url, 'GET').then(response => {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        if (InHomeUtils.isNotNull(response) && response != undefined) {
            responseapi = response;
        }
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.data)
            && response.data != undefined && response.data != null && (response.meta.code === 200 || response.meta.code === 200.01) &&
            response.data.profileFailReason == "SUCCESS") {
            dispatch({
                type: CheckLQ.validateSignin,
                value: response.data.isPendingOrderAvailable
            });
            dispatch({
                type: 'accountAndCustomerId',
                value: response.data
            });
            let appStateVal = null;
            let lqStateVal = null
            if (store && store.getState() && store.getState().app && store.getState().loopQual){
                appStateVal = store.getState().app;
                lqStateVal = store.getState().loopQual;
            }
            tempVzdlSCData.flowName = "accord move";
            updateVzdlSCCustomEvent("loginSuccessful", "ddLoginSuccessful", "");
            if(appStateVal && lqStateVal){
                getVZDLInit("checkAvaillqInit", { appInfo: appStateVal, lqInfo: lqStateVal });
            }
            if (response.data.isHsiInProfile) {
                errorAction("LBO", "CheckLQ", "profileFailReason", "", visitId, dispatch, true, "HsiInProfile");
                vzdlErrorUpdate(response.meta.code, "GBBERR-" + "HsiInProfile");
                return;
            } else if (response.data.isLecInProfile) {
                errorAction("LBO", "CheckLQ", "RuralBroadBand", "", visitId, dispatch, true, "RuralBroadBand");
                //errorAction("LBO", "CheckLQ", "profileFailReason", "", visitId, dispatch, true, "LecInProfile");
                vzdlErrorUpdate(response.meta.code, "GBBERR-" + "LecInProfile");
                return;
            } else if (response.data.isPendingOrderAvailable) {
                errorAction("LBO", "CheckLQ", "profileFailReason", "", visitId, dispatch, true, "Business_Err_PendingInProfile");
                vzdlErrorUpdate(response.meta.code, "GBBERR-" + "Business_Err_PendingInProfile");
                return;
            }

        } else if (response.meta.code === 200 || response.meta.code === 200.01 && response.data != undefined && response.data != null && response.data.profileFailReason == "signinRequired") {
            updateSCTags("continue-move service");
            dispatch({ type: "UPDATE_FLOWTYPE", value: { flowType: "MV" } });
            dispatch({ type: 'UPDATE_FLOWPURPOSE', value: { flowPurpose: "MV" } });
            let isLoggedIn = false;
            const loggedInCookie = InHomeUtils.getCookie('loggedIn', document.cookie);
            if (loggedInCookie === 'true') {
                isLoggedIn = true;
              }
            if(!isLoggedIn){
                redirectTo(Pages.MoveSignIn, dispatch);
            }else{
                window.location.href = Pages.MyVerizonSignInMv;
            }
            tempVzdlSCData.flowName = "accord move";
            updateVzdlSCCustomEvent("loginSuccessful", "ddLoginSuccessful", "");
        } else {
            errorAction("LBO", "CheckLQ", "profileFailReason", "", visitId, dispatch, true, response.data.profileFailReason);
            vzdlErrorUpdate(response.meta.code, "GBBERR-" + response.data.profileFailReason);
        }
        return response;
    })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            logKafka("ERROR", "looQual", error.message + ":" + responseapi, getErrorLogUrl, "applogs", visitId);
            errorAction("LBO", "CheckLQ", "profileFailReason", "", visitId, dispatch, true, "ValidateSigninForMoves");
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
            return;
        });
};

export const resetLqResponse = (value, dispatch) => {
    dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value });
}

export const resetlqQualdetails = (dispatch) => {
    dispatch({ type: 'LQ_ON_RETRIEVE_QUALDETAILS', value: {} });
}

export const resetExistingService = (dispatch, value) => {
    dispatch({
        type: 'EXISTING_SERVICE',
        value: ''
    });
};

export const resetQualificationDetails = (dispatch) => {
    resetLqResponse({}, dispatch);
    resetlqQualdetails(dispatch);
    resetExistingService(dispatch);
    resetQualifiedService(dispatch);
};

export const resetQualifiedService = (dispatch) => {
    dispatch({
        type: 'LQ_SET_QUALIFIED_SERVICES', value: {
            isDataQualified: true,
            isHsiQualified: true,
            isVideoQualified: true,
            isVoiceQualified: true
        }
    });
};

export const rememberMeCheck = (status, dispatch) => {
    dispatch({ type: 'LQ_ON_REMEMBERME_CHECK', value: status })
};

export const onSelectSignin = (action, dispatch) => {
    dispatch({ type: CheckLQ.signInAs, value: action });
}

export const fNameErr = (status, dispatch) => {
    dispatch({ type: FutureNotification.fNameErr, value: status })
};

export const lNameErr = (status, dispatch) => {
    dispatch({ type: FutureNotification.lNameErr, value: status })
};

export const emailErr = (status, dispatch) => {
    dispatch({ type: FutureNotification.emailErr, value: status })
};

export const mtnErr = (status, dispatch) => {
    dispatch({ type: FutureNotification.mtnErr, value: status })
};

export const mtn = (status, dispatch) => {
    dispatch({ type: FutureNotification.mtn, value: status })
};
export const ftvCheckErr = (status, dispatch) => {
    dispatch({ type: FutureNotification.ftvCheckErr, value: status })
};
export const validateInput = (action, dispatch) => {
    dispatch({ type: FutureNotification.validateInput, value: action });
}
export const ftvCheck = (status, dispatch) => {
    dispatch({ type: FutureNotification.ftvCheck, value: status })
}
export const validateSignInCoupon = (action, dispatch) => {
    dispatch({ type: CheckLQ.validateSignInCoupon, value: action });
}
export const phoneNumCheck = (status, dispatch) => {
    dispatch({ type: CheckLQ.phoneNumCheck, value: status })
}
export const mtnSignInErr = (status, dispatch) => {
    dispatch({ type: CheckLQ.mtnSignInErr, value: status })
};
export const mtnSignIn = (status, dispatch) => {
    dispatch({ type: CheckLQ.mtnSignIn, value: status })
};

const getNsiRequest = (addressId, state) => {
    let request = {
        addressId: addressId,
        programName: 'vzcom',
        inquiryType: 'status',
        nsiID: '',
        state: state,
        firstName: '',
        lastName: '',
        emailAddress: '',
        contactPhone: '',
        notifyFios: '',
        notifyFiosTv: '',
        siResponse: ''
    }
    return JSON.stringify(request);
}

export const setNpmLofFlow = (isNpmLofFlow, dispatch) => {
    dispatch({ type: 'SET_NPMLOF_FLOW', value: isNpmLofFlow });
}

export const showNewYoutubeChanges = (showChanges, dispatch) => {
    dispatch({ type: 'SHOW_NEW_YOUTUBE_CHANGES', value: showChanges });
}

export const setVzwMtn = (respData, mtn, dispatch) => {
    if (respData && respData.status === "Success" && mtn) {
        dispatch({ type: 'SET_VZW_MTN', value: mtn });
    } else {
        dispatch({ type: 'SET_VZW_MTN', value: undefined });
    }
};

export const validateVzwMtn = (mtn, visitId, addrID, dispatch) => {
    try {
        let url = apiUrl().vzwOfferEligibility;
        let request = {
            "mtn": mtn,
            "addressId": addrID
        };

        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.offerEligibilitydata)) {
                setVzwMtn(response.data.offerEligibilitydata, mtn, dispatch);
            } else {
                console.log("Error calling validateVzwMtn")
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:validateVzwMtn,errorMessage:${error.message}`;
                logKafka("ERROR", "MTNQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            });

    } catch (ex) {
        catchJSException('loopQual', visitId, 'validateVzwMtn', ex);
    }
};

export const validateVZWOfferEligibility = (dispatch, mtn, visitId, fromLQPage, addrID, flowType, movesEligibility, isFCPflow, isDoFlow, lqState = null, buildProductState = null, sourceSystem = "",firstName="",lastName="",emailId="") => {
    try {
        logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "Inside validateVZWOfferEligibility"));
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });

        let url = apiUrl().vzwOfferEligibility;
        let request = lqState&&lqState.runtimeKey&&lqState.runtimeKey.EnableMHFiosSignIn&&lqState.runtimeKey.EnableMHFiosSignIn==="Y"?{
            "mtn": mtn,
            "addressId": addrID,
            "sourceSystem": sourceSystem,
            "firstName": firstName,
            "lastName": lastName,
            "emailId": emailId
            
        }:{
            "mtn": mtn,
            "addressId": addrID,
            "sourceSystem": sourceSystem
        };

        api(url, 'POST', JSON.stringify(request)).then(response => {

            //response = {"meta":{"code":200.01,"description":"VZWOFFERELIGIBILITY Completed successfully .","timestamp":"Fri Mar 27 06:55:41 UTC 2020"},"data":{"status":"Success","statusCode":"0","desc":"All calls made successfully","accountNo":"825853324-1","mtn":"2405616399","checkOfferEligibilityInfoList":{"checkOfferEligibilityInfo":[{"name":"FIOSGIGABT","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"FIOS200","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVBSMRKT1","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVBSMRKT2","eligibilityIndicator":"N","offerId":"1628","offerDescription":"MOBILE + HOME LEVEL 2 ELIGIBLE","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT ALREADY HAS THIS OFFER.","reasonCode":"3"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVBSMRKT3","eligibilityIndicator":"Y","offerId":"1629","offerDescription":"MOBILE + HOME LEVEL 3 ELIGIBLE","ineligibilityReasonCount":"","ineligibilityReasonList":{"ineligibilityReasonInfo":[]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVWSMRKT1","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVWSMRKT2","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVWSMRKT3","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVBSOFRT1","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVBSOFRT2","eligibilityIndicator":"N","offerId":"1631","offerDescription":"MOBILE + HOME LEVEL 2","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT ALREADY HAS THIS OFFER.","reasonCode":"3"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVBSOFRT3","eligibilityIndicator":"Y","offerId":"1632","offerDescription":"MOBILE + HOME LEVEL 3","ineligibilityReasonCount":"","ineligibilityReasonList":{"ineligibilityReasonInfo":[]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVWSOFRT1","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVWSOFRT2","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"ADVWSOFRT3","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null},{"name":"VZWB2BJMP","eligibilityIndicator":"N","offerId":"","offerDescription":"","ineligibilityReasonCount":"1","ineligibilityReasonList":{"ineligibilityReasonInfo":[{"reason":"CUSTOMER ACCOUNT IS NOT ELIGIBLE DUE TO LACK OF QUALIFIEDDATA PLAN OR ACCOUNT SETUP.","reasonCode":"2"}]},"allowanceTypeCode":"","allowanceAmount":"","vzwOfferInfo":null,"vztOfferInfo":null}]},"visionOrderNumber":null,"otherOfferEligibilityIndicator":null,"sharePlanId":null,"accountEstablishedDate":"11/17/2019","isOnVzwUnlimitedPlan":"Y","primaryAccountIndicator":"Y","isCCEligible":"Y","sspQualicationDetails":{"status":"Success","isVzwAccountEligibile":"Y","vzwAccountId":"825853324-1","mtn":"2405616399","isVzwAccountPromoEligibile":"Y","isAccountMandHEligibile":"N"},"updateCart":true}};
            //response= resp.samplerespdata
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.offerEligibilitydata)) {
                dispatch({ type: MTNValidation.updateVZWOfferEligibility, value: { data: response.data.offerEligibilitydata, isVZWOfferCallComplete: true } });
                if(response.data && response.data.offerEligibilitydata.validVzw && response.data.offerEligibilitydata.validVzw === "Y")
                    {
                        dispatch({type : 'validVzw',value : "Y"});
                    }

                if (InHomeUtils.isNotNull(response.data) && response.data.offerEligibilitydata.isCCEligible === "Y") {
                    tempSCData.detailPageName = "accord| info and credit - billinfo| vzw mtn eligible";
                    tempVzdlSCData.detail = "info and credit - billinfo vzw mtn eligible";
                    logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "mtn eligible for Online CC"));
                }
                else {
                    if(InHomeUtils.isNotNull(response.data) && response.data.offerEligibilitydata.mtn!==undefined){
                        tempVzdlSCData.detail = "info and credit- crd chk- vzw authenticated";
                        logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "mtn ineligible for Online CC"));
                    }
                    else{
                    tempSCData.detailPageName = "accord| info and credit - billinfo| vzw mtn ineligible";
                    tempVzdlSCData.detail = "info and credit - billinfo vzw mtn ineligible";
                    logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "mtn ineligible for Online CC"));
                    }
                }

                if (!fromLQPage) {
                    if (InHomeUtils.isNotNull(response.data) && response.data.offerEligibilitydata.isCCEligible === "Y") {
                        doCreditAssessment(dispatch, isFCPflow, isDoFlow, false, visitId);
                    }
                    dispatch({ type: MTNValidation.updateVZWOfferPageCallStatus, value: "CheckoutPage" });
                    if (response.data.offerEligibilitydata.updateCart) {
                        url = apiUrl().getCartAcc + '/' + visitId;
                        api(url, 'GET', "").then(resp => {
                            if (InHomeUtils.isNotNull(resp) && InHomeUtils.isNotNull(resp.meta) && InHomeUtils.getIndexOf(resp.meta.code, '200')) {
                                dispatch({
                                    type: "UPDATE_CART",
                                    value: {
                                        cartResponse: resp.data.cartTierPricing,
                                        cartHeader: getCartHeader(resp.data.cartTierPricing.tierContent, visitId),
                                        cartData: getCartData(resp.data.cartTierPricing.tierContent, visitId),
                                        cartOrderDetail: resp.data.orderDetail,
                                        cartOrderProperty: InHomeUtils.isNull(resp.data.cartOrderProperty) ? null : resp.data.cartOrderProperty
                                    }
                                });
                                let cartProducts = getCartProducts(resp.data.cartTierPricing, visitId)
                                try {
                                    let product;
                                    let mnhProduct = false;
                                    if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd)) {
                                        product = cartProducts.DataProduct.dataProd.filter(e => InHomeUtils.isNotNull(e.prodType) && e.prodType === 'FTTPD');
                                        mnhProduct = cartProducts.CartSubProduct && cartProducts.CartSubProduct.SpecialOffers && cartProducts.CartSubProduct.SpecialOffers.rewardoffers && cartProducts.CartSubProduct.SpecialOffers.rewardoffers.filter(e => InHomeUtils.isNotNull(e.offerAttrValue) && (e.offerAttrValue.indexOf('MF2DISCF25') > -1 || e.offerAttrValue.indexOf('MF2DISCF10') > -1 || e.offerAttrValue.indexOf('MF2MRKF25') > -1 || e.offerAttrValue.indexOf('MF2MRKF10') > -1));
                                        if (InHomeUtils.isNotNull(product) && mnhProduct) {
                                            setTimeout(() => {
                                                vzdl.txn.product.current = [];
                                                addToCartVzdlSCEvent(visitId, product, "INTERNET", resp, isDoFlow, true, "", flowType, isFCPflow,"", "", "", false,"N",false, true);
                                            }, 3000);
                                        }
                                    }
                                }
                                catch (err) {
                                    catchJSException('BuildProduct', visitId, 'PreselectCartProducts', ex);
                                } 
                                let servicesInCart = InHomeUtils.isNotNull(resp.data.orderDetail) && InHomeUtils.isNotNull(resp.data.orderDetail.servicesOrdered) ? resp.data.orderDetail.servicesOrdered : '';
                                let contract = InHomeUtils.isNotNull(resp.data.orderDetail) && InHomeUtils.isNotNull(resp.data.orderDetail.contract) ? resp.data.orderDetail.contract : 'MTM';
                                let addlInfo = {
                                    isDoFlow: InHomeUtils.isNotNull(lqState.doFlowDetails) ? lqState.doFlowDetails.isDoFlow : false,
                                    zip: InHomeUtils.isNotNull(lqState.selectedState) ? lqState.selectedState.zip : null,
                                    tarCode: lqState.tarCode,
                                    state: lqState.selectedState.state,
                                    couponFlowType: lqState.couponFlowType,
                                    EquipmentState: null,
                                    masterpackageview: InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.masterpackageview) ? buildProductState.tv.masterpackageview : [],
                                    selectedProductId: '',
                                    isFCPflow: lqState.isFCPflow,
                                    isAlaCarte: false,
                                    flowType: flowType,
                                    servicesQualified: InHomeUtils.isNotNull(lqState.servicesQualified) ? lqState.servicesQualified : null,
                                    regionId: InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.fiosFiveSearchVhoParams) && InHomeUtils.isNotNull(buildProductState.tv.fiosFiveSearchVhoParams.regionId) ? buildProductState.tv.fiosFiveSearchVhoParams.regionId : ''
                                }
                                doPrefetch("REFRESH", dispatch, visitId, addlInfo, contract, servicesInCart, false, false,
                                    false, false, false, servicesInCart, null, null)
                            }
                        })
                    }
                }
                else {
                    dispatch({ type: MTNValidation.updateVZWOfferEligibility, value: { data: response.data.offerEligibilitydata, isVZWOfferCallComplete: true } });
                    dispatch({ type: MTNValidation.updateVZWOfferPageCallStatus, value: "LQPage" });
                }
                //LOF
                setVzwMtn(response.data, mtn, dispatch);
                if (InHomeUtils.isNotNull(response.data.offerEligibilitydata.sspQualicationDetails) && InHomeUtils.isNotEmpty(response.data.offerEligibilitydata.sspQualicationDetails.isVzwAccountEligibile) && response.data.offerEligibilitydata.sspQualicationDetails.isVzwAccountEligibile === 'Y') {
                    dispatch({ type: 'SET_VZW_ACCOUNTELIGIBLE', value: 'Y' })
                }

            } else {
                tempSCData.detailPageName = "accord| info and credit - billinfo| vzw mtn ineligible";
                tempVzdlSCData.detail = "info and credit - billinfo vzw mtn ineligible";
                logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "mtn ineligible for Online CC - response error"));
                dispatch({ type: MTNValidation.updateVZWOfferEligibility, value: { isVZWOfferCallComplete: false } })
            }
            if (flowType == "MV") {
                tempSCData.customerCategory = "^Moves^";
                tempSCData.flowName = "prospect accord seamless move";
                tempVzdlSCData.flowName = "accord seamless move";
                let noOfInstallDays = "";
                if(store && store.getState && store.getState().checkout){
                    //let selDueDateType =  store.getState().checkout.selDueDateType? store.getState().checkout.selDueDateType : "";
                    let calenderDisplayArr = store.getState().checkout.calenderDisplayArr ? store.getState().checkout.calenderDisplayArr : [];
                    
                    if(calenderDisplayArr.length > 0){
                        try {
                            let dt1 = new Date();
                            let dt2 = new Date(calenderDisplayArr[0]);
                            noOfInstallDays = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
                            noOfInstallDays = noOfInstallDays.toString();
                        }
                        catch (ex) {
                            console.log('Date difference Calculation Failed '+ ex.message);
                        }
                    }
                    /*if(selDueDateType  === "TECHVISIT"){
                        tempVzdlSCData.detail = "installation options - tech install";
                    }
                    else{
                        tempVzdlSCData.detail = "installation options - self install";
                    }*/
                }
                if (InHomeUtils.flowCheckforSeamless()) {
                    updateSCcustomEvent("checkoutMoves", "ddCheckoutEvent", "detailPageName");
                    updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail", false, "", false, "", "", noOfInstallDays);
                }
                else {
                    updateSCcustomEvent("checkoutMovesNonSeamless", "ddCheckoutEvent", "detailPageName");
                    updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail", false, "", false, "", "", noOfInstallDays);
                }
            } else {
                updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
            }

            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                dispatch({ type: MTNValidation.updateVZWOfferEligibility, value: { isVZWOfferCallComplete: false } })
                logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "mtn ineligible for Online CC - exception"));
                let errorMsg = `MethodName:validateVZWOfferEligibility,errorMessage:${error.message}`;
                logKafka("ERROR", "MTNQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'validateVZWOfferEligibility', ex);
    }
};

export const setBannerType = (dispatch, lqState, visitId, qualResponse) => {
    try {
        const VecOrder = qualResponse && qualResponse.hoaFlag && qualResponse.hoaFlag === 'Y';
        let bannerType = '';
        if (VecOrder && typeof getLpVVPCustomer !== "undefined") {
            window.getLpVVPCustomer();
        }
        if (InHomeUtils.isNotNull(lqState)) {
            if (VecOrder) {
                bannerType = BannerTypes.VecOrder;
            }
            else {
                let lqServices = (InHomeUtils.isNotNull(qualResponse) && InHomeUtils.isNotNull(qualResponse.services)) ? qualResponse.services : [];
                let dataService = 'N';
                let videoService = 'N';
                if (lqServices.length > 0) {
                    for (let i = 0; i < lqServices.length; i++) {
                        if (InHomeUtils.isNotNull(lqServices[i])) {
                            if (lqServices[i].servicename === 'FiOSData' && lqServices[i].qualified === 'Y') {
                                dataService = 'Y'
                            } else if (lqServices[i].servicename === 'Video' && lqServices[i].qualified === 'Y') {
                                videoService = 'Y'
                            }
                        }
                    }
                }

                if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.couponFlowType)) {
                    if (lqState.couponFlowType === "Employee" || lqState.couponFlowType === "Retiree") {
                        bannerType = BannerTypes.Employee;
                    }
                    else if (lqState.couponFlowType === "Affinity") {
                        bannerType = BannerTypes.connections;
                    }
                }
                else if (InHomeUtils.isNotNull(lqState.lqQualdetails)
                    && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult)
                    && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR)) {
                    let fttpAvailabilityDetailsAGR = lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR;

                    if (InHomeUtils.isNotNull(fttpAvailabilityDetailsAGR.ontAGR) && fttpAvailabilityDetailsAGR.ontAGR.length > 0) {
                        let srvcs = fttpAvailabilityDetailsAGR.ontAGR[0].portDetailAGR;
                        for (let i = 0; i < srvcs.length; i++) {
                            if (InHomeUtils.isNotNull(srvcs[i]) && InHomeUtils.isNotNull(srvcs[i].portType) && srvcs[i].portType.indexOf('VDSL') > -1) {
                                bannerType = BannerTypes.vdsl;
                            }
                        }
                    }

                    if (bannerType !== BannerTypes.vdsl && InHomeUtils.isNotNull(lqState)
                        && InHomeUtils.isNotNull(lqState.lqQualdetails)
                        && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult)
                        && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR)
                        && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.fiosTVQualified)
                        && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.fiosTVQualified)
                        && lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.fiosTVQualified === "N") {
                        bannerType = BannerTypes.vdsl;
                    }
                }
            }
            updateBannerType(bannerType, dispatch);
            if (bannerType === '') {
                bannerType = BannerTypes.default;
                updateBannerType(bannerType, dispatch);
                isBannerChecked(false, dispatch);
            }
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'setBannerType', ex);
    }
};
export const fetchBanners = (dispatch, visitId, isConnection = false) => {
    try {
        // var response = require('./../containers/banner/OrderingBanners.json');
        if (InHomeUtils.isNotNull(OrderingBanners)) {
            dispatch({ type: 'GET_BANNERS', value: OrderingBanners });
            if (isConnection) {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        }
        /*
        api(apiUrl().getBanners, 'GET', '').then(response => {
            if(InHomeUtils.isNotNull(response))
            dispatch({ type: 'GET_BANNERS', value: response });
        }).catch(error => {
            let errorMsg = `MethodName:fetchBanners,errorMessage:${error.message}`;
            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
        });*/
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'fetchBanners', ex);
        if (isConnection) {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
    }

};

export const fetchFlashOfferDetails = (dispatch, visitId, isConnection = false) => {
    try {
        let response = FlashOffersJson;
        if (InHomeUtils.isNotNull(response)) {
            dispatch({ type: 'GET_FLASH_OFFERDETAILS', value: response });
            if (isConnection) {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        }

    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'fetchBanners', ex);
        if (isConnection) {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
    }

};

export const fetchRibbonContent = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('loopQual', visitId, 'fetchRibbonContent', "Inside fetchRibbonContent"));
        let url = "https://www.verizon.com/content/caas/countdown-ribbon.model.json";
        //let response = RibbonContentJson;
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response)) {
                dispatch({ type: 'GET_RIBBON_CONTENT', value: response });

            }
        })
            .catch(error => {
                let errorMsg = `MethodName:fetchRibbonContent,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'fetchRibbonContent', ex);
    }
};
export const getvisitid = (async () => {
    //this.visitorvisitorid = await getCookieVisitIdAndVisitorIdNoParam();
    //console.log("resp",this.visitorvisitorid);  
    return await getCookieVisitIdAndVisitorIdNoParam();
});
export const chatupdateurlcount = (dispatch) =>{
    dispatch({type : 'INCREASE_CHATURL_COUNT', value : 1})
}
export const chaturlupdate = async (dispatch) =>{
    let url = '/inhome/chatupdateurl';
    if(window.location.href.indexOf('http://localhost') === -1){
    api(url,'GET','').then(response =>{
        if(response !== undefined &&  InHomeUtils.isNotNull(response)){
        console.log(response);
        dispatch({type:'CHATUPDATEURL',value:response})
        }
    })
    .catch(error => {
        console.log(error);
    })
}
}
export const getVendorDetailsForRetry = async (dispatch, visitId, lqState, referralUrl) => {
    try {

        getvisitid().then(response => {
            if (visitId && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.server_visit_id) && InHomeUtils.isNotNull(response.data.server_visitor_id)) {
                logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Inside getVendorDetails"));
                let url = apiUrl().getvendorvisitdetails;
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
                return api(url, 'GET', '');
            }
        });

    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getVendorDetails', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}
export const getVendorDetails = (dispatch, visitId, lqState, referralUrl, fromCommonLq = false) => {
    try {
        logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Inside getVendorDetails"));
        let url = apiUrl().getvendorvisitdetails + (fromCommonLq && '?fromFiveg=Y' || '');
        let addressRequest = null;
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({ type: 'GET_VENDOR_DETAILS', value: response.data });
                if (InHomeUtils.isNotNull(response.data.vendordetails) && response.data.vendordetails.vendor_name !== "") {
                    if (response.data.vendordetails.vendor_name === "Target") {
                        logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Target Flow"));
                        updateTargetOrdering(true, dispatch);
                    }
                    let vendordetails = {
                        vendor_name: InHomeUtils.isNotNull(response.data.vendordetails.vendorSalesDetails) ? response.data.vendordetails.vendorSalesDetails.vendor_name : response.data.vendordetails.vendor_name,
                        vendor_url: InHomeUtils.isNotNull(response.data.vendordetails.vendorSalesDetails) ? response.data.vendordetails.vendorSalesDetails.vendorurl : response.data.vendordetails.vendor_url,
                        default_tn: InHomeUtils.isNotNull(response.data.vendordetails.vendorSalesDetails) && response.data.vendordetails.vendorSalesDetails.default_tn ? typeof response.data.vendordetails.vendorSalesDetails.default_tn === "string" ? response.data.vendordetails.vendorSalesDetails.default_tn : response.data.vendordetails.vendorSalesDetails.default_tn.toString() : response.data.vendordetails.default_tn,
                        dig: response.data.vendordetails.dig ? response.data.vendordetails.dig : ''
                    }
                    updateVendorDetails(vendordetails, dispatch);
                    if (window._Cohesion && window._Cohesion.webContext && window._Cohesion.webContext.page && window._Cohesion.webContext.page.referrer) {
                        setReferralUrl(dispatch, window._Cohesion.webContext.page.referrer);
                    }
                }
                if (InHomeUtils.isNotNull(response.data.leadlistdetails) && (InHomeUtils.isNotNull(response.data.leadlistdetails.config) && (InHomeUtils.isNotNull(response.data.leadlistdetails.config.doid) && response.data.leadlistdetails.config.doid !== "") || response.data.leadlistdetails.doFlow)) {
                    logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Updating Do Flow Details"));
                    let doid = response.data.leadlistdetails.config && response.data.leadlistdetails.config.doid ? response.data.leadlistdetails.config.doid : 'FCP';
                    updateDOFlowDetails(doid, dispatch);
                }
                if (InHomeUtils.isNotNull(response.data.addressdetails) && InHomeUtils.isNotNull(response.data.addressdetails.addressID) && response.data.addressdetails.addressID !== "") {
                    addressRequest = {
                        addressID: response.data.addressdetails.addressID,
                        baseAddID: response.data.addressdetails.addressID,
                        street: (lqState.isoneLQFlow) ? (response.data.addressdetails.addressline1) + ", " + (response.data.addressdetails.city) + ", " + (response.data.addressdetails.state) + ", " + response.data.addressdetails.zip : response.data.addressdetails.addressline1,
                        unit: response.data.addressdetails.addressline2,
                        city: response.data.addressdetails.city,
                        state: response.data.addressdetails.state,
                        zip: response.data.addressdetails.zip,
                    }
                    dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDSTATE', value: addressRequest });
                    dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDADDRESS', value: addressRequest });
                    if (response.data.addressdetails.addressline2) {
                        dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDUNIT', value: addressRequest });
                    }
                } else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.leadlistdetails) && (InHomeUtils.isNotNull(response.data.leadlistdetails.config) && (InHomeUtils.isNotNull(response.data.leadlistdetails.config.doid) && response.data.leadlistdetails.config.doid !== "") || response.data.leadlistdetails.doFlow)) {
                    if (response.data.leadlistdetails.config.addressInfo && response.data.leadlistdetails.config.addressInfo.addressID) {
                        logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Updating Do Flow Details"));
                        addressRequest = {
                            addressID: response.data.leadlistdetails.config.addressInfo.addressID,
                            baseAddID: response.data.leadlistdetails.config.addressInfo.addressID,
                            street: (lqState.isoneLQFlow) ? ((response.data.leadlistdetails.config.addressInfo.addressline1) + ", " + (response.data.leadlistdetails.config.addressInfo.city) + ", " + (response.data.leadlistdetails.config.addressInfo.state) + ", " + response.data.leadlistdetails.config.addressInfo.zip) : response.data.leadlistdetails.config.addressInfo.addressline1,
                            unit: response.data.leadlistdetails.config.addressInfo.addressline2,
                            city: response.data.leadlistdetails.config.addressInfo.city,
                            state: response.data.leadlistdetails.config.addressInfo.state,
                            zip: response.data.leadlistdetails.config.addressInfo.zip,
                        }
                        dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDSTATE', value: addressRequest });
                        dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDADDRESS', value: addressRequest });
                        if (response.data.leadlistdetails.config.addressInfo.addressline2) {
                            dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDUNIT', value: addressRequest });
                        }
                    }
                }
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.vendorqualification)) {
                    dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: response.data.vendorqualification });
                    if (response.data.vendorqualification.services) {
                        let hsiFlow = false;
                        let lennarFlow = false;
                        if (InHomeUtils.isNotEmpty(response.data.vendorqualification.isLennarEligible) && response.data.vendorqualification.isLennarEligible === 'Y') {
                            lennarFlow = true;
                        }
                        let qualificationString = 'QUALIFIED-';
                        response.data.vendorqualification.services.forEach(key => {
                            if (Service.hsi.indexOf(key.servicename.toUpperCase()) >= 0 && key.qualified === "Y") {
                                qualificationString = qualificationString + Service.hsi + ',';
                            }
                            else if (Service.voice.indexOf(key.servicename.toUpperCase()) >= 0) {
                                if (key.qualified === "Y") {
                                    qualificationString = qualificationString + Service.voice + ',';
                                }
                            }
                            else if (Service.FiOSData.indexOf(key.servicename.toUpperCase()) >= 0 && key.qualified === "Y") {
                                qualificationString = qualificationString + Service.FiOSData + ',';
                            }
                            else if (Service.video.indexOf(key.servicename.toUpperCase()) >= 0 && key.qualified === "Y") {
                                qualificationString = qualificationString + Service.video + ',';
                            }
                        }
                        );
                        if (qualificationString === "QUALIFIED-" || qualificationString === "QUALIFIED-HSI,")
                            hsiFlow = true;

                        if (hsiFlow || lennarFlow) {
                            var Qstring = "?src=frmAtom";
                            dispatch({ type: 'REDIRECTINGFYH', value: "Y" });
                            var host = window.location.host;
                            if (host.indexOf("orderinglite") > -1)
                                window.location.href = Pages.CheckAvailPilot + Qstring;
                            else
                                window.location.href = Pages.CheckAvail + Qstring;
                            return;
                        }
                    }
                    //servicesQualified(response.data.vendorqualification, dispatch);
                    let retrieveQualdetailsUrl = apiUrl().retrieveQualdetails;
                    api(retrieveQualdetailsUrl, 'GET', '').then(response => {
                        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "retrieve Qual Details"));
                            dispatch({ type: 'LQ_ON_RETRIEVE_QUALDETAILS', value: response.data });
                            if(response.data?.getBroadbandAvailabilityResult?.fttpAvailabilityDetailsAGR?.isRuralBroadBandAddress){
                                dispatch({ type: 'IS_RURAL_BROADBAND_ADDRESS', value: true });
                            }     
                            let nsiIndicator = "";
                            if (InHomeUtils.isNotNull(response.data.addressValidationRecordAGR) && response.data.addressValidationRecordAGR.length > 0) {
                                nsiIndicator = response.data.addressValidationRecordAGR[0].nonStandardAddressFlag;
                                dispatch({ type: 'NSI_INDICATOR', value: nsiIndicator });
                                if (nsiIndicator === "Y") {
                                    let nsiUrl = apiUrl().nsiNotify
                                    api(nsiUrl, 'POST', getNsiRequest(response.vendordetails.config.addressInfo.addressId, response.vendordetails.config.addressInfo.state)).then(response => {
                                        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "nsi response is success"));
                                            dispatch({ type: 'NSI_STATUS', value: response.data });
                                        }
                                        else if (InHomeUtils.isNull(response) || ((InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && (InHomeUtils.getIndexOf(response.meta.code, '500') || InHomeUtils.getIndexOf(response.meta.code, '400'))))) {
                                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "nsi response is failed"));
                                            dispatch({ type: 'NSI_FAILED', value: true });
                                        }
                                    })
                                }
                            }
                            if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR)
                                && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR) && response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.ofsPresaleEligible === "Y") {
                                logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "PRESALE is Eligible"));
                                dispatch({ type: "PRESALE_ELIGIBLE", value: true })
                                if (response.data.getAdditionalInfo !== null && response.data.getAdditionalInfo !== undefined && response.data.getAdditionalInfo.ofsEstimateDays !== "") {
                                    dispatch({ type: "PRESALE_ESTIMATEDAYS", value: response.data.getAdditionalInfo.ofsEstimateDays })
                                }
                            }
                            if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR)
                                && response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent === "Y") {
                                logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "IONT Eligible", PAGEACTIVITY.UA));
                                dispatch({ type: "IONT_ELIGIBLE", value: true })
                                dispatch({ type: "IONT_STATUS", value: true })
                                tempSCData.IONTEligible = true;
                                isIONTAddr = true;
                            }
                            //fetch all banners and store
                            fetchBanners(dispatch, visitId);
                            //set bannerType on LQ success
                            setBannerType(dispatch, lqState, visitId, response.data.vendorqualification);
                        }
                    })
                        .catch(error => {
                            errorAction("ERROR", "RetrieveQual", error.message, "applogs", visitId, dispatch, false, "");
                            loaderActive({ isLoaderActive: false }, dispatch)
                            vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                        });
                    if (InHomeUtils.isNotNull(response.data.vendorqualification.smartCartDetails) && response.data.vendorqualification.smartCartDetails.smartCartAvailable && InHomeUtils.isNotNull(addressRequest)) {
                        saveAction.processSaveCartandRedirect(visitId, dispatch, addressRequest);
                    }
                    if (response.data.vendorqualification.inService === "N" && response.data.vendorqualification.pendingOrder === "N") {
                        dispatch({ type: CheckLQ.updateInitLoad, value: 5000 });
                    }
                    if (response.data.vendorqualification.inService === "N") {
                        logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Existing Service is not Available"));
                        //Adding GateKeeper for Initial Release
                        if (Save.smartCartFlowFlag === 'true' && InHomeUtils.isNotNull(response.data.vendorqualification.smartCartDetails) && response.data.vendorqualification.smartCartDetails.smartCartAvailable) {
                            if (response.data.vendorqualification.type === 'EmailId' || response.data.vendorqualification.type === 'Mtn') {
                                tempSCData.detailPageName = "smart cart resume entry| continue your cart| provide mtn or email";
                                tempVzdlSCData.detail = "smart cart resume entry - continue your cart - provide mtn or email";
                            }
                            else if (response.data.vendorqualification.type === 'mon') {
                                tempSCData.detailPageName = "smart cart resume entry| continue your cart| provide cart number";
                                tempVzdlSCData.detail = "smart cart resume entry - continue your cart - provide cart number";
                            }
                            else {
                                tempSCData.detailPageName = "smart cart resume entry| continue your cart| no cart number";
                                tempVzdlSCData.detail = "smart cart resume entry - continue your cart - no cart number";
                            }

                            updateSCcustomEvent("smartSave", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                            setTimeout(() => {
                                updateVzdlSCCustomEvent("smartSave", "pageViewOmni", "detail");
                            }, 1000);
                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Redirecting to Smart Save"));
                            redirectTo(Pages.SmartSave, dispatch);
                        }
                        else if (response.data.vendorqualification.pendingOrder === "Y") {
                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Redirecting to Pending Order"));
                            updateSCcustomEvent("pendingOrder", "ddCheckAvailabilityPageViewEvent");
                            updateVzdlSCCustomEvent("pendingOrder", "pageViewOmni", "");
                            redirectTo(Pages.PendingOrder, dispatch);
                        }
                        else {
                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Redirecting to Build Product"));
                            redirectTo(Pages.BuildProduct, dispatch)
                        }
                    }
                    else {
                        logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Existing Service is Available"));
                        updateSCcustomEvent("existingSrvc", "ddCheckAvailabilityPageViewEvent");
                    }
                }
                //     if (!InHomeUtils.isNotNull(response.data.vendorqualification)) {
                //         let mon = '' ;
                //         let url = apiUrl().getMon;
                //         const stateFromLq = lqState ; 
                //         if (InHomeUtils.isNotEmpty(stateFromLq)){
                //             url += "?serviceState=" + stateFromLq
                //         } 
                //         return api(url, 'GET', '').then(response => {
                //          if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) 
                //                 && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                //                 mon=response.data.mon ; 
                //                  if(InHomeUtils.isNotNull(mon) && InHomeUtils.isNotEmpty(mon)) {  
                //                  let smartCartStatus = getSmartCartStatus(mon, visitId);
                //                   Promise.all([smartCartStatus]).then(function (values) {
                //                   //Conditions or pre-requisites for already submitted MON
                //                         if((InHomeUtils.isNotNull(values) && InHomeUtils.isNotEmpty(values) && 
                //                         InHomeUtils.isNotNull(values[0].meta) && InHomeUtils.isNotEmpty(values[0].meta) && 
                //                         InHomeUtils.getIndexOf(values[0].meta.code, '200') && InHomeUtils.isNotNull(values[0].data))) {
                //                         if(InHomeUtils.isNotNull(values[0].data.status) && values[0].data.status === 'Success' 
                //                                 && InHomeUtils.isNotNull(values[0].data.mon) && InHomeUtils.isNotEmpty(values[0].data.mon) 
                //                                 & ((InHomeUtils.isNotNull(values[0].data.orderDetails) && 
                //                                 InHomeUtils.isNotNull(values[0].data.orderDetails.order)&& values[0].data.orderDetails.order.length >= 1)||
                //                                 ((InHomeUtils.isNotNull(values[0].data.isOrderInSQ) && InHomeUtils.isNotEmpty(values[0].data.isOrderInSQ) 
                //                                 && values[0].data.isOrderInSQ.toLowerCase() === "y")||(InHomeUtils.isNotNull(values[0].data.isOrderReceived) 
                //                                 && InHomeUtils.isNotEmpty(values[0].data.isOrderReceived) && values[0].data.isOrderReceived.toLowerCase() === "y")))) {
                //                                     smartCartBoolean = true;
                //                                 }
                //                                  //Routing based on MON submitted or not
                //                                     if(smartCartBoolean) {
                //                                     InHomeUtils.clearMemory();
                //                                     redirectTo(Pages.CheckLQ, dispatch);

                //                                 }
                //                             }
                //                  })
                //                 }
                //             }

                //         })
                // }

            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:getVendorDetails,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getVendorDetails', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const getRevisitDetails = (response, dispatch, visitId, lqState, changeLoc) => {
    try {
        let addressRequest = null;
        if (lqState.isoneLQFlow) {
            addressRequest = {
                addressID: response.addressId,
                street: decodeURIComponent(response.streetAddress) + ", " + decodeURIComponent(response.city) + ", " + decodeURIComponent(response.state) + ", " + response.zip,
                unit: '',
                city: decodeURIComponent(response.city),
                state: decodeURIComponent(response.state),
                zip: response.zip,
            }
        }
        else {
            addressRequest = {
                addressID: response.addressId,
                street: decodeURIComponent(response.streetAddress),
                unit: '',
                city: decodeURIComponent(response.city),
                state: decodeURIComponent(response.state),
                zip: response.zip,
            }
        }
        dispatch({
            type: 'UPDATE_RETURNVISIT_SELECTEDSTATE',
            value: addressRequest
        });
        dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDADDRESS', value: addressRequest });
        if (InHomeUtils.isNotEmpty(response.emailLq)) {
            dispatch({ type: Save.saveLqEmailInput, value: response.emailLq });
        }
        if (InHomeUtils.isNotEmpty(response.mobileNumLq)) {
            dispatch({ type: Save.saveLqMtnInput, value: response.mobileNumLq });
        }
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getRevisitDetails_Revisit', PAGEACTIVITY.MSG.revisit, PAGEACTIVITY.UA));
        dispatch({ type: CheckLQ.lqRevisit, value: "Y" });

        if (changeLoc && changeLoc === 'Y') {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getRevisitDetails_Change', PAGEACTIVITY.MSG.changeAdr, PAGEACTIVITY.UA));
            dispatch({ type: CheckLQ.updateInitLoad, value: 5000 });
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getRevisitDetails', ex);
    }
};

export const getAddressDetailsdoLQ = (dispatch, params) => {
    try {
        let addressRequest = null;
        let addressid = InHomeUtils.isNotNull(params.get('addrid')) ? decodeURIComponent(params.get('addrid')) : 0;
        let state = decodeURIComponent(params.get('state'));
        let url = apiUrl().getCompleteAddress; //addressid=16494801&state=PA

        if (addressid !== null && state !== null)
            url = encodeURI(url + addressid + "&state=" + state);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        api(url, 'GET', '').then(response => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.addressSwitch) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                let streetadr = response.addressSwitch.addressLine1 ? response.addressSwitch.addressLine1 : '';
                response.addressSwitch.addressLine2 ? streetadr = streetadr + " " + response.addressSwitch.addressLine2 : '';
                if (streetadr === "") streetadr = decodeURIComponent(params.get('rawstring'));
                addressRequest = {
                    addressID: addressid,
                    street: streetadr,
                    unit: response.addressSwitch.addressLine2 ? response.addressSwitch.addressLine2 : '',
                    city: response.addressSwitch.city ? response.addressSwitch.city : params.get('city') ? decodeURIComponent(params.get('city')) : '',
                    state: state,
                    zip: decodeURIComponent(params.get('zipcode')),
                }
            }
            else {
                addressRequest = {
                    addressID: addressid,
                    street: decodeURIComponent(params.get('rawstring')),
                    unit: '',
                    city: params.get('city') ? decodeURIComponent(params.get('city')) : '',
                    state: state,
                    zip: decodeURIComponent(params.get('zipcode')),
                }
            }
            dispatch({
                type: 'UPDATE_RETURNVISIT_SELECTEDSTATE',
                value: addressRequest
            });
            dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDADDRESS', value: addressRequest });
            dispatch({ type: 'VENDORNAME', value: "amazon" });
        }).catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            vzdlErrorUpdate(error.code === undefined ? "" : error.code, "");

        });
    }
    catch (ex) {
    }
};

export const onSubmitCaptcha = (captchaReq, visitId, dispatch) => {
    try {
        let url = '/inhome/validatecaptcha';
        let request = {
            'g-recaptcha-response': captchaReq
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {

            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.responseCode) && response.responseCode === 0) {
                redirectTo(Pages.CheckLQ, dispatch);
                updateSCTags("lq check avail - captcha FIOS success");
            }
            else {
                updateSCTags("lq check avail - captcha FIOS failure");
            }
        }).catch(error => {
            let errorMsg = `MethodName:onSubmitCaptcha,errorMessage:${error.message}`;
            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
        });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'onSubmitCaptcha', ex);
    }
}
export const changeTriggerLQ = (dispatch, value) => { dispatch({ type: CheckLQ.TriggerLQ, value }) };

export const onValidateCaptcha = (captchaReq, props) => {

    let url = '/inhome/validatecaptcha';
    // url = 'https://localhost.verizon.com:8080/validatecaptcha'; // localDev
    let request = {
        'g-recaptcha-response': captchaReq
    }
    api(url, 'POST', JSON.stringify(request)).then(response => {
        //console.log(response);
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.responseCode) && response.responseCode === 0) {
            // TODO : hide loader after successful response and enable LQBTN, with false flag in updateStateLocus
            props.dispatch({ type: CheckLQ.captchaChanged, value: 'COMPLETED' });
            if (props.lqState.is5GRecommended || props.lqState.is4GRecommended) {
                tempSCData.events = "event5,event8,event88"
                if (InHomeUtils.isNotNull(props.lqState) && InHomeUtils.isNotNull(props.lqState.selectedState)) {
                    tempSCData.statePostLQA = props.lqState.selectedState.state;
                    tempSCData.servicePostalCode = props.lqState.selectedState.zip;
                }
                else if (props.lqState.lqResponse && props.lqState.lqResponse.state && props.lqState.lqResponse.zip) {
                    tempSCData.statePostLQA = props.lqState.lqResponse.state;
                    tempSCData.servicePostalCode = props.lqState.lqResponse.zip;
                }
                if (props.lqState.is5GRecommended) {
                    updateSCTags("lq check avail - captcha 5G success");
                    tempSCData.detailPageName = "lq address verification - 5G eligible - Redirecting to Wireless";
                    tempVzdlSCData.detail = "lq address verification - 5G eligible - Redirecting to Wireless";
                    updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                }
                else if (props.lqState.is4GRecommended) {
                    updateSCTags("lq check avail - captcha 4G success");
                    tempSCData.detailPageName = "lq address verification - lte eligible - Redirecting to Wireless";
                    tempVzdlSCData.detail = "lq address verification - lte eligible - Redirecting to Wireless";
                    updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                }
                props.dispatch({ type: CheckLQ.onStreetAddrSelected, value: { streetAddr: props.lqState.selectedAdr, isdisplayUnit: false } });
                tempVzdlSCData.events = "event137,event160";
                updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, props.appState.visitId, 'onValidateCaptcha', PAGEACTIVITY.MSG.CaptchaSuccess, PAGEACTIVITY.UA));
                setTimeout(() => doLQorRedirectTo5G(props.lqState, props.dispatch, props.appState.visitId, props.save.saveLqEmailInput, props.save.saveLqMtnInput, false, false, "", props.appState), 4000);
            }
            else {
                updateSCTags("lq check avail - captcha FIOS success");
                loaderActive({ isLoaderActive: false }, props.dispatch);
                changeTriggerLQ(props.dispatch, true);
            }
        }
        else {
            if (InHomeUtils.isNotNull(props.lqState) && InHomeUtils.isNotNull(props.lqState.selectedState)) {
                tempSCData.statePostLQA = props.lqState.selectedState.state;
                tempSCData.servicePostalCode = props.lqState.selectedState.zip;
            }
            tempSCData.detailPageName = props.lqState.is5GRecommended ? "lq address verification - captcha 5G failure" : "lq address verification - captcha FIOS failure";
            tempVzdlSCData.detail = props.lqState.is5GRecommended ? "lq address verification - captcha 5G failure" : "lq address verification - captcha FIOS failure";
            tempSCData.events = "event5,event8,event88";
            tempVzdlSCData.events = "event137,event160";
            updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
            updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, props.appState.visitId, 'onValidateCaptcha', PAGEACTIVITY.MSG.CaptchaFailure, PAGEACTIVITY.UA));
            (props.lqState.is5GRecommended) ? updateSCTags("lq check avail - captcha 5G failure") : updateSCTags("lq check avail - captcha FIOS failure");
            var host = window.location.host; //validatecaptcha wont give success response in non-prod hence making it success in failure case only in non-prod for testing
            if (props.lqState.isoneLQFlow) {
                if (host === "wwwawssit.ebiz.verizon.com" || host === "www98.verizon.com" || host === "orderinglite-gz-east.vpc.verizon.com" || host === "www.preprod.verizon.com" || host === "preprod-east-gz.vpc.verizon.com" || host === "wwwnte3aws.ebiz.verizon.com") {
                    props.dispatch({ type: CheckLQ.captchaChanged, value: 'COMPLETED' });
                    props.dispatch({ type: CheckLQ.onStreetAddrSelected, value: { streetAddr: props.lqState.selectedAdr, isdisplayUnit: false } });
                    doLQorRedirectTo5G(props.lqState, props.dispatch, props.appState.visitId, props.save.saveLqEmailInput, props.save.saveLqMtnInput, false, false, "", props.appState);
                }
                else {
                    loaderActive({ isLoaderActive: false }, props.dispatch);
                    redirectTo(Pages.Oof, props.dispatch);
                }
            }
            else {
                if (host === "wwwawssit.ebiz.verizon.com" || host === "orderinglite-gz-east.vpc.verizon.com" || host === "www.preprod.verizon.com" || host === "preprod-east-gz.vpc.verizon.com" || host === "wwwnte3aws.ebiz.verizon.com") {
                    props.dispatch({ type: CheckLQ.captchaChanged, value: 'COMPLETED' });
                    loaderActive({ isLoaderActive: false }, props.dispatch);
                    changeTriggerLQ(props.dispatch, true);
                    // redirectTo(Pages.CheckLQ, props.dispatch);
                }
            }
        }
    }).catch(error => {
        let errorMsg = `MethodName:onSubmitCaptcha,errorMessage:${error.message}`;
        logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", props.appState.visitId);
        vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
    });
}

export const updateBannerType = (status, dispatch) => {
    dispatch({ type: CheckLQ.updateBannerType, value: status })
};

export const setVendorRequest = (cookies, props, dispatch, visitId, visitorId, inputDetail, lqState, isTarget) => {
    try {
        let url = apiUrl().vendorFlow;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        api(url, 'POST', vendorRequest(inputDetail, visitId, visitorId)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({ type: 'VENDOR_RESPONSE', value: response.data });
                if (InHomeUtils.isNotNull(response.data) && response.data.isVendorFlowAllowed && response.data.visitid !== "" && response.data.visitorid !== "") {
                    let data = { visit_id: response.data.visitid, visitor_id: response.data.visitorid }
                    setVendorCookie(cookies, data, props);
                    if (!isTarget) {
                        getVendorDetails(dispatch, visitId, lqState);
                    }
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
                else {
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            }
            else {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:setVendorRequest,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'setVendorRequest', ex);
    }
};

const vendorRequest = (inputDetail, visitId, visitorId) => {
    let request = {
        leadListDetails: {
            visitId: visitId !== "" ? visitId : "",
            visitorId: visitorId !== "" ? visitorId : "",
            config: {
                storeId: InHomeUtils.isNotNull(inputDetail.storeid) ? inputDetail.storeid : "",
                doid: inputDetail.doid !== "" ? inputDetail.doid : "",
                location: "",
                lob: "",
                vendorId: "",
                locationId: "",
                sessionId: "",
                repInfo: {
                    repId: InHomeUtils.isNotNull(inputDetail.repid) ? inputDetail.repid : "",
                    userId: "",
                    firstName: "",
                    lastName: "",
                    repName: "",
                }
            }
        },
        vendorQueryDetails: {
            c: InHomeUtils.isNotNull(inputDetail.cVal) ? inputDetail.cVal : "",
            cmpId: InHomeUtils.isNotNull(inputDetail.cmp) ? inputDetail.cmp : "",
            abrVal: InHomeUtils.isNotNull(inputDetail.abrVal) ? inputDetail.abrVal : "",
            dig: inputDetail.dig ? inputDetail.dig.toUpperCase() : ""
        }
    }
    return JSON.stringify(request);
}

export const setParsedaddress = (dispatch, parsedResponse) => {
    let addressRequest = null;
    addressRequest = {
        addressID: parsedResponse.addressID,
        street: parsedResponse.street,
        unit: parsedResponse.unit || "",
        city: parsedResponse.city,
        state: parsedResponse.state,
        zip: parsedResponse.zipCode || parsedResponse.zip,
    }
    dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDSTATE', value: addressRequest });
    dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDADDRESS', value: addressRequest });
    if (parsedResponse.unit !== undefined && parsedResponse.unit !== "") {
        dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDUNIT', value: addressRequest });
    }
}
export const update5GResponse = (dispatch, value) => {
    dispatch({ type: 'CHECKFOR5G_RES', value });
}

export const checkfor5G = (dispatch, visitId, lqState, input, appState) => {
    try {
        let url = apiUrl().qualification5G; //addressLine1=10 S BRADLEY AVE&city=INDIANAPOLIS&state=IN&zipCode=46201
        let qparam = "", adrentered = "";
        let emailInput = "", mtnInput = "";
        if (input && input.dispstr && input.muni && input.state && input.zip) {
            updateLQZip(input.zip);
            qparam = "?addressLine1=" + input.dispstr + "&city=" + input.muni + "&state=" + input.state + "&zipCode=" + input.zip + "&isMnFlow=Y";
            url = encodeURI(url + qparam);
            adrentered = input.dispstr + " " + input.muni + " " + input.state + " " + input.zip;
            dispatch({ type: CheckLQ.adrEntered, value: adrentered })
        }

        if (qparam !== "") {
            api(url, 'GET', '').then(response => {
                // response.data.qualified = 'Success'; 
                //response.data.encryptedAddress = 'N0UG8nQM52pJKB3QNrbF5ELSQgyqq3wyKPOuY0ef6ExwaqYwQCTYR66x72tYY/XV+tyg8u+SZ4naFJTXZGxpr7yvv+M5y7BNL/DntkYR+8ndngSF5UHTOvs+ntGfYhigTQX0rr8IDayP8n/Yq2Rnfw==';
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    if (InHomeUtils.isNotNull(response.data) && (response.data.qualified === "Success" || response.data.qualified4gHome || response.data.qualifiedCBand)) {
                        if (lqState.captchaState === '' || lqState.showCaptchaFromVisitId) {
                            updateSCTags("lq check avail - captcha 5G shown");
                            if (response.data.qualified4gHome) {
                                tempSCData.detailPageName = "lq address verification";
                                tempVzdlSCData.detail = "lq address verification";
                            }
                            else {
                                tempSCData.detailPageName = "lq address verification";
                                tempVzdlSCData.detail = "lq address verification";
                            }
                            tempSCData.events = "event5,event8,event88";
                            tempVzdlSCData.events = "event137,event160";
                            updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                            updateVzdlSCCustomEvent("checkAvaillqInit", "pageViewOmni", "detail,events");
                            if (response.data.qualified4gHome) {
                                update4GRecommended(dispatch, true);
                            }
                            else {
                                update5GRecommended(dispatch, true);
                            }
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkfor5G', PAGEACTIVITY.MSG.CaptchaShown, PAGEACTIVITY.UA));
                            update5GResponse(dispatch, response.data);
                            //updateCaptcha(dispatch, 'INITIATED');
                            redirectTo(Pages.nonfiosRedirect, dispatch);
                        }
                    }
                    else if (InHomeUtils.isNotNull(response.data) && response.data.qualified4gHome) {
                        if (lqState.captchaState === '' || lqState.showCaptchaFromVisitId) {  // && lqState.isCaptchaTest                      
                            update4GRecommended(dispatch, true);
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkfor4G', PAGEACTIVITY.MSG.CaptchaShown, PAGEACTIVITY.UA));
                            updateSCTags("lq check avail - captcha 4G shown");
                            update5GResponse(dispatch, response.data);
                            redirectTo(Pages.nonfiosRedirect, dispatch);
                        }
                    } else if (lqState && lqState.runtimeKey && lqState.runtimeKey.fiosStates && InHomeUtils.isNotNull(input.state) && lqState.runtimeKey.fiosStates.includes(input.state)) {
                        checkAddr(lqState, dispatch, visitId, emailInput, mtnInput, false, false, "", appState, "", input); //Do auto LQ on success
                    } else {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkfor5G', PAGEACTIVITY.MSG.AddressNotFound, PAGEACTIVITY.UA));
                        dispatch({ type: "STREET_NOT_FOUND", value: null });

                        if (input.propertyType == "B") {
                            dispatch({ type: "VCG_OOF_SHOW_VBG_MSG", value: true });
                            dispatch({ type: "INPUT_ADDRESS", value: input })
                        }

                        lqState.isoneLQFlow && dispatch({ type: "ZIP_NOT_FOUND", value: null });
                        if (lqState.selectedState && lqState.selectedState.state && lqState.selectedState.zip) {
                            tempSCData.statePostLQA = lqState.selectedState.state
                            tempSCData.servicePostalCode = lqState.selectedState.zip
                        }
                        tempSCData.detailPageName = "street address oof";
                        tempVzdlSCData.detail = "street address oof";
                        updateSCcustomEvent("outOfFranchise", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                        updateVzdlSCCustomEvent("outOfFranchise", "pageViewOmni", "detail");
                    }
                }
                else {
                    if (lqState.captchaState === '') {
                        update5GRecommended(dispatch, true);
                        updateCaptcha(dispatch, 'INITIATED');
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkfor5G', PAGEACTIVITY.MSG.CaptchaShown, PAGEACTIVITY.UA));
                        updateSCTags("lq check avail - captcha 5G shown");
                    }

                    // dispatch({ type: "STREET_NOT_FOUND", value: null });
                    // if(input.propertyType == "B"){
                    //     dispatch({ type: "VCG_OOF_SHOW_VBG_MSG", value: true });
                    //     dispatch({ type: "INPUT_ADDRESS", value: input })
                    // }
                }
                loaderActive({ isLoaderActive: false }, dispatch);
            })
        }
        else {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkfor5G', PAGEACTIVITY.MSG.AddressNotFound, PAGEACTIVITY.UA));
            dispatch({ type: "STREET_NOT_FOUND", value: null });
            loaderActive({ isLoaderActive: false }, dispatch);
            lqState.isoneLQFlow && dispatch({ type: "ZIP_NOT_FOUND", value: null });
            if (lqState.selectedState && lqState.selectedState.state && lqState.selectedState.zip) {
                tempSCData.statePostLQA = lqState.selectedState.state
                tempSCData.servicePostalCode = lqState.selectedState.zip
            }
            tempSCData.detailPageName = "street address oof";
            tempVzdlSCData.detail = "street address oof";
            updateSCcustomEvent("outOfFranchise", "ddCheckAvailabilityPageViewEvent", "detailPageName");
            updateVzdlSCCustomEvent("outOfFranchise", "pageViewOmni", "detail");
            if (input.propertyType == "B") {
                dispatch({ type: "VCG_OOF_SHOW_VBG_MSG", value: true });
                dispatch({ type: "INPUT_ADDRESS", value: input })
            }
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'checkfor5G', ex);
        loaderActive({ isLoaderActive: false }, dispatch);
    }
}

export const doLQorRedirectTo5G = (lqState, dispatch, visitId, emailInput, mtnInput, isLqRetry = false, isLqRetryDataNull = false, appState) => {
    try {
        if ((InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.lqResponse) && InHomeUtils.isNotEmpty(lqState.lqResponse.encryptedAddressFor5G)) ||
            (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.checkfor5gresponse) && InHomeUtils.isNotEmpty(lqState.checkfor5gresponse.encryptedAddress))) {

            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, '5G', PAGEACTIVITY.MSG.FIVEG, PAGEACTIVITY.UA));
            // let addressString = lqState.lqResponse.encryptedAddressFor5G ? lqState.lqResponse.encryptedAddressFor5G :
            //     lqState.checkfor5gresponse.encryptedAddress ? lqState.checkfor5gresponse.encryptedAddress : "";
            // if(lqState.checkfor5gresponse.qualified === "Success"){
            //    window.location.href = apiUrl().Wireless5Gurl
            //    redirectTo(Pages.nonfiosRedirect,dispatch);
            // }
            // else if(lqState.checkfor5gresponse.qualified4gHome){
            //   window.location.href = apiUrl().Lte4Gurl
            //    redirectTo(Pages.nonfiosRedirect,dispatch);
            // }
            return;
        }
        else {
            checkAddr(lqState, dispatch, visitId, emailInput, mtnInput, false, false, "", appState); //Do auto LQ on success            
            //loaderActive({ isLoaderActive: false }, props.dispatch); 
        }

    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'redirectTo5G', ex);
        loaderActive({ isLoaderActive: false }, dispatch);
    }
}

export const updateVZWResponse = (dispatch, value) => {
    dispatch({ type: 'VZWOFFER_DETAILS', value });
}
export const restoreDefaultState = (dispatch) => {
    emptyBuildProductState(dispatch);
    emptyCartState(dispatch);
    emptyCheckoutState(dispatch);
}
export const checkPDCForFCC = async (visitId,visitorId,dispatch) => {
    try {
        let url = apiUrl().checkPDCdata;
        let request = {
            'visitorid': visitorId ? visitorId : ""
        }
        return api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.vzpers)) {
                let vzpers = JSON.parse(response.data.vzpers);
            dispatch({ type: 'CHECKPDC_FCCLEARN', value: vzpers});
            }

        }).catch(error => {
            let errorMsg = `MethodName:checkPDCForFCC,errorMessage:${error.message}`;
            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            return false;
        });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'CHECKPDC_FCCLEARN', ex);
        return false;
    }
}
export const checkPDCForDOFlow = async (visitId, visitorId, dispatch, quickCheckoutQS, isLQ20Flow, lqState = null) => {
    try {
        let url = apiUrl().checkPDCdata;
        let request = {
            'visitorid': visitorId ? visitorId : ""
        }
        return api(url, 'POST', JSON.stringify(request)).then(response => {           
            let ismnhFlow = false;
            console.log('checkpdc response', response);
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkPDC', response, PAGEACTIVITY.UA));
            if (isLQ20Flow && (lqState && lqState.selectedAdr && (InHomeUtils.isNotEmpty(lqState.selectedAdr.addressID) || InHomeUtils.isNotEmpty(lqState.selectedAdr.ntasAddrID)))) {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.vzpers)) {
                    let vzpers = JSON.parse(response.data.vzpers);
                    if ((vzpers.addressId !== lqState.selectedAdr.addressID) || (InHomeUtils.isNotEmpty(lqState.selectedAdr.ntasAddrID) && vzpers.addressId !== lqState.selectedAdr.ntasAddrID) ) {//revisit with diff address
                        restoreDefaultState(dispatch);
                        resetLqData(dispatch)
                    }
                }
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                if (InHomeUtils.isNotNull(response.data) && response.data.isDirectOrderingFlow) {
                    updateDOFlowDetails('FCP', dispatch);
                }
                //F&F change to read the FFCouponInfo info from PDC
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.ffcouponInfo.ffcoupon) && InHomeUtils.isNotNull(response.data.ffcouponInfo.leadListId) && InHomeUtils.isNotEmpty(response.data.ffcouponInfo.ffcoupon) && InHomeUtils.isNotEmpty(response.data.ffcouponInfo.leadListId)) {
                    let mlpFFCouponInfo = {
                        ffCoupon: response.data.ffcouponInfo.ffcoupon,
                        leadListID: response.data.ffcouponInfo.leadListId,
                        isMLPPromoRefreshRequired: true
                    }
                    dispatch({ type: 'MLPFFCOUPONINFO', value: mlpFFCouponInfo });
                }
                if (response.data && ((response.data.vzosel && response.data.vzosel.mnh && response.data.vzosel.mnh.toLowerCase() === 'y') || isLQ20Flow)) {
                    ismnhFlow = response.data.vzosel && response.data.vzosel.mnh && response.data.vzosel.mnh.toLowerCase() === 'y';
                    processPDCForMNH(visitId, dispatch, response.data, ismnhFlow, isLQ20Flow)
                }
                if (InHomeUtils.isNotNull(quickCheckoutQS) && quickCheckoutQS === "y" && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotEmpty(response.data.quickCheckout) && response.data.quickCheckout === "Y" && !ismnhFlow) {
                    quickCheckout(dispatch, true)
                    setCartDirtyFlag(true, dispatch)
                    updateCheckoutBtnStatus(true, dispatch)
                }
                else {
                    quickCheckout(dispatch, false)
                }
                // PRODDEF-26499 :: Manoj : Parsing when data is coming as stringified object and has customerToken
                if (response?.data?.vzapps && typeof response.data.vzapps === 'string' && (response.data.vzapps.indexOf("customerToken") > -1 || response.data.vzapps.indexOf("flowType") > -1)) {
                    response.data.vzapps = JSON.parse(response.data.vzapps);
                }
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.vzapps) && response.data?.vzapps?.customerToken && response.data?.vzapps?.flowType){                    
                    dispatch({ type: CheckLQ.updateToken, value: response.data.vzapps.customerToken })
                    dispatch({ type: CheckLQ.updateCouponFlowType, value: response.data.vzapps.flowType });
                } 
                return ismnhFlow;
            }
        }).catch(error => {
            let errorMsg = `MethodName:checkPDCForDOFlow,errorMessage:${error.message}`;
            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            //vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            return false;
        });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'checkPDCForDOFlow', ex);
        return false;
    }
}

export const processPDCForMNH = (visitId, dispatch, data, ismnhFlow, isLQ20Flow) => {
    if (data) {
        if (data.vzpers) {
            let vzpers = JSON.parse(data.vzpers);
            if (vzpers.addressId) {
                if (ismnhFlow) {
                    dispatch({ type: CheckLQ.MNHFlow, value: true });
                    dispatch({ type: CheckLQ.MNHPDCData, value: data });
                }
                let addressRequest = {
                    addressID: vzpers.addressId,
                    baseAddID: vzpers.addressId,
                    street: vzpers.adr1,
                    unit: "",
                    city: vzpers.city,
                    state: vzpers.state,
                    zip: vzpers.zip,
                }
                dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDSTATE', value: addressRequest });
                dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDADDRESS', value: addressRequest });
                if (vzpers.emailLq) {
                    dispatch({ type: Save.saveLqEmailInput, value: vzpers.emailLq });
                    dispatch({ type: Save.saveModalInput, value: vzpers.emailLq });
                }
                if (vzpers.mobileNumLq) {
                    dispatch({ type: Save.saveLqMtnInput, value: vzpers.mobileNumLq });
                    if (isLQ20Flow) {
                        let phoneNo = vzpers.mobileNumLq.slice(0, 3) + "." + vzpers.mobileNumLq.slice(3, 6) + "." + vzpers.mobileNumLq.slice(6, 10);
                        dispatch({ type: 'UPDATE_PH1', value: phoneNo });
                    }
                }
                if (vzpers.ipisin) {
                    dispatch({ type: CheckLQ.MNHGigQualified, value: vzpers.ipisin.toLowerCase() === 'y' });
                }
            }
        }
    }
}

export const setMNHChangeFlow = (dispatch, value) => {
    dispatch({ type: CheckLQ.MNHChangeAdrFlow, value: value });
}

export const setMNHQueryString = (dispatch, value) => {
    dispatch({ type: CheckLQ.MNHQueryString, value: value });
}

export const showMNHCartOnCheckOut = (dispatch, value) => {
    dispatch({ type: CheckLQ.MNHSHOWCARTONCHECKOUT, value: value });
}

export const isMNHCreditCompleted = (dispatch, value) => {
    dispatch({ type: CheckLQ.MNHCREDITCOMPLETED, value: value });
}
export const moversInvoked = (dispatch, value) => {
    dispatch({ type: 'UPDATE_MOVERSINVOKED', value: value });
}
export const updateCRMMRefreshMover = (visitId, dispatch) => {
    return new Promise((resolve, reject) => {
        try {
            let url = apiUrl().refreshPromotionsUrl
            api(url, 'POST', getMfrtCRMMRefreshRequestMover()).then(response => {
                console.log("crmm refreshpromo response received");
                if (InHomeUtils.isNotNull(response)) {
                    resolve(response);
                    moversInvoked(dispatch, true);
                }
                else {
                    reject(response);
                }
                emptyCartState(dispatch);
                emptyBuildProductState(dispatch);
                clearCart(visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                redirectTo(Pages.BuildProduct, dispatch);
            }).catch(error => {
                let errorMsg = `MethodName:updateCRMMRefreshMover,errorMessage:${error.message}`;
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                logKafka("ERROR", "LoopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                reject(error);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                redirectTo(Pages.BuildProduct, dispatch);
            });
        }
        catch (ex) {
            catchJSException('LoopQual', visitId, 'updateCRMMRefreshMover', ex);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            reject(ex);
            redirectTo(Pages.BuildProduct, dispatch);
        }
    });
}
const getMfrtCRMMRefreshRequestMover = () => {
    let request = {
        "isMovers": "Y",
        "code": "",
        "expirationDate": "",
        "leadListId": "",
        "type": "",
        "isMfrt": ""
    }
    return JSON.stringify(request);
}
const getMfrtCRMMRefreshRequest = (code, type) => {
    let request = {
        "code": code,
        "expirationDate": '',
        "leadListId": '',
        "type": '',
        "isMfrt": type
    }
    return JSON.stringify(request);
}

export const updateCRMMRefresh = (visitId, dispatch, code, type, flowType) => {

    return new Promise((resolve, reject) => {
        try {
            let url = "";
            if (flowType === 'AF')
                url = apiUrl().refreshPromotionsECUrl
            else
                url = apiUrl().refreshPromotionsUrl
            console.log("before crmm refreshpromo call");
            let SweetnerMessageMFRT = {
                currentMsg: '',
                isDisplay: true,
                bgColor: '',
                discountEligible: false
            };

            api(url, 'POST', getMfrtCRMMRefreshRequest(code, type)).then(response => {
                console.log("crmm refreshpromo response received");
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.service) && response.service.length > 0 && InHomeUtils.isNotNull(response.isUnIdPresent) && response.isUnIdPresent === "N") {
                    resolve(response);
                }
                else {
                    reject(response);
                    SweetnerMessageMFRT.currentMsg = "We are unable to recognize your discount eligibility and you will not be eligible for the Fios Home Internet Discount offer.  You can continue to make changes to your order below.";
                    SweetnerMessageMFRT.discountEligible = false;
                    SweetnerMsgMFRT(SweetnerMessageMFRT, dispatch);
                }
            }).catch(error => {
                let errorMsg = `MethodName:updateCRMMRefresh,errorMessage:${error.message}`;
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, error.message);
                logKafka("ERROR", "BuildProduct", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                reject(error);
            });
        }
        catch (ex) {
            catchJSException('BuildProduct', visitId, 'updateCRMMRefresh', ex);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            reject(ex);
        }
    });
}

const getCRMMRefereshRequest = (coupon, leadListId) => {
    let request = {
        "code": coupon,
        "expirationDate": '',
        "leadListId": leadListId,
        "type": ''
    }
    return JSON.stringify(request);
}

export const getFFCouponInfo = (visitId, visitorId, dispatch) => {
    try {
        let url = apiUrl().checkPDCdata;
        let request = {
            'visitorid': visitorId
        }

        api(url, 'POST', JSON.stringify(request)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.ffcouponInfo.ffcoupon) && InHomeUtils.isNotNull(response.data.ffcouponInfo.leadListId) && InHomeUtils.isNotEmpty(response.data.ffcouponInfo.ffcoupon) && InHomeUtils.isNotEmpty(response.data.ffcouponInfo.leadListId)) {
                    let mlpFFCouponInfo = {
                        ffCoupon: response.data.ffcouponInfo.ffcoupon,
                        leadListID: response.data.ffcouponInfo.leadListId,
                        isMLPPromoRefreshRequired: true
                    }
                    dispatch({ type: 'MLPFFCOUPONINFO', value: mlpFFCouponInfo });
                }
            }
        }).catch(error => {
            let errorMsg = `MethodName:getFFCouponInfo,errorMessage:${error.message}`;
            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
        });

    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getFFCouponInfo', ex);
    }
}

export const fetchEmergencyNotificationStatesConfig = async (dispatch) => {
    try {
        let url = apiUrl().emergencyNotificationStatesConfigUrl;
        return api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && response !== "") {
                dispatch({ type: 'FETCH_EMERGENCY_NOTIFICATION_STATES_CONFIG', value: response });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:fetchEmergencyNotificationStatesConfig,errorMessage:${error.message}`;
                logKafka("ERROR", "LoopQual", errorMsg, getErrorLogUrl, "applogs", "");
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            });
    }

    catch (ex) {
        catchJSException('LoopQual', "", 'fetchEmergencyNotificationStatesConfig', ex);
    }
};

export const SweetnerMsgMFRT = (Msg, dispatch) => {
    dispatch({ type: CheckLQ.sweetnerMsgMFRT, value: Msg });
}

export const DtmTransactionsMFRT = (Msg, dispatch) => {
    dispatch({ type: CheckLQ.dtmTransactionsMFRT, value: Msg });
}

export const MFRTEligible = (status, dispatch) => {
    dispatch({ type: CheckLQ.MFRTEligible, value: status });
}
export const TWSLq2 = (status, dispatch) => {
    dispatch({ type: CheckLQ.TWSLQ2, value: status });
}
export const MFRTVerified = (status, dispatch) => {
    dispatch({ type: CheckLQ.MFRTVerified, value: status });
}
export const mfrtInitialLoad = (status, dispatch) => {
    dispatch({ type: CheckLQ.mfrtInitialLoad, value: status });
}

export const MFRTCompleted = (status, dispatch) => {
    dispatch({ type: CheckLQ.MFRTCompleted, value: status });
}

export const MFRTMovesFlow = (status, dispatch) => {
    dispatch({ type: CheckLQ.MFRTMovesFlow, value: status });
}
export const MFRTDiscountEligible = (status, dispatch) => {
    dispatch({ type: CheckLQ.MFRTDiscountEligible, value: status });
}
export const MFRTProfileDiscountEligible = (status, dispatch) => {
    dispatch({ type: CheckLQ.MFRTProfileDiscountEligible, value: status });
}
export const ValidateApiCount = (status, dispatch) => {
    dispatch({ type: CheckLQ.ValidateApiCount, value: status});
}
export const ResetApiCount = (dispatch) => {
    dispatch({ type: CheckLQ.ResetApiCount, value: 1});
}
export const skipfornowMH = (status, dispatch, lqstate) => {
    dispatch({ type: CheckLQ.skipfornowMH, value: status});
}
export const signinMHSuccess = (status, dispatch, lqstate) => {
    dispatch({ type: CheckLQ.signinMHSuccess, value: status});
}
export const MFRTMovesEligibleCheck = (visitId, dispatch, accesscode) => {
    try {
        let url = apiUrl().mfrtnmoveEligibleCheck;

        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && accesscode != "") {
                if (InHomeUtils.isNotNull(response.data) &&
                    InHomeUtils.isNotNull(response.meta.code === 200.02)) {
                    let verified = false;
                    if (response.data.status == "true") {
                        verified = true
                        dispatch({ type: CheckLQ.MFRTEligible, value: verified });
                        dispatch({ type: CheckLQ.MFRTDiscountEligible, value: verified });
                    }
                    else {
                        dispatch({ type: CheckLQ.MFRTEligible, value: verified });
                        dispatch({ type: CheckLQ.MFRTDiscountEligible, value: verified });
                    }
                }

                // if(InHomeUtils.isNull(response.data)){
                //     dispatch({type: CheckLQ.MFRTEligible,value:true}); 
                //     // dispatch({type: CheckLQ.MFRTDiscountEligible,value:false}); 
                //     MFRTDiscountEligible()
                // }
                MFRTMovesFlow(true, dispatch);
            }
        }).catch(error => {
            let errorMsg = `MethodName:MFRTMovesEligibleCheck,errorMessage:${error.message}`;
            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            MFRTMovesFlow(true, dispatch);
            vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
        });

    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'MFRTMovesEligibleCheck', ex);
        MFRTMovesFlow(true, dispatch);
    }
}

export const callValidateAPI = () => {
    try {
      const url = apiUrl().ssoMHAuthiniticate;
      let data = JSON.stringify({skip: 'Y'})
      api(url, 'POST', data).then(async response => {
      //callingApi(url, MethodType.POST, data, contentType, requiredAuth).then(() => {
      }).catch((error) => {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ,'','callValidateAPI_Failure', PAGEACTIVITY.MSG.callValidateAPIFailure, PAGEACTIVITY.UA));
        const errorMsg = `MethodName:callValidateAPI,errorMessage:${error.message}`;
        logKafka('ERROR', 'callValidateAPI_Failure', errorMsg, getErrorLogUrl, 'applogs');
      });
    } catch (error) {
      catchJSException('LOOPQUAL2.0', 'callValidateAPI', error);
    }
  };

export const callGetNameMnhDetails = (dispatch) => {
  try {
    const url = apiUrl().ssoMHGetName;
    api(url, 'GET', '').then(async response => {
    if(response && response.data && response.data.firstName ){
      let input = response.data.firstName;
      let final = input.charAt(0) + input.toLowerCase().substring(1);
      dispatch({
          type: 'UPDATEMNHDETAILS',
          value: final
      });
    }
    }).catch((error) => {
      logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ,'','callGetNameMnhDetails_Failure', PAGEACTIVITY.MSG.callValidateAPIFailure, PAGEACTIVITY.UA));
      const errorMsg = `MethodName:callGetNameMnhDetails,errorMessage:${error.message}`;
      logKafka('ERROR', 'callGetNameMnhDetails_Failure', errorMsg, getErrorLogUrl, 'applogs');
    });
  } catch (error) {
    catchJSException('LOOPQUAL2.0', 'callGetNameMnhDetails', error);
  }
};

export const signinMH = (visitId, dispatch, userId, pwd,) => {
    try {
        let url = apiUrl().ssoMHAuthiniticate;
        let jsonstr = JSON.stringify({username: userId, password: pwd})
		api(url, 'POST', jsonstr).then(response => {
		if (response && response.data && response.data.data.isAuthenticated === 'Y') {
            if( lqState.lqResponse.inService === "Y") {
                dispatch({ type: CheckLQ.signinMHSuccess, value: true });
				redirectTo(Pages.CheckLQ, dispatch)
				}
		} else {
            dispatch({ type: CheckLQ.errorSigninMH, value: true });
          }
		}).catch(error => {
            dispatch({ type: CheckLQ.errorSigninMH, value: true });
            let errorMsg = `MethodName:ssoMHAuthiniticate,errorMessage:${error.message}`;
            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
        });
    }
    catch (ex) {
        dispatch({ type: CheckLQ.errorSigninMH, value: true });
        catchJSException('loopQual', visitId, 'SigninMH', ex);
    }
}

const storeRuntimeKeys = async(runtimeKeysToStore, dispatch) => {
    let orderedKeys = null;
    if (typeof runtimeKeysToStore === 'object' && Object.keys(runtimeKeysToStore).length) {
        orderedKeys = Object.keys(runtimeKeysToStore).sort().reduce(
            (obj, key) => {
                obj[key] = runtimeKeysToStore[key];
                return obj;
            },
            {}
        );
    }
    //From LQState -- lqState.runtimeKey we can refer the respective runtimeKey whereever required
    dispatch({ type: 'RUNTIME_KEY', value: orderedKeys });
}

export const fetchCombinedData = async(dispatch, runtimeKeys, shouldFetchRuntimeKeys, commonLQ="N") => { 
    let url = '/inhome/fetchcombineddata';
    try {
        const request = JSON.stringify({
            commonLQ: commonLQ,
            shouldFetchRuntimeKeys: shouldFetchRuntimeKeys,
            visitId: window.localStorage.getItem("visit_id")? window.localStorage.getItem("visit_id"):'',
            visitorId: window.localStorage.getItem("visitor_id")? window.localStorage.getItem("visitor_id"):''
        });
        if(!shouldFetchRuntimeKeys) storeRuntimeKeys(runtimeKeys, dispatch)
        return new Promise((resolve, reject) => {
            api(url, 'POST', request).then(async response => {
                const runtimeKeysToStore = (shouldFetchRuntimeKeys && InHomeUtils.isNotNull(response.runtimeKeys) && response.runtimeKeys !== "") ? response.runtimeKeys: null;
                if(InHomeUtils.isNotNull(runtimeKeysToStore)) {
                    storeRuntimeKeys(runtimeKeysToStore, dispatch)
                } 
                resolve(response);
            })
            .catch(error => {
                let errorMsg = `MethodName:fetchCombined,errorMessage:${error.message}`;
                logKafka("ERROR", "LoopQual", errorMsg, getErrorLogUrl, "applogs", "");
                vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
            });
      });
    } catch(error) {
      console.log(error)
    }
  }